<template>
    <div class="cart_full_width">

        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>

        <section class="cart_page pt-0 card-page-mobile cart_page_vtwo cart_page_vthree">
            <div class="container-fluid">
                <div class="cart_head">
                    <div class="left_block">
                        <h2 class="heading2 d-md-flex align-items-center">
                            Shopping Cart
                        </h2>
                    </div>
                    <div class="right_block">
                        <button 
                            v-if="cart_items.length > 0"
                            class="kitting-btn d-none"
                            @click="openShippingPreferencesModal"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14"
                                viewBox="0 0 13 14" fill="none" class="__web-inspector-hide-shortcut__">
                                <path
                                    d="M12.48 3.13317L6.98 0.123791C6.83305 0.0425919 6.66789 0 6.5 0C6.33211 0 6.16695 0.0425919 6.02 0.123791L0.52 3.13442C0.36293 3.22036 0.231815 3.34689 0.140345 3.50081C0.0488751 3.65472 0.000406411 3.83037 0 4.00942V9.98692C0.000406411 10.166 0.0488751 10.3416 0.140345 10.4955C0.231815 10.6494 0.36293 10.776 0.52 10.8619L6.02 13.8725C6.16695 13.9537 6.33211 13.9963 6.5 13.9963C6.66789 13.9963 6.83305 13.9537 6.98 13.8725L12.48 10.8619C12.6371 10.776 12.7682 10.6494 12.8597 10.4955C12.9511 10.3416 12.9996 10.166 13 9.98692V4.01004C12.9999 3.83068 12.9516 3.65464 12.8601 3.50036C12.7686 3.34609 12.6373 3.21926 12.48 3.13317ZM6.5 0.998791L11.5212 3.74879L9.66063 4.76754L4.63875 2.01754L6.5 0.998791ZM6.5 6.49879L1.47875 3.74879L3.5975 2.58879L8.61875 5.33879L6.5 6.49879ZM1 4.62379L6 7.36004V12.7219L1 9.98754V4.62379ZM12 9.98504L7 12.7219V7.36254L9 6.26817V8.49879C9 8.6314 9.05268 8.75858 9.14645 8.85234C9.24021 8.94611 9.36739 8.99879 9.5 8.99879C9.63261 8.99879 9.75979 8.94611 9.85355 8.85234C9.94732 8.75858 10 8.6314 10 8.49879V5.72067L12 4.62379V9.98442V9.98504Z"
                                    fill="#1D6CB5" />
                            </svg>Kitting or Handling Request?
                        </button>
                        <a @click="emptyAllCartItems" v-show="cart_items.length" class="ml-auto font_size_16"
                            v-tooltip="'Empty cart!'">
                            <!-- <img src="/maincss/images/delete.svg" alt=" " class="mr_8" /> -->
                            <svg class="mr_8" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.5 4.98356C14.725 4.70856 11.9333 4.56689 9.15 4.56689C7.5 4.56689 5.85 4.65023 4.2 4.81689L2.5 4.98356"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M7.08301 4.1415L7.26634 3.04984C7.39967 2.25817 7.49967 1.6665 8.90801 1.6665H11.0913C12.4997 1.6665 12.608 2.2915 12.733 3.05817L12.9163 4.1415"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M15.7087 7.6167L15.167 16.0084C15.0753 17.3167 15.0003 18.3334 12.6753 18.3334H7.32533C5.00033 18.3334 4.92533 17.3167 4.83366 16.0084L4.29199 7.6167"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M8.6084 13.75H11.3834" stroke="#606060" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.91699 10.4165H12.0837" stroke="#606060" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span class="emt_align1">Empty Cart</span>
                        </a>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="cart_table table-responsive cart_table_custom_class" :class="{
                            empty_cart_item: cart_items.length == 0,
                            cart_tbl_mobile: isMobile()
                        }">
                            <div class="cart_table_custom_overflow">
                                <table class="table cart_table">
                                    <!-- <thead class="table_header">
                                        <tr class="header_row">
                                            <th class="artwork">
                                                <span class="d-flex"
                                                    v-tooltip="'One time setup-fee will apply for same artwork'">
                                                    Artwork
                                                    <img class="ml-1" src="/maincss/images/information.svg" />
                                                </span>
                                            </th>

                                            <th scope="col">Item</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Color</th>
                                            <th scope="col" class="quantity">Quantity</th>
                                            <th scope="col" class="cost">Cost</th>
                                            <th scope="col" class="blank_last">&nbsp;</th>
                                        </tr>
                                    </thead> -->

                                    <tbody>
                                        <tr v-if="cart_items.length == 0">
                                            <td colspan="8" class="text-center padding-mobile">
                                                No item added yet.
                                            </td>
                                        </tr>
                                        <tr v-for="(item, key) in cart_items" :key="key">
                                            <td colspan="9" class="main_data">
                                                <div class="main_data_inner">
 <table>
                                                    <thead class="outer_head">
                                                        <tr v-if="isAssemblyGroup(item)" class="assembly_group_header_row">
                                                            <td colspan="9" class="assembly_group_header_cell">
                                                                <div class="assembly_header_inner">
                                                                         {{ getAssemblyProductCount(item) }} Products With Matching Artwork
                                                                </div>
                                                               
                                                            </td>
                                                        </tr>
                                                        <tr class="header_row">
                                                            <td class="item-image">
                                                                <div class="cart_image d-flex">
                                                                    <DisplayProductImage
                                                                        :whateverActivatesThisLink="false"
                                                                        :product="item.main_new_product"
                                                                        :designImage="item.design_image"
                                                                        :colorProductImage="item.main_new_product_image"
                                                                        :color="item.color_id"
                                                                        :classValue="'m-auto1'" />
                                                                    <a href="#" class="hover_search" data-toggle="modal"
                                                                        :data-target="'#imagepreview-' + item.id">
                                                                        <img src="/maincss/images/zoom.svg" alt=" " />
                                                                    </a>

                                                                </div>
                                                                <button
                                                                    class="cart-preview-artworks-btn"
                                                                    data-toggle="modal"
                                                                    :data-target="'#imagepreview-' + item.id"
                                                                >
                                                                    Preview Artworks
                                                                </button>
                                                                <ul v-if="item.decoration_colors"
                                                                    class="standard_colors">
                                                                    <li v-for="(color, index) in item.decoration_colors"
                                                                        :style="'background-color:' + color.hex + ';'"
                                                                        :key="index" v-tooltip="{
                                                                            'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                                                                            'html': true
                                                                        }">
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td class="title_mobile">
                                                                <span class="cart_icon_image">
                                                                    Item code : <span>{{
                                                                        item.main_new_product.product_number }}</span>
                                                                    <a v-if="hasNameNumberData(item.name_and_number_json)"
                                                                        :id="'nameNumbers' + item.color_id"
                                                                        @click="openNameNumbersModal(item)"
                                                                        href="javascript:void(0);"
                                                                        class="d-flex align-items-center"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/maincss/images/path.png"
                                                                            class="ml_6 path cart_icon" />
                                                                    </a>
                                                                </span>
                                                                <small v-if="item.OrderBuild">{{ item.OrderBuild.name
                                                                }}</small>
                                                                <router-link v-if="isTShirt24HourItem(item)"
                                                                    :to="{ path: '/24hourtshirts/' + item.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ item.main_new_product.name | capitalize
                                                                            }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            getTotalItemQuantity(item)
                                                                        }})</span></p>
                                                                    </div>
                                                                </router-link>
                                                                <router-link v-else
                                                                    :to="{ path: '/product-details-new/' + item.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ item.main_new_product.name | capitalize
                                                                            }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            getTotalItemQuantity(item)
                                                                        }})</span></p>
                                                                    </div>

                                                                </router-link>
                                                                <div class="size_mobile quantity_custom_div">
                                                                    <div class="d-flex flex-wrap inner_size_table">
                                                                        <div class="product_count"
                                                                            v-for="(sizeItem, sizeIndex) in getSortedCartSizeItems(item)"
                                                                            :key="sizeIndex">
                                                                            <div class="count_item_heading">
                                                                                <h6 class="m-0">{{
                                                                                    sizeItem.main_new_sub_product.Size.size
                                                                                }}</h6>
                                                                            </div>
                                                                            <div class="count_item_price">
                                                                                <!-- Commented out + - buttons for size -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-minus"
                                                                                    @click="decrementQuantity($event, item, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                                <!-- Replaced qty-display with input field -->
                                                                                <input 
                                                                                    type="number" 
                                                                                    class="qty-display qty-input"
                                                                                    :value="getDisplayQuantity(sizeItem)"
                                                                                    @input="onSizeInputChange($event, item, sizeItem)"
                                                                                    @blur="onSizeInputBlur($event, item, sizeItem)"
                                                                                    :disabled="isBusy"
                                                                                    min="0"
                                                                                    style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd; border-radius: 4px;"
                                                                                />
                                                                                <!-- <div class="qty-display">{{
                                                                                    getDisplayQuantity(sizeItem) }}
                                                                                </div> -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-plus"
                                                                                    @click="incrementQuantity($event, item, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M8 3.5V12.5M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <!-- Commented out Update button - auto-update with debounce now -->
                                                                    <!-- <a v-if="item.show_update_button"
                                                                        href="javascript:void(0);"
                                                                        @click="updateCartItem(item)"
                                                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header mt_10">
                                                                        Update
                                                                    </a> -->
                                                                </div>
                                                                <div class=" color_block"
                                                                    v-html="productColors(item.Color)"></div>
                                                                    <div class="hours_info_block">
                                                                   <div>
                                                                    <small
                                                                    v-if="item.decoration && item.decoration.master_service && item.decoration.master_service.id">
                                                                    {{ getCartDecorationServiceEcommDisplayName(item) }}
                                                                </small>
                                                                <small v-else>{{ decoration_types[item.decoration_type]
                                                                }}
                                                                </small>
                                                                

                                                                    <small v-if="isTShirt24HourItem(item)">24 hours
                                                                        T-Shirt</small>
                                                
                                                                    
                                                                <small v-if="getEstimatedShippingDate(item)" class="estimated-ship-date" style="display: block; margin-top: 4px; color: #666;">
                                                                    Est. Ship Date: {{ getEstimatedShippingDate(item) }}
                                                                </small>
                                                                   </div>
                                                                <div
                                                                    v-if="isTShirt24HourItem(item)"
                                                                    class="hours_info_block_image"
                                                                >
                                                                    <img src="/maincss/images/icons/hour-tshirts.png" alt="24 hours T-Shirt" />
                                                                </div>
                                                            </div>
                                                            </td>
                                                            <td class="price_data_block">
                                                                <div class="cost-breakdown">
                                                                    <div class="delete_block">
                                                                        <div></div>
                                                                        <a href="javascript:void(0);"
                                                                            @click="deleteCartItem(item.id)"
                                                                            class="delete-item-link">
                                                                            Delete Item
                                                                        </a>
                                                                    </div>


                                                                    <div class="cost-item"
                                                                        v-if="getBaseFeeTotal(item) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(1) || 'Base Fee'"
                                                                            :title="(getRollupFeeDisplayName(1) || 'Base Fee') + ' Breakdown'"
                                                                            :base-price="item.subtotal_price"
                                                                            :base-unit-price="getBaseUnitPriceFromTiers(item)"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getBaseFeeServices(item)"
                                                                            :color-size-combinations="getColorSizeCombinations(item)"
                                                                            :discount-config="getActiveProductDiscount(item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getBaseFeeTotal(item)) }}
                                                                        </div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="item.decoration_type !== undefined && (item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) && shouldShowRunChargeRow(item)">
                                                                        <ToolTip :label="getRollupFeeDisplayName(12) || 'Run Charge'"
                                                                            :title="(getRollupFeeDisplayName(12) || 'Run Charge') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getRunChargeServices(item)"
                                                                            :run-charge-breakdown="getRunChargeBreakdown(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRunChargeTotalFromBreakdown(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <!-- Custom Color Fee for single items -->
                                                                    <div class="cost-item"
                                                                        v-if="(item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) && (getColorMixFeeData(item) || (getColorMixFeeServices(item) && getColorMixFeeServices(item).length > 0)) && getColorMixFeeTotal(item) > 0 && !isGroupedDecorationType0(item)">
                                                                        <ToolTip :label="getRollupFeeDisplayName(13) || 'Custom Color Fee'"
                                                                            :title="(getRollupFeeDisplayName(13) || 'Custom Color Fee') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <!-- Combined Custom Color Fee for grouped items (show in parent item only, when collapsed) -->
                                                                    <div class="cost-item"
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && item.collapse && (getCombinedColorMixFeeData(item) || hasCombinedColorMixFeeServices(item)) && getCombinedColorMixFeeTotal(item) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(13) || 'Custom Color Fee'"
                                                                            :title="(getRollupFeeDisplayName(13) || 'Custom Color Fee') + ' Breakdown'"
                                                                            :base-price="0" :quantity="0"
                                                                            :services="getCombinedColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getCombinedColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getCombinedColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>
                                                                    <!-- Combined Custom Color Fee for grouped items (show in parent item only, when expanded) -->
                                                                    <div class="cost-item"
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && !item.collapse && (getCombinedColorMixFeeData(item) || hasCombinedColorMixFeeServices(item)) && getCombinedColorMixFeeTotal(item) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(13) || 'Custom Color Fee'"
                                                                            :title="(getRollupFeeDisplayName(13) || 'Custom Color Fee') + ' Breakdown'"
                                                                            :base-price="0" :quantity="0"
                                                                            :services="getCombinedColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getCombinedColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getCombinedColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="(item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) && shouldShowSetupFeeRow(item)">
                                                                        <ToolTip :label="getRollupFeeDisplayName(2) || 'Set Up Fees'"
                                                                            :title="(getRollupFeeDisplayName(2) || 'Set Up Fees') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getSetupFeeServices(item)"
                                                                            :setup-fee-details="getNormalizedSetupFeeDetails(item)"
                                                                            :imprint-locations="getEffectiveImprintLocations(item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getDisplayedSetupFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="item.rush_fee_breakdown && getRushFeeTotal(item) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(6) || 'Rush Fee'"
                                                                            :title="(getRollupFeeDisplayName(6) || 'Rush Fee') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :rush-fee-breakdown="item.rush_fee_breakdown"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRushFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="getDynamicPatchCostTotal(item) > 0 || getDynamicPatchCostDetails(item).some(r => parseInt(r.inventory_used || 0, 10) > 0)">
                                                                        <ToolTip
                                                                            label="Patch Cost"
                                                                            title="Patch Cost Breakdown"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :patch-cost-details="getDynamicPatchCostDetails(item)"
                                                                            :patch-cost-total="getDynamicPatchCostTotal(item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getDynamicPatchCostTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-separator"></div>
                                                                    <template
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && item.collapse">
                                                                        <div class="cost-separator"></div>
                                                                        <div class="cost-item cost-total"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Group Sub Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">{{
                                                                                    icPriceFormat(getGroupSubTotal(item)) }}
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <!-- For grouped items when expanded, show Item Sub Total, Discount, and Total -->
                                                                        <template v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && !item.collapse">
                                                                            <div class="cost-item cost-total">
                                                                                <div class="cost-label">
                                                                                    <span>Item Sub Total</span>
                                                                                </div>
                                                                                <div class="cost-value">{{
                                                                                    icPriceFormat(getItemSubTotalForGroupedParent(item)) }}
                                                                                </div>
                                                                            </div>
                                                                            <!-- Discount removed - now applied at size cost level -->
                                                                        </template>
                                                                        <!-- For single items, show Item Sub Total, Discount, and Total -->
                                                                        <template v-else>
                                                                            <div class="cost-item cost-total">
                                                                                <div class="cost-label">
                                                                                    <span>Item Sub Total</span>
                                                                                </div>
                                                                                <div class="cost-value">{{
                                                                                    icPriceFormat(getItemSubTotal(item)) }}
                                                                                </div>
                                                                            </div>
                                                                            <!-- Discount removed - now applied at size cost level -->
                                                                        </template>
                                                                    </template>
                                                                </div>
                                                            </td>

                                                            <!-- <td class="price">{{ icPriceFormat(item.total_price) }}</td> -->

                                                            <!-- <td class="mobile_rgt_50 delete_col">
                                                                <a data-original-title="null" class=" has-tooltip"
                                                                    @click="deleteCartItem(item.id)"
                                                                    v-tooltip="'Delete item!'">
                                                                    <img src="/maincss/images/trash.svg" alt=" ">
                                                                </a>
                                                            </td> -->
                                                            <div class="modal fade cart_preview"
                                                                :id="'imagepreview-' + item.id" data-backdrop="static"
                                                                data-keyboard="false" tabindex="-1"
                                                                aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true">
                                                                <div class="modal-dialog modal-dialog-centered cart_modal_s"
                                                                    style="max-width: 823px; width: 100%">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header border-bottom-0 p-0">
                                                                            <button type="button" class="close"
                                                                                data-dismiss="modal" aria-label="Close">
                                                                                <img src="/maincss/images/cancel.svg" />
                                                                            </button>
                                                                        </div>
                                                                        <div v-if="getFilteredDesignImages(item).length > 0
                                                                        " class="modal-body pt-0">
                                                                            <div :class="'canvas_auto_preview_images ' +
                                                                                (getFilteredDesignImages(item).length > 0
                                                                                    ? 'new_canvas_images' +
                                                                                    getFilteredDesignImages(item).length
                                                                                    : '')
                                                                                "
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px"
                                                                                    v-for="(design_img, index) in getFilteredDesignImages(item)"
                                                                                    :key="index">
                                                                                    <h4>
                                                                                        {{
                                                                                            (design_img.label) ? design_img.label.replace(
                                                                                                /(?:^|\s|-)\S/g,
                                                                                                (x) => x.toUpperCase()
                                                                                            ) : ''
                                                                                        }}
                                                                                    </h4>
                                                                                    <DisplayProductImage
                                                                                        :product="item.main_new_product"
                                                                                        :classValue="'m-auto'"
                                                                                        :designImage="design_img.url"
                                                                                        :color="item.color_id"
                                                                                        :backgroundColorHex="isCustomBoxLocation(item, design_img) && item.Color && item.Color.hex ? item.Color.hex : ''"
                                                                                        :whateverActivatesThisLink="false" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="modal-body pt-0">
                                                                            <div class="canvas_auto_preview_images new_canvas_images1"
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px">
                                                                                    <DisplayProductImage
                                                                                        :whateverActivatesThisLink="false"
                                                                                        :product="item.main_new_product"
                                                                                        :designImage="item.design_image"
                                                                                        :colorProductImage="item.main_new_product_image"
                                                                                        :color="item.color_id"
                                                                                        :classValue="'m-auto'" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <td class="accordion_action">
                                                                <span v-if="item.subItems && (item.subItems.length > 0)"
                                                                    data-toggle="collapse"
                                                                    :href="`#subItemsModal${item.id}`" role="button"
                                                                    aria-expanded="true" aria-controls="collapseExample"
                                                                    @click="item.collapse = !item.collapse; $forceUpdate();">
                                                                    <a href="javascript:void(0);"
                                                                        v-if="item.collapse"><img
                                                                            src="/maincss/images/plus-ic.svg"
                                                                            alt=""></a>
                                                                    <a href="javascript:void(0);" v-else><img
                                                                            src="/maincss/images/minus-ic.svg"
                                                                            alt=""></a>
                                                                </span>
                                                            </td> -->

                                                        </tr>
                                                    </thead>
                                                    <tbody class="collapse inner_tbody show"
                                                        :id="`subItemsModal${item.id}`">
                                                        <tr v-for="(subItem, subItemIndex) in item.subItems"
                                                            :key="subItemIndex">
                                                            <td class="item-image">
                                                                <div class="cart_image d-flex">
                                                                    <DisplayProductImage
                                                                        :whateverActivatesThisLink="false"
                                                                        :product="subItem.main_new_product"
                                                                        :designImage="subItem.design_image"
                                                                        :colorProductImage="subItem.main_new_product_image"
                                                                        :color="subItem.color_id"
                                                                        :classValue="'m-auto1'" />
                                                                    <a href="#" class="hover_search" data-toggle="modal"
                                                                        :data-target="'#imagepreview-' + subItem.id">
                                                                        <img src="/maincss/images/zoom.svg" alt=" " />
                                                                    </a>

                                                                </div>
                                                                <!-- <router-link v-if="isTShirt24HourItem(subItem)"
                                                                    class="product_items_no_custom"
                                                                    :to="{ path: '/24hourtshirts/' + subItem.main_new_product.id }">
                                                                    <p class="text-center mt_14 mb_0">
                                                                        {{ subItem.main_new_product.product_number }}
                                                                    </p>
                                                                </router-link> -->
                                                                <button
                                                                    class="cart-preview-artworks-btn"
                                                                    data-toggle="modal"
                                                                    :data-target="'#imagepreview-' + subItem.id"
                                                                >
                                                                    Preview Artworks
                                                                </button>
                                                                <ul v-if="subItem.decoration_colors && subItem.decoration_colors.length > 0"
                                                                    class="standard_colors">
                                                                    <li v-for="(color, index) in subItem.decoration_colors"
                                                                        :style="'background-color:' + color.hex + ';'"
                                                                        :key="index" v-tooltip="{
                                                                            'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                                                                            'html': true
                                                                        }">
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td class="title_mobile">
                                                                <span class="cart_icon_image">
                                                                    Item code :
                                                                    <span>{{ subItem.main_new_product.product_number
                                                                    }}</span>
                                                                    <a v-if="shouldShowNameNumbersForChild(subItem, item)"
                                                                        :id="'nameNumbers' + subItem.color_id"
                                                                        @click="openNameNumbersModal(subItem, item)"
                                                                        href="javascript:void(0);"
                                                                        class="d-flex align-items-center"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/maincss/images/path.png"
                                                                            class="ml_6 path cart_icon" />
                                                                    </a>
                                                                </span>
                                                                <router-link v-if="isTShirt24HourItem(subItem)"
                                                                    :to="{ path: '/24hourtshirts/' + subItem.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ subItem.main_new_product.name |
                                                                                capitalize }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            getTotalItemQuantity(subItem)
                                                                        }})</span></p>
                                                                    </div>
                                                                </router-link>
                                                                <router-link v-else
                                                                    :to="{ path: '/product-details-new/' + subItem.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ subItem.main_new_product.name |
                                                                                capitalize }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            getTotalItemQuantity(subItem)
                                                                        }})</span></p>
                                                                    </div>
                                                                </router-link>

                                                                <div class="size_mobile quantity_custom_div">
                                                                    <div class="d-flex flex-wrap inner_size_table">
                                                                        <div class="product_count"
                                                                            v-for="(sizeItem, subItemSizeIndex) in getSortedCartSizeItems(subItem)"
                                                                            :key="subItemSizeIndex">
                                                                            <div class="count_item_heading">
                                                                                <h6 class="m-0">{{
                                                                                    sizeItem.main_new_sub_product.Size.size
                                                                                }}</h6>
                                                                            </div>
                                                                            <div class="count_item_price">
                                                                                <!-- Commented out + - buttons for size -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-minus"
                                                                                    @click="decrementQuantity($event, subItem, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                                <!-- Replaced qty-display with input field -->
                                                                                <input 
                                                                                    type="number" 
                                                                                    class="qty-display qty-input"
                                                                                    :value="getDisplayQuantity(sizeItem)"
                                                                                    @input="onSizeInputChange($event, subItem, sizeItem)"
                                                                                    @blur="onSizeInputBlur($event, subItem, sizeItem)"
                                                                                    :disabled="isBusy"
                                                                                    min="0"
                                                                                    style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd; border-radius: 4px;"
                                                                                />
                                                                                <!-- <div class="qty-display">{{
                                                                                    getDisplayQuantity(sizeItem) }}
                                                                                </div> -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-plus"
                                                                                    @click="incrementQuantity($event, subItem, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M8 3.5V12.5M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- Commented out Update button - auto-update with debounce now -->
                                                                    <!-- <a v-if="subItem.show_update_button"
                                                                        href="javascript:void(0);"
                                                                        @click="updateCartItem(subItem)"
                                                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header mt_10">
                                                                        Update
                                                                    </a> -->
                                                                </div>
                                                                <div class="color_mobile">
                                                                    <div class="color_block"
                                                                        v-html="productColors(subItem.Color)"></div>
                                                                </div>
                                                                <div class="hours_info_block">
                                                                    <div>
                                                                        <small
                                                                            v-if="subItem.decoration && subItem.decoration.master_service && subItem.decoration.master_service.id">
                                                                            {{ getCartDecorationServiceEcommDisplayName(subItem) }}
                                                                        </small>
                                                                        <small v-else>{{
                                                                            decoration_types[subItem.decoration_type] }}
                                                                        </small>
                                                                        <small v-if="isTShirt24HourItem(subItem)">24 hours
                                                                            T-Shirt</small>
                                                                        <small v-if="getEstimatedShippingDate(subItem)" class="estimated-ship-date" style="display: block; margin-top: 4px; color: #666;">
                                                                            Est. Ship Date: {{ getEstimatedShippingDate(subItem) }}
                                                                        </small>
                                                                    </div>
                                                                    <div
                                                                        v-if="isTShirt24HourItem(subItem)"
                                                                        class="hours_info_block_image"
                                                                    >
                                                                        <img src="/maincss/images/icons/hour-tshirts.png" alt="24 hours T-Shirt" />
                                                                    </div>
                                                                </div>
                                                            </td>


                                                            <td class="price_data_block">
                                                                <div class="cost-breakdown">
                                                                    <div class="delete_block">
                                                                        <div></div>
                                                                        <a href="javascript:void(0);"
                                                                            @click="deleteCartItem(subItem.id)"
                                                                            class="delete-item-link">
                                                                            Delete Item
                                                                        </a>
                                                                    </div>
                                                                    <div class="cost-item"
                                                                        v-if="getBaseFeeTotal(subItem, item) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(1) || 'Base Fee'"
                                                                            :title="(getRollupFeeDisplayName(1) || 'Base Fee') + ' Breakdown'"
                                                                            :base-price="subItem.subtotal_price"
                                                                            :base-unit-price="getBaseUnitPriceFromTiers(subItem, item)"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getBaseFeeServices(subItem)"
                                                                            :color-size-combinations="getColorSizeCombinations(subItem, item)"
                                                                            :discount-config="getActiveProductDiscount(subItem)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getBaseFeeTotal(subItem, item)) }}
                                                                        </div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="subItem.decoration_type !== undefined && (subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 5 || subItem.decoration_type == 2 || subItem.decoration_type == 4) && shouldShowRunChargeRow(subItem, item)">
                                                                        <ToolTip :label="getRollupFeeDisplayName(12) || 'Run Charge'"
                                                                            :title="(getRollupFeeDisplayName(12) || 'Run Charge') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getRunChargeServices(subItem)"
                                                                            :run-charge-breakdown="getRunChargeBreakdown(subItem, item)"
                                                                            :decoration-type="subItem.decoration_type"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRunChargeTotalFromBreakdown(subItem, item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="(subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 5 || subItem.decoration_type == 2 || subItem.decoration_type == 4) && (getDisplayedColorMixFeeData(subItem, item) || (getDisplayedColorMixFeeServices(subItem, item) && getDisplayedColorMixFeeServices(subItem, item).length > 0)) && getDisplayedColorMixFeeTotal(subItem, item) > 0 && (!isGroupedDecorationType0(item) || isAssemblyGroup(item))">
                                                                        <ToolTip :label="getRollupFeeDisplayName(13) || 'Custom Color Fee'"
                                                                            :title="(getRollupFeeDisplayName(13) || 'Custom Color Fee') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getDisplayedColorMixFeeServices(subItem, item)"
                                                                            :color-mix-fee-data="getDisplayedColorMixFeeData(subItem, item)"
                                                                            :decoration-type="subItem.decoration_type"
                                                                            :master-service="subItem.decoration && subItem.decoration.master_service ? subItem.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getDisplayedColorMixFeeTotal(subItem, item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="(subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 5 || subItem.decoration_type == 2 || subItem.decoration_type == 4) && shouldShowSetupFeeRow(subItem, item)">
                                                                        <ToolTip :label="getRollupFeeDisplayName(2) || 'Set Up Fees'"
                                                                            :title="(getRollupFeeDisplayName(2) || 'Set Up Fees') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getSetupFeeServices(subItem)"
                                                                            :setup-fee-details="getDisplayedSetupFeeDetails(subItem, item)"
                                                                            :imprint-locations="getEffectiveImprintLocations(subItem, item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getDisplayedSetupFeeTotal(subItem, item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="subItem.rush_fee_breakdown && getRushFeeTotal(subItem) > 0">
                                                                        <ToolTip :label="getRollupFeeDisplayName(6) || 'Rush Fee'"
                                                                            :title="(getRollupFeeDisplayName(6) || 'Rush Fee') + ' Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :rush-fee-breakdown="subItem.rush_fee_breakdown"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRushFeeTotal(subItem))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-separator"></div>

                                                                    <div class="cost-item cost-total">
                                                                        <div class="cost-label">
                                                                            <span>Item Sub Total</span>
                                                                        </div>
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getItemSubTotal(subItem,
                                                                                item)) }}</div>
                                                                    </div>

                                                                    <!-- Discount removed - now applied at size cost level -->

                                                                    <!-- Group Sub Total for grouped items (show only on last subItem when expanded, no discount applied) -->
                                                                    <template
                                                                        v-if="isGroupedDecorationType0(item) && subItemIndex === item.subItems.length - 1 && !item.collapse">
                                                                        <div class="cost-separator"></div>
                                                                        <div class="cost-item cost-total"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Group Sub Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">{{
                                                                                    icPriceFormat(getGroupSubTotal(item)) }}
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </td>
                                                            <!-- <td class="price"></td> -->

                                                            <div class="modal fade cart_preview"
                                                                :id="'imagepreview-' + subItem.id"
                                                                data-backdrop="static" data-keyboard="false"
                                                                tabindex="-1" aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true">
                                                                <div class="modal-dialog modal-dialog-centered cart_modal_s"
                                                                    style="max-width: 823px; width: 100%">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header border-bottom-0 p-0">
                                                                            <button type="button" class="close"
                                                                                data-dismiss="modal" aria-label="Close">
                                                                                <img src="/maincss/images/cancel.svg" />
                                                                            </button>
                                                                        </div>
                                                                        <div v-if="getFilteredDesignImages(subItem, item).length > 0
                                                                        " class="modal-body pt-0">
                                                                            <div :class="'canvas_auto_preview_images ' +
                                                                                (getFilteredDesignImages(subItem, item).length > 0
                                                                                    ? 'new_canvas_images' +
                                                                                    getFilteredDesignImages(subItem, item).length
                                                                                    : '')
                                                                                "
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px" v-for="(
design_img, index
                                            ) in getFilteredDesignImages(subItem, item)" :key="index">
                                                                                    <h4>
                                                                                        {{
                                                                                            (design_img.label) ? design_img.label.replace(
                                                                                                /(?:^|\s|-)\S/g,
                                                                                                (x) => x.toUpperCase()
                                                                                            ) : ''
                                                                                        }}
                                                                                    </h4>
                                                                                    <DisplayProductImage
                                                                                        :product="subItem.main_new_product"
                                                                                        :classValue="'m-auto'"
                                                                                        :designImage="design_img.url"
                                                                                        :color="subItem.color_id"
                                                                                        :backgroundColorHex="isCustomBoxLocation(subItem, design_img) && subItem.Color && subItem.Color.hex ? subItem.Color.hex : ''"
                                                                                        :whateverActivatesThisLink="false" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="modal-body pt-0">
                                                                            <div class="canvas_auto_preview_images new_canvas_images1"
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px">
                                                                                    <DisplayProductImage
                                                                                        :whateverActivatesThisLink="false"
                                                                                        :product="subItem.main_new_product"
                                                                                        :designImage="subItem.design_image"
                                                                                        :colorProductImage="subItem.product_image"
                                                                                        :color="subItem.color_id"
                                                                                        :classValue="'m-auto'" />
                                                                                    <!-- <h3>{{ item.product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </tr>

                                                    </tbody>
                                                    <tr class="total-block d-none">
                                                        <td class="on_way">
                                                            <img v-if="haveRushFee(item)"
                                                                src="/maincss/images/on-way.svg" alt=" " class="mr_8" />
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td colspan="2" class="fee_data">
                                                            <div v-if="item.sp_setup_fee && item.build_id">
                                                                Per Color Setup Fee ( {{ item.sp_decoration_colors_count
                                                                }} * {{ icPriceFormat(item.per_color_setup_cost) }} ):
                                                                <span> {{ icPriceFormat(item.sp_setup_fee) }}</span>
                                                            </div>
                                                            <div v-if="item.emb_setup_fee && item.build_id">
                                                                Digitizing Fee:
                                                                <span> {{ icPriceFormat(item.emb_setup_fee) }}</span>
                                                            </div>
                                                            <div class="d-flex align-items-center"
                                                                v-if="item.sp_imprint_locations && item.sp_imprint_locations.length && (item.sp_decoration_colors_count > 0) && item.build_id">
                                                                Screen Print Color Fee
                                                                <div class="more_color_link dropdown">
                                                                    <a href="#" id="dropdownMenuButton551"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        class="dropdown-toggle d-flex align-items-center">
                                                                        <img src="/maincss/images/information.svg"
                                                                            class="ml_6">
                                                                    </a>
                                                                    <div aria-labelledby="dropdownMenuButton"
                                                                        class="dropdown-menu">
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20">
                                                                            Imprint locations & colors
                                                                            <span class="cross_ic"><img
                                                                                    src="/maincss/images/cross.svg"></span>
                                                                        </h4>
                                                                        <div class="scroll">
                                                                            <div v-for="(location, key) in item.sp_imprint_locations"
                                                                                :key="key">
                                                                                <div v-if="location.no_of_color"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p class="font-weight-bold">
                                                                                        Imprint Location: {{
                                                                                            location.location }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="location.total_decoration_fee">
                                                                                        {{
                                                                                            icPriceFormat(location.total_decoration_fee)
                                                                                        }}
                                                                                    </p>
                                                                                </div>

                                                                                <div v-for="(colors, color_key) in location.colors"
                                                                                    :key="color_key"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p v-if="colors.color"
                                                                                        class="font-weight-bold w-25">
                                                                                        Color {{ color_key + 1 }} -
                                                                                        {{ colors.color.color_name }}:
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="(colors.color.color_id == 0) && colors.color.non_standard_fee">
                                                                                        {{
                                                                                            icPriceFormat(colors.color.non_standard_fee)
                                                                                        }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-else-if="colors.total_decor_upcharge">
                                                                                        {{
                                                                                            icPriceFormat(colors.total_decor_upcharge)
                                                                                        }}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:
                                                                <span> {{ icPriceFormat(item.sp_decoration_colors_price)
                                                                }}</span>
                                                            </div>
                                                            <div class="d-flex align-items-center"
                                                                v-if="item.emb_imprint_locations && item.emb_imprint_locations.length && (item.emb_decoration_colors_count > 0) && item.build_id">
                                                                Embroidery Color Fee
                                                                <div class="more_color_link dropdown">
                                                                    <a href="#" id="dropdownMenuButton551"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        class="dropdown-toggle d-flex align-items-center">
                                                                        <img src="/maincss/images/information.svg"
                                                                            class="ml_6">
                                                                    </a>
                                                                    <div aria-labelledby="dropdownMenuButton"
                                                                        class="dropdown-menu">
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20">
                                                                            Embroidery locations & colors
                                                                            <span class="cross_ic"><img
                                                                                    src="/maincss/images/cross.svg"></span>
                                                                        </h4>
                                                                        <div class="scroll">
                                                                            <div v-for="(location, key) in item.emb_imprint_locations"
                                                                                :key="key">
                                                                                <div v-if="location.no_of_color"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p class="font-weight-bold">
                                                                                        Embroidery Location: {{
                                                                                            location.location }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="location.total_decoration_fee">
                                                                                        {{
                                                                                            icPriceFormat(location.total_decoration_fee)
                                                                                        }}
                                                                                    </p>
                                                                                </div>

                                                                                <div v-for="(colors, color_key) in location.colors"
                                                                                    :key="color_key"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p v-if="colors.color"
                                                                                        class="font-weight-bold w-25">
                                                                                        Color {{ color_key + 1 }} -
                                                                                        {{ colors.color.color_name }}:
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="(colors.color.color_id == 0) && colors.color.non_standard_fee">
                                                                                        {{
                                                                                            icPriceFormat(colors.color.non_standard_fee)
                                                                                        }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-else-if="colors.total_decor_upcharge">
                                                                                        {{
                                                                                            icPriceFormat(colors.total_decor_upcharge)
                                                                                        }}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:
                                                                <span> {{
                                                                    icPriceFormat(item.emb_decoration_colors_price)
                                                                }}</span>
                                                            </div>
                                                        </td>
                                                        <td colspan="4" class="fee_data">
                                                            {{ item.build_id ? 'Build' : '' }} Sub Total: <span>{{
                                                                icPriceFormat(item.build_total_price) }}</span>
                                                        </td>
                                                    </tr>

                                                </table>
                                                </div>
                                               

                                            </td>

                                        </tr>

                                    </tbody>
                                    <tr class="build-total-block d-none" v-if="cart_items.length > 0">
                                        <td colspan="1"></td>
                                        <td colspan="3"></td>
                                        <td class="total-fee-block" colspan="4">
                                            <p v-if="total_design_fee > 0">
                                                <span>Design Fee : </span>
                                                <span class="fee_amount">{{ icPriceFormat(total_design_fee) }}</span>
                                            </p>
                                            <p v-if="false">
                                                <span>
                                                    <img src="/maincss/images/on-way.svg" alt="on-way" class="mr_8" />
                                                    Rush Fee : </span>
                                                <span class="fee_amount">$0.00</span>
                                            </p>
                                            <p v-if="total_non_standard_fees_sp > 0">
                                                <span class="d-flex align-items-center">
                                                    Custom Ink Mix Fee ( {{ total_non_standard_colors_sp.length }} * {{
                                                        icPriceFormat(non_standard_fees['sp']) }} )<ul
                                                        v-if="total_non_standard_colors_sp.length > 0"
                                                        class="standard_colors">
                                                        <div class="more_color_link dropdown">
                                                            <a href="#" id="dropdownMenuButton551"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"
                                                                class="dropdown-toggle d-flex align-items-center">
                                                                <img src="/maincss/images/information.svg" class="ml_6">
                                                            </a>
                                                            <div aria-labelledby="dropdownMenuButton"
                                                                class="dropdown-menu">
                                                                <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                    Custom Ink Mix Colors
                                                                    <span class="cross_ic"><img
                                                                            src="/maincss/images/cross.svg"></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <!-- eslint-disable -->
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li class="w-15"
                                                                            v-for="(color, index) in total_non_standard_colors_sp"
                                                                            :style="'background-color:' + color + ';'"
                                                                            :key="index" v-tooltip="color">
                                                                        </li>
                                                                    </ul>
                                            </p>
                                            <!-- eslint-enable -->
                            </div>
                        </div>
                    </div>
                    </ul>:
                    </span>



                    <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_sp) }}

                    </span>

                    </p>
                    <p v-if="total_non_standard_fees_emb > 0">
                        <span class="d-flex align-items-center">
                            Custom Thread Mix Fee ( {{ total_non_standard_colors_emb.length }} * {{
                                icPriceFormat(non_standard_fees['emb']) }} ) <ul
                                v-if="total_non_standard_colors_emb.length > 0" class="standard_colors">
                                <div class="more_color_link dropdown">
                                    <a href="#" id="dropdownMenuButton551" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false" class="dropdown-toggle d-flex align-items-center">
                                        <!-- <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_sp) }}</span>  -->
                                        <img src="/maincss/images/information.svg" class="ml_6">
                                    </a>
                                    <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                        <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                            Custom Ink Mix Colors
                                            <span class="cross_ic"><img src="/maincss/images/cross.svg"></span>
                                        </h4>
                                        <div class="dropdown-item d-flex align-items-center">
                                            <p class="mb-0">
                                            <ul>
                                                <li class="w-15" v-for="(color, index) in total_non_standard_colors_emb"
                                                    :style="'background-color:' + color + ';'" :key="index"
                                                    v-tooltip="color">
                                                </li>
                                            </ul>
                    </p>
                </div>
            </div>
    </div>
    </ul>:
    </span>



    <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_emb) }}

    </span>

    </p>
    <p v-if="cart_items.length > 0"><span>Total :</span> <span class="fee_amount">{{ icPriceFormat(grand_total) }}</span> </p>
    </td>
    </tr>
    </table>
    </div>
    </div>
    </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div :class="cart_items.length == 0
                ? 'cart_buttons d-flex flex-wrap mt_28 align-items-center logout_cart_empty '
                : 'cart_buttons d-flex flex-wrap mt_28 align-items-start justify-content-between'
                ">
                <a href="/product-list/apparel/28" class="btn btn_continue_shopping bg_primary_blue text_white">
                    CONTINUE SHOPPING
                </a>

                <div class="cart-summary-section">
                    <div class="cart-totals">
                        <!-- <div class="cart-total-row">
                            <span class="total-label">Sub Total</span>
                            <span class="total-value">{{ icPriceFormat(cart_subtotal) }}</span>
                        </div> -->
                        <!-- <div class="cart-total-row">
                            <span class="total-label">Sales Tax</span>
                            <span class="total-value">{{ icPriceFormat(sales_tax) }}</span>
                        </div> -->
                        <div class="cart-total-row grand-total-row" v-if="cart_items.length > 0">
                            <span class="total-label">Grand Total:</span>
                            <span class="total-value">{{ icPriceFormat(grand_total) }}</span>
                        </div>
                    </div>

                    <div class="checkout-button-wrapper">
                        <a v-if="cart_items.length > 0 && isAuthenticatedClient" @click="checkout()"
                            class="btn btn_checkout bg_primary_orange text_white">
                            CHECK OUT
                        </a>

                        <a href="#" data-toggle="modal" data-target="#login" data-path="/checkout/v3"
                            v-if="cart_items.length > 0 && !isAuthenticatedClient"
                            class="login-cart btn btn_checkout bg_primary_orange text_white">
                            <span>CHECK OUT</span>
                        </a>
                    </div>
                </div>

                <!-- :href="isError==true ? '#':'/checkout'" -->

            </div>
            <div class="preloader" v-show="isBusy">
                <div class="preloader-body">
                    <svg width="40" height="40" viewBox="0 0 40 40">
                        <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
    </div>
    </section>
    <LoginModal />
    <ShippingKittingPreferencesModal 
        ref="shippingPreferencesModal"
        @preferences-saved="handleShippingPreferences"
    />



    <!-- NAME & NUMBERS MODAL -->
    <div class="modal fade name_number_popup" id="nameNumbersModal" aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title fs-5" id="exampleModalToggleLabel">Name & Numbers</h3>
                    <div class="close_modal">
                        <a href="#" class="popup-close art_poup_close" id="popup-close" data-dismiss="modal"
                            ref="popupclose">
                            <span aria-hidden="true">&times;</span>
                        </a>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-row">
                        <div class="text-center" v-if="nameNumberAllowedImprints.front && name_and_number_json.front.length > 0 && selected_name_number.front && (selected_name_number.front.name || selected_name_number.front.number)">
                            <h5>Front Location</h5>

                            <div class="scroll">
                                <div>
                                    <div class="col-md-12">
                                        <div class="mt_10 d-flex flex-wrap justify-content-left color_checkbox ">
                                            <div class="table-responsive">
                                                <table class="name-number-data mt-0">
                                                    <thead class="data-head">
                                                        <tr class="cart-data-col">
                                                            <th v-if="selected_name_number.front && selected_name_number.front.name"
                                                                class="data-heading">Name</th>
                                                            <th v-if="selected_name_number.front && selected_name_number.front.number"
                                                                class="data-heading">Number</th>
                                                            <th class="data-heading">Size</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="data-body">
                                                        <tr v-for="(namesAndNumber, key) in name_and_number_json.front"
                                                            :key="key" class="cart-data-col">
                                                            <td v-if="selected_name_number.front && selected_name_number.front.name">
                                                                {{ namesAndNumber.name || '-' }}
                                                            </td>
                                                            <td v-if="selected_name_number.front && selected_name_number.front.number">
                                                                {{ namesAndNumber.number || '-' }}
                                                            </td>
                                                            <td>{{ namesAndNumber.size }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="nameNumberAllowedImprints.back && name_and_number_json.back.length > 0 && selected_name_number.back && (selected_name_number.back.name || selected_name_number.back.number)">
                            <h5>Back Location</h5>
                            <div class="scroll">
                                <div>
                                    <div class="col-md-12">
                                        <div class="mt_10 d-flex flex-wrap justify-content-left color_checkbox ">
                                            <div class="table-responsive">
                                                <table v-if="name_and_number_json.back.length > 0"
                                                    class="name-number-data mt-0">
                                                    <thead class="data-head">
                                                        <tr class="cart-data-col">
                                                            <th v-if="selected_name_number.back.name"
                                                                class="data-heading">
                                                                Name
                                                            </th>
                                                            <th v-if="selected_name_number.back.number"
                                                                class="data-heading">
                                                                Number
                                                            </th>
                                                            <th class="data-heading">Size</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="data-body">
                                                        <tr v-for="(namesAndNumber, key) in name_and_number_json.back"
                                                            :key="key" class="cart-data-col">
                                                            <td v-if="selected_name_number.back.name">
                                                                {{ namesAndNumber.name || '-' }}
                                                            </td>
                                                            <td v-if="selected_name_number.back.number">
                                                                {{ namesAndNumber.number || '-' }}
                                                            </td>
                                                            <td>{{ namesAndNumber.size }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="nameNumberAllowedImprints.left && name_and_number_json.left && name_and_number_json.left.length > 0 && selected_name_number.left && (selected_name_number.left.name || selected_name_number.left.number)">
                            <h5>Left Location</h5>
                            <div class="scroll">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table class="name-number-data mt-0">
                                            <thead class="data-head">
                                                <tr class="cart-data-col">
                                                    <th v-if="selected_name_number.left && selected_name_number.left.name"
                                                        class="data-heading">Name</th>
                                                    <th v-if="selected_name_number.left && selected_name_number.left.number"
                                                        class="data-heading">Number</th>
                                                    <th class="data-heading">Size</th>
                                                </tr>
                                            </thead>
                                            <tbody class="data-body">
                                                <tr v-for="(namesAndNumber, key) in name_and_number_json.left"
                                                    :key="'left-' + key" class="cart-data-col">
                                                    <td v-if="selected_name_number.left && selected_name_number.left.name">
                                                        {{ namesAndNumber.name || '-' }}
                                                    </td>
                                                    <td v-if="selected_name_number.left && selected_name_number.left.number">
                                                        {{ namesAndNumber.number || '-' }}
                                                    </td>
                                                    <td>{{ namesAndNumber.size }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="nameNumberAllowedImprints.right && name_and_number_json.right && name_and_number_json.right.length > 0 && selected_name_number.right && (selected_name_number.right.name || selected_name_number.right.number)">
                            <h5>Right Location</h5>
                            <div class="scroll">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table class="name-number-data mt-0">
                                            <thead class="data-head">
                                                <tr class="cart-data-col">
                                                    <th v-if="selected_name_number.right && selected_name_number.right.name"
                                                        class="data-heading">Name</th>
                                                    <th v-if="selected_name_number.right && selected_name_number.right.number"
                                                        class="data-heading">Number</th>
                                                    <th class="data-heading">Size</th>
                                                </tr>
                                            </thead>
                                            <tbody class="data-body">
                                                <tr v-for="(namesAndNumber, key) in name_and_number_json.right"
                                                    :key="'right-' + key" class="cart-data-col">
                                                    <td v-if="selected_name_number.right && selected_name_number.right.name">
                                                        {{ namesAndNumber.name || '-' }}
                                                    </td>
                                                    <td v-if="selected_name_number.right && selected_name_number.right.number">
                                                        {{ namesAndNumber.number || '-' }}
                                                    </td>
                                                    <td>{{ namesAndNumber.size }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DECORATION_METHODS } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import LoginModal from "@/components/frontend/LoginModal";
import ShippingKittingPreferencesModal from "@/components/cart/V3/ShippingKittingPreferencesModal.vue";
import { rollupFeeMixin } from "@/common/rollupFee.service";
import { ecommDisplayNameMixin } from "@/common/ecommDisplayName.service";
import { resolveTierQuantityForItem } from "@/common/cartPricingTier.service";
import { computeFingerprintFromArbitraryPayload } from "@/common/suppressDesignGroupFingerprint";
import {
    applySuppressionToSetupFeeDetails as applySetupFeeSuppressionShared,
    shouldSkipSetupFeeSuppressionForAssemblyParentFromGrouped,
    getRawSetupFeesDetailsTotal,
    expandSetupFeeDetailsToMatchTargetTotal,
    getSetupFeeLocationCatalogQuantity,
    getSuppressAdditionalSetupRunChargeConfig
} from "@/common/itemSuppressDisplayShared";
import {
    getAssemblySetupPatchesFromMergedCart,
    getAssemblyMixedCaseDisplaySetupDetails,
    prepareCartItemsAssemblyPlaceOrderInPlace,
    isAssemblySuppressOrphanLine
} from "@/common/assemblyPlaceOrderSetup";
import Breadcrumb from "@/components/Breadcrumb";
import ToolTip from "./components/ToolTip.vue";
import { isTShirt24HourFromItem } from "@/common/product24Hour.util";

export default {
    name: "shopping-cart",
    mixins: [rollupFeeMixin, ecommDisplayNameMixin],
    data() {
        return {
            isBusy: false,
            _pendingAssemblyPatchAfterDelete: false,
            cart_items: [],
            total_design_fee: 0,
            activePatchTooltipId: null,
            retail_price: 0,
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            decoration_price_template_location2: [],
            max_cart_count: 2000,
            isError: false,
            breadcrumbs: [],
            total_non_standard_fees_sp: 0,
            total_non_standard_fees_emb: 0,
            total_cart_items_count: 0,
            total_non_standard_colors_sp: [],
            total_non_standard_colors_emb: [],
            colors_limit: 6,
            decoration_types: {},
            name_and_number_json: {
                front: [],
                back: [],
                left: [],
                right: []
            },
            // Which imprint sides exist on the current cart line (hides Name & Numbers columns for unused sides)
            nameNumberAllowedImprints: {
                front: true,
                back: true,
                left: true,
                right: true
            },
            vendor_data: null,
            vendors_list: [],
            non_standard_fees: { sp: 0, emb: 0 },
            nonStandardColorObj: {
                color_id: 0,
                color_name: "Mix Color",
                color_pms: "Non Standard",
                non_standard_fee: 0,
                decor_upcharge: 0,
                color_value: "#GGGGGG",
                swatches: "",
                category: "Non Standard",
                shades: []
            },
            sizeUpdateTimers: {}, // Store debounce timers for size updates
            holidays: [], // Holidays for date calculation
            patchPriceCacheByMaterial: {},
            patchPriceFetchInFlight: {},
            patchPriceCacheByPatchId: {},
            patchPriceByPatchFetchInFlight: {},
            markup_tiers: [],
            realtimeTemplateFeeCache: {}
        };
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "getAdminOption",
            "adminOptions",
            "decorationMethods",
            "printTemplates",
            "embroideryTemplates",
            "patchTemplates"
        ]),
        tag() {
            return this.$route.params.tag;
        },
        cart_subtotal() {
            // Calculate subtotal before tax using getItemSubTotal for accurate calculation
            // Each item (including subItems) gets individual discount applied
            // For grouped items, use getItemSubTotalForGroupedParent to include combined color mix fee
            let subtotal = 0;
            this.cart_items.forEach((item) => {
                // Check if item is grouped
                if (
                    this.isGroupedDecorationType0(item) &&
                    item.subItems &&
                    item.subItems.length > 0
                ) {
                    // For grouped parent items, use getItemSubTotalForGroupedParent (includes combined color mix fee)
                    const parentSubTotal =
                        this.getItemSubTotalForGroupedParent(item);
                    const parentDiscount = this.getItemDiscount(item);
                    subtotal +=
                        parentDiscount > 0
                            ? parentSubTotal - parentDiscount
                            : parentSubTotal;

                    // Add all sub-items subtotals with individual discounts
                    item.subItems.forEach((subItem) => {
                        // Discount now applied at size cost level, not here
                        const subItemSubTotal = this.getItemSubTotal(
                            subItem,
                            item
                        );
                        subtotal += subItemSubTotal;
                    });
                } else {
                    // For single items, use getItemSubTotal
                    // Discount now applied at size cost level, not here
                    const itemSubTotal = this.getItemSubTotal(item);
                    subtotal += itemSubTotal;
                }
            });
            return subtotal;
        },
        sales_tax() {
            // Calculate sales tax (you can adjust the tax rate as needed)
            // For now, returning 0. You can add tax calculation logic here
            return 0;
        },
        grand_total() {
            // Calculate grand total from cart_subtotal + sales_tax
            // Note: Non-standard fees (custom color fees) are already included in cart_subtotal via getItemSubTotal -> getColorMixFeeTotal
            // So we don't need to add them again here to avoid double-counting
            return this.cart_subtotal + this.sales_tax;
        }
    },
    watch: {
        decorationMethods() {
            this.decorationMethods.filter((method) => {
                this.decoration_types[method.id] = method.name;
            });
        },
        // Force re-render when holidays are loaded to update dates
        holidays() {
            if (
                this.holidays &&
                this.holidays.length > 0 &&
                this.cart_items.length > 0
            ) {
                // Trigger reactivity by reassigning cart_items
                this.$nextTick(() => {
                    this.cart_items = [...this.cart_items];
                });
            }
        }
    },
    components: { DisplayProductImage, LoginModal, ShippingKittingPreferencesModal, Breadcrumb, ToolTip },
    beforeMount() {
        this.$store.dispatch(FETCH_DECORATION_METHODS);
        this.getAllMarkupTiers();
        this.getVendorsList();
        this.fetchHolidays();
    },
    mounted() {
         if (!this.isAuthenticatedClient) {
            //$("#login").modal("show");
            this.$router.push({ name: "home" });
            return;
        }
        this.breadcrumbs = [{ name: "Cart" }];
        document.body.classList.remove("bg_primary_light_white");
        this.isBusy = true;

        // Store Cart component instance globally so CartSummary and ToolTip can access it
        if (typeof window !== "undefined") {
            window.CartV3Component = this;
            // Also set holidays if already loaded
            if (this.holidays && this.holidays.length > 0) {
                window.CartV3Component.holidays = this.holidays;
            }
        }

        setTimeout(() => {
            let non_standard_fees_sp_obj = this.adminOptions.find(
                (option) => option.option_key == "non_standard_color_fees"
            );
            let non_standard_fees_emb_obj = this.adminOptions.find(
                (option) => option.option_key == "non_standard_color_fees_emb"
            );

            if (
                non_standard_fees_sp_obj &&
                non_standard_fees_sp_obj.option_value
            ) {
                this.non_standard_fees["sp"] = parseFloat(
                    non_standard_fees_sp_obj.option_value
                );
            }

            if (
                non_standard_fees_emb_obj &&
                non_standard_fees_emb_obj.option_value
            ) {
                this.non_standard_fees["emb"] = parseFloat(
                    non_standard_fees_emb_obj.option_value
                );
            }
        }, 500);

        if (this.currentUserClient.id === undefined) {
            setTimeout(() => {
                this.getCart();
            }, 3000);
        } else {
            this.getCart();
        }

        // Pre-initialize shipping preferences modal for faster opening
        this.$nextTick(() => {
            /* eslint-disable */
            if (typeof window.$ !== 'undefined') {
                const $modal = window.$("#shippingKittingPreferencesModal");
                if ($modal.length && !$modal.data('bs.modal')) {
                    $modal.modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: false
                    });
                }
            }
            /* eslint-enable */
        });
    },
    methods: {
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        this.markup_tiers = Array.isArray(data.markup_tiers)
                            ? data.markup_tiers
                            : [];
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            if (
                !Array.isArray(this.markup_tiers) ||
                !this.markup_tiers.length ||
                price === undefined ||
                price === null ||
                decoration_type === undefined ||
                decoration_type === null ||
                decoration_price_template === undefined ||
                decoration_price_template === null
            ) {
                return null;
            }

            const normalizedPrice = parseFloat(price);
            const tier = this.markup_tiers.find(
                (row) =>
                    decoration_type == row.decoration_id &&
                    decoration_price_template == row.template_id &&
                    parseFloat(row.start_price) <= normalizedPrice &&
                    parseFloat(row.end_price) >= normalizedPrice
            );

            return tier ? parseFloat(tier.markup) : null;
        },
        getResolvedMarkupPercentage(
            price,
            decoration_type,
            decoration_price_template
        ) {
            const tierMarkup = this.getMarkupFromTier(
                price,
                decoration_type,
                decoration_price_template
            );
            if (tierMarkup !== null) {
                return tierMarkup;
            }
            // Realtime-only behavior: no fallback from saved DB/product markup.
            return 0;
        },
        getChildMarkupPrice(cartItem, childItem) {
            const basePrice = parseFloat(childItem.case_price || 0);
            const decorationType =
                cartItem.decoration_type !== undefined &&
                cartItem.decoration_type !== null
                    ? cartItem.decoration_type
                    : cartItem.main_new_product
                    ? cartItem.main_new_product.decoration_type
                    : null;
            const decorationTemplate =
                cartItem.decoration_price_template !== undefined &&
                cartItem.decoration_price_template !== null
                    ? cartItem.decoration_price_template
                    : cartItem.main_new_product
                    ? cartItem.main_new_product.decoration_price_template
                    : null;
            const markupPercentage = this.getResolvedMarkupPercentage(
                basePrice,
                decorationType,
                decorationTemplate
            );
            const markupPrice = parseFloat(
                (
                    (parseFloat(basePrice) * parseFloat(markupPercentage || 0)) /
                    100
                ).toFixed(2)
            );

            childItem.markup_percentage = markupPercentage;
            childItem.markup_price = markupPrice;

            return markupPrice;
        },
        // Get ecomm display name for decoration service in cart (using VendorDecorationServices)
        getCartDecorationServiceEcommDisplayName(cartItem) {
            if (!cartItem || !cartItem.decoration || !cartItem.main_new_product)
                return null;

            const decoration = cartItem.decoration;
            const decServiceId =
                decoration.id ||
                (decoration.master_service && decoration.master_service.id);
            if (!decServiceId) return null;

            // Priority 1: Check VendorDecorationServices from main_new_product
            if (
                cartItem.main_new_product.VendorDecorationServices &&
                Array.isArray(
                    cartItem.main_new_product.VendorDecorationServices
                )
            ) {
                const vendorService =
                    cartItem.main_new_product.VendorDecorationServices.find(
                        (vs) => {
                            const vsId =
                                typeof vs.id === "string"
                                    ? parseInt(vs.id)
                                    : vs.id;
                            const decId =
                                typeof decServiceId === "string"
                                    ? parseInt(decServiceId)
                                    : decServiceId;
                            return vsId === decId;
                        }
                    );

                if (vendorService) {
                    // Priority 1a: Try ecomm_display directly from vendor service
                    if (vendorService.ecomm_display) {
                        return vendorService.ecomm_display;
                    }

                    // Priority 1b: Try master_service_id lookup from store
                    if (vendorService.master_service_id) {
                        const masterServiceId =
                            typeof vendorService.master_service_id === "string"
                                ? parseInt(vendorService.master_service_id)
                                : vendorService.master_service_id;
                        const ecommDisplayName =
                            this.getEcommDisplayName(masterServiceId);
                        if (ecommDisplayName) return ecommDisplayName;
                    }
                }
            }

            // Priority 2: Fallback to master_service.id from decoration
            if (decoration.master_service && decoration.master_service.id) {
                const ecommDisplayName = this.getEcommDisplayName(
                    decoration.master_service.id
                );
                if (ecommDisplayName) return ecommDisplayName;
            }

            return null;
        },
        // Only design areas that are enabled (imprint_locations.is_selected) are shown in preview.
        getFilteredDesignImages(cartItem, parentItem) {
            const designImages = cartItem.design_images;
            if (!designImages || !Array.isArray(designImages) || designImages.length === 0)
                return designImages || [];
            const imprintLocations = cartItem.imprint_locations || (parentItem && parentItem.imprint_locations) || [];
            if (!imprintLocations.length)
                return designImages;
            const selectedLocations = imprintLocations
                .filter((loc) => loc.is_selected && (loc.location || "").trim())
                .map((loc) => (loc.location || "").toLowerCase().trim());
            if (!selectedLocations.length)
                return designImages;
            return designImages.filter((designImg) => {
                const label = (designImg.label || "").toLowerCase().trim();
                if (!label) return true;
                return selectedLocations.some(
                    (loc) => loc.includes(label) || label.includes(loc)
                );
            });
        },
        // Returns true when custom box is enabled for this cart item's location (front/back/left/right)
        isCustomBoxLocation(cartItem, designImg) {
            if (!cartItem || !cartItem.main_new_product) return false;
            const product = cartItem.main_new_product;
            let areas = product.design_areas;
            if (!areas) return false;

            if (typeof areas === "string") {
                try {
                    areas = JSON.parse(areas);
                } catch (e) {
                    return false;
                }
            }
            if (!Array.isArray(areas) || areas.length === 0) return false;

            const rawLabel = designImg && designImg.label ? designImg.label : "";
            const label = String(rawLabel).toLowerCase().trim();
            if (!label) return false;

            const match = areas.find((a) => {
                if (!a || !a.label) return false;
                const l = String(a.label).toLowerCase().trim();
                if (!l) return false;

                const labelHasFront = label.includes("front");
                const labelHasBack = label.includes("back");
                const labelHasLeft = label.includes("left");
                const labelHasRight = label.includes("right");

                const areaHasFront = l.includes("front");
                const areaHasBack = l.includes("back");
                const areaHasLeft = l.includes("left");
                const areaHasRight = l.includes("right");

                if (labelHasFront || areaHasFront) return labelHasFront && areaHasFront;
                if (labelHasBack || areaHasBack) return labelHasBack && areaHasBack;
                if (labelHasLeft || areaHasLeft) return labelHasLeft && areaHasLeft;
                if (labelHasRight || areaHasRight) return labelHasRight && areaHasRight;

                // Fallback: exact label match when no standard keywords
                return l === label;
            });

            return !!(match && match.use_custom_box === true);
        },
        async getCart() {
            if (!this.currentUserClient.id) {
                this.isBusy = false;
                return Promise.resolve();
            }
            this.isBusy = true;
            return ApiService.get("/cart-new")
                .then(async ({ data }) => {
                    if (data.success == false) {
                        this._pendingAssemblyPatchAfterDelete = false;
                        this.$toast.error(data.error, {
                            position: "top-right",
                            queue: true
                        });
                        this.isBusy = false;
                        return false;
                    }

                    this.total_non_standard_fees_sp =
                        data.total_non_standard_fees_sp;
                    this.total_non_standard_fees_emb =
                        data.total_non_standard_fees_emb;
                    this.total_non_standard_colors_sp =
                        data.total_non_standard_colors_sp;
                    this.total_non_standard_colors_emb =
                        data.total_non_standard_colors_emb;

                    this.max_cart_count = parseInt(data.max_cart_count);

                    let cart_items = [];
                    let front_art_url;
                    this.total_cart_items_count = data.cart_items.length;

                    data.cart_items.forEach((item) => {
                        item.name_and_number_json = item.name_and_number_json
                            ? JSON.parse(item.name_and_number_json)
                            : [];
                        // Support both array (legacy) and object { front, back, left, right }
                        if (Array.isArray(item.name_and_number_json)) {
                            item.name_and_number_json =
                                item.name_and_number_json.filter(
                                    (nn) => nn.name != "" || nn.number
                                );
                        } else if (
                            item.name_and_number_json &&
                            typeof item.name_and_number_json === "object"
                        ) {
                            ["front", "back", "left", "right"].forEach(
                                (key) => {
                                    if (
                                        !Array.isArray(
                                            item.name_and_number_json[key]
                                        )
                                    ) {
                                        item.name_and_number_json[key] = [];
                                    }
                                }
                            );
                        }
                        this.total_design_fee += parseFloat(item.design_fee);
                        item.design_images = item.design_image
                            ? JSON.parse(item.design_image)
                            : [];

                        if (item.design_images.length > 0) {
                            item.design_image = JSON.parse(
                                item.design_image
                            )[0]["url"];
                        }

                        item.front_art_url = "";

                        if (item.design_images.length > 0) {
                            if (
                                front_art_url !=
                                item.design_images[0].design_image
                            ) {
                                item.front_art_url =
                                    item.design_images[0].design_image;
                                front_art_url = item.front_art_url;
                            }
                        }

                        item.non_standard_colors = item.non_standard_colors
                            ? JSON.parse(item.non_standard_colors)
                            : [];
                        item.decoration_colors = item.decoration_colors
                            ? JSON.parse(item.decoration_colors)
                            : [];
                        item.item_prices = item.item_prices
                            ? JSON.parse(item.item_prices)
                            : [];
                        item.location_decoration_colors =
                            item.location_decoration_colors
                                ? JSON.parse(item.location_decoration_colors)
                                : [];
                        // Parse imprint_locations with proper type checking and error handling
                        if (item.imprint_locations) {
                            if (typeof item.imprint_locations === "string") {
                                try {
                                    item.imprint_locations = JSON.parse(
                                        item.imprint_locations
                                    );
                                } catch (e) {
                                    console.error(
                                        "Error parsing imprint_locations:",
                                        e
                                    );
                                    item.imprint_locations = [];
                                }
                            }
                            // If it's already an array or object, keep it as is
                            // Ensure it's an array
                            if (!Array.isArray(item.imprint_locations)) {
                                item.imprint_locations = [];
                            }
                        } else {
                            item.imprint_locations = [];
                        }

                        // Parse decoration and setup_fees_details if they are strings
                        if (item.decoration) {
                            item.decoration =
                                typeof item.decoration === "string"
                                    ? JSON.parse(item.decoration)
                                    : item.decoration;
                        }
                        if (item.setup_fees_details) {
                            item.setup_fees_details =
                                typeof item.setup_fees_details === "string"
                                    ? JSON.parse(item.setup_fees_details)
                                    : item.setup_fees_details;
                        }

                        if (item.rush_fee_breakdown) {
                            try {
                                item.rush_fee_breakdown =
                                    typeof item.rush_fee_breakdown === "string"
                                        ? JSON.parse(item.rush_fee_breakdown)
                                        : item.rush_fee_breakdown;
                            } catch (e) {
                                console.error(
                                    "Error parsing rush_fee_breakdown:",
                                    e
                                );
                            }
                        }

                        if (item.patch_cost_details) {
                            try {
                                item.patch_cost_details =
                                    typeof item.patch_cost_details === "string"
                                        ? JSON.parse(item.patch_cost_details)
                                        : item.patch_cost_details;
                            } catch (e) {
                                item.patch_cost_details = null;
                            }
                        }

                        item.decoration_template_data =
                            this.getDecorationTemplateData(
                                item.decoration_type,
                                item.decoration_price_template
                            );
                        if (
                            (item.decoration_type == 1 ||
                                item.decoration_type == 5) &&
                            item.decoration_template_data
                        ) {
                            item.per_color_setup_cost = parseFloat(
                                item.decoration_template_data
                                    .per_color_setup_cost || 0
                            );
                        }

                        // Update global prices
                        if (
                            item.decoration_type ==
                                item.main_new_product.decoration_type &&
                            item.decoration_price_template ==
                                item.main_new_product.decoration_price_template
                        ) {
                            if (
                                item.main_new_product.decoration_price_type ==
                                "global_price"
                            ) {
                                if (
                                    (item.decoration_type == 1 ||
                                        item.decoration_type == 5) &&
                                    item.decoration_template_data
                                ) {
                                    item.price_decoration_bulk = JSON.stringify(
                                        {
                                            print_location1:
                                                item.decoration_template_data
                                                    .PrintLocation1Templates,
                                            print_location2:
                                                item.decoration_template_data
                                                    .PrintLocation2Templates
                                        }
                                    );
                                } else if (
                                    (item.decoration_type == 2 || item.decoration_type == 4) &&
                                    item.decoration_template_data
                                ) {
                                    item.price_decoration_bulk = JSON.stringify(
                                        item.decoration_template_data
                                            .EmbroideryQuantities
                                    );
                                } else if (item.decoration_type == 0) {
                                    // No decoration, no price_decoration_bulk needed
                                    item.price_decoration_bulk = null;
                                }
                            } else if (
                                item.main_new_product.decoration_price_type ==
                                "custom_price"
                            ) {
                                item.price_decoration_bulk =
                                    item.main_new_product.price_decoration_bulk;
                            }
                        }

                        item.subItems = [];

                        if (item.build_id) {
                            let itemIndex = cart_items.findIndex((element) =>
                                element.front_art_url.includes(front_art_url)
                            );
                            if (itemIndex >= 0 && cart_items[itemIndex]) {
                                cart_items[itemIndex].subItems.push(item);
                            } else {
                                cart_items.push(item);
                            }
                        } else {
                            const assemblyKey = this.getAssemblyKey(item);
                            if (assemblyKey) {
                                const assemblyIndex = cart_items.findIndex(
                                    (element) => {
                                        if (element.build_id) return false;
                                        // Match by stored group_assembly_id when both items have it
                                        if (
                                            item.group_assembly_id &&
                                            element.group_assembly_id
                                        ) {
                                            return element.group_assembly_id === item.group_assembly_id;
                                        }
                                        // Fallback: match by computed assembly key
                                        return this.getAssemblyKey(element) === assemblyKey;
                                    }
                                );
                                if (
                                    assemblyIndex >= 0 &&
                                    cart_items[assemblyIndex]
                                ) {
                                    cart_items[assemblyIndex].subItems.push(
                                        item
                                    );
                                } else {
                                    cart_items.push(item);
                                }
                                return;
                            }

                            // Group by item_id AND service for visual grouping
                            // Same product with same service shows together, different services show separately
                            // But calculations will be per-item (each subItem has its own calculation)
                            let itemIndex = cart_items.findIndex((element) => {
                                // Basic matching: item_id, decoration_type, decoration_price_template
                                if (
                                    element.item_id != item.item_id ||
                                    element.decoration_type !=
                                        item.decoration_type ||
                                    element.decoration_price_template !=
                                        item.decoration_price_template
                                ) {
                                    return false;
                                }

                                // For decoration type 0, also check master_service.id to identify the service
                                if (item.decoration_type == 0) {
                                    let elementDecoration = element.decoration;
                                    let itemDecoration = item.decoration;

                                    // Parse if string
                                    if (typeof elementDecoration === "string") {
                                        try {
                                            elementDecoration =
                                                JSON.parse(elementDecoration);
                                        } catch (e) {
                                            elementDecoration = {};
                                        }
                                    }
                                    if (typeof itemDecoration === "string") {
                                        try {
                                            itemDecoration =
                                                JSON.parse(itemDecoration);
                                        } catch (e) {
                                            itemDecoration = {};
                                        }
                                    }

                                    const elementServiceId =
                                        elementDecoration.master_service &&
                                        elementDecoration.master_service.id
                                            ? elementDecoration.master_service
                                                  .id
                                            : null;
                                    const itemServiceId =
                                        itemDecoration.master_service &&
                                        itemDecoration.master_service.id
                                            ? itemDecoration.master_service.id
                                            : null;

                                    // If both have service IDs, they must match
                                    if (
                                        elementServiceId !== null &&
                                        itemServiceId !== null
                                    ) {
                                        return (
                                            elementServiceId == itemServiceId
                                        );
                                    }

                                    // If one has ID and other doesn't, they're different services
                                    if (
                                        (elementServiceId !== null) !==
                                        (itemServiceId !== null)
                                    ) {
                                        return false;
                                    }

                                    // If neither has ID, fall back to basic matching (already matched above)
                                    return true;
                                }

                                // For other decoration types, basic matching is sufficient
                                return true;
                            });

                            if (itemIndex >= 0 && cart_items[itemIndex]) {
                                cart_items[itemIndex].subItems.push(item);
                            } else {
                                cart_items.push(item);
                            }
                        }
                    });

                    await this.applyRealtimeTemplateFees(cart_items);

                    let assemblyPatches = [];
                    if (this._pendingAssemblyPatchAfterDelete) {
                        this._pendingAssemblyPatchAfterDelete = false;
                        assemblyPatches =
                            getAssemblySetupPatchesFromMergedCart(cart_items);
                    }

                    prepareCartItemsAssemblyPlaceOrderInPlace(cart_items);
                    this.markFirstTemplateProduct(cart_items);
                    this.calculatePricing(cart_items);

                    // Enrich rush fee breakdowns with real-time vendor service prices
                    await this.enrichRushFeeBreakdowns(cart_items);
                    await this.primePatchPriceCacheForCartItems(cart_items);

                    this.cart_items = cart_items;
                    if (assemblyPatches.length > 0) {
                        try {
                            await Promise.all(
                                assemblyPatches.map((p) =>
                                    ApiService.post(
                                        "/patch-cart-setup-line",
                                        {
                                            cart_id: p.cart_id,
                                            setup_fee: p.setup_fee,
                                            setup_fees_details:
                                                p.setup_fees_details
                                        }
                                    )
                                )
                            );
                            await this.getCart();
                            return;
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.error("[AssemblyCartPatch]", e);
                        }
                    }
                    this.isBusy = false;
                })
                .catch(() => {
                    this._pendingAssemblyPatchAfterDelete = false;
                    this.isBusy = false;
                });
        },

        updateCartItem(cart_item) {
            // Store original quantities before applying temp quantities (for rollback if validation fails)
            const originalQuantities = new Map();
            cart_item.CartChildItems.forEach((childItem) => {
                originalQuantities.set(childItem.id, childItem.quantity);
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            originalQuantities.set(
                                childItem.id,
                                childItem.quantity
                            );
                        });
                    }
                });
            }

            // First, apply temporary quantities to actual quantities
            cart_item.CartChildItems.forEach((childItem) => {
                if (
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                ) {
                    childItem.quantity = childItem.tempQuantity;
                }
            });

            // Also update subItems if they exist
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                            ) {
                                childItem.quantity = childItem.tempQuantity;
                            }
                        });
                    }
                });
            }

            if (!this.validateMinQuantity(cart_item)) {
                // Revert quantities to original values if validation fails
                cart_item.CartChildItems.forEach((childItem) => {
                    if (originalQuantities.has(childItem.id)) {
                        childItem.quantity = originalQuantities.get(
                            childItem.id
                        );
                    }
                });
                if (cart_item.subItems && cart_item.subItems.length > 0) {
                    cart_item.subItems.forEach((subItem) => {
                        if (subItem.CartChildItems) {
                            subItem.CartChildItems.forEach((childItem) => {
                                if (originalQuantities.has(childItem.id)) {
                                    childItem.quantity = originalQuantities.get(
                                        childItem.id
                                    );
                                }
                            });
                        }
                    });
                }
                // Clear tempQuantity so display shows original values
                this.revertTempQuantities(cart_item);
                return;
            }

            this.isBusy = true;
            this.calculatePricing(this.cart_items);

            let params = [];
            let child_items = [];
            cart_item.CartChildItems.forEach((childItem) => {
                child_items.push({
                    id: childItem.id,
                    sub_product_id: childItem.sub_product_id,
                    case_price: childItem.case_price,
                    markup_price: childItem.markup_price,
                    markup_percentage: childItem.markup_percentage,
                    ink_price: childItem.ink_price,
                    single_location_price: childItem.single_location_price,
                    quantity: childItem.quantity || 0,
                    discount: childItem.discount || 0,
                    unit_price: childItem.unit_price || 0,
                    total_price: childItem.total_price || 0
                });
            });
            params.push({
                cart_id: cart_item.id,
                child_items: child_items,
                total_quantity: cart_item.total_quantity
            });

            // Store original quantities for rollback if API fails
            const originalQuantitiesForApi = new Map();
            cart_item.CartChildItems.forEach((childItem) => {
                originalQuantitiesForApi.set(
                    childItem.id,
                    originalQuantities.get(childItem.id)
                );
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            originalQuantitiesForApi.set(
                                childItem.id,
                                originalQuantities.get(childItem.id)
                            );
                        });
                    }
                });
            }

            ApiService.post("/update-cart", params)
                .then(({ data }) => {
                    if (!data.success) {
                        this.$toast.error(data.error, {
                            position: "top-right",
                            queue: true
                        });
                        // Revert quantities to original values if API call fails
                        cart_item.CartChildItems.forEach((childItem) => {
                            if (originalQuantitiesForApi.has(childItem.id)) {
                                childItem.quantity =
                                    originalQuantitiesForApi.get(childItem.id);
                            }
                        });
                        if (
                            cart_item.subItems &&
                            cart_item.subItems.length > 0
                        ) {
                            cart_item.subItems.forEach((subItem) => {
                                if (subItem.CartChildItems) {
                                    subItem.CartChildItems.forEach(
                                        (childItem) => {
                                            if (
                                                originalQuantitiesForApi.has(
                                                    childItem.id
                                                )
                                            ) {
                                                childItem.quantity =
                                                    originalQuantitiesForApi.get(
                                                        childItem.id
                                                    );
                                            }
                                        }
                                    );
                                }
                            });
                        }
                        // Clear tempQuantity so display shows original values
                        this.revertTempQuantities(cart_item);
                        this.isBusy = false;
                        return;
                    }
                    // Clear tempQuantity after successful update
                    this.clearTempQuantities(cart_item);
                    this.$root.$emit("update-cart");
                    this.$toast.success("Quantity updated successfully.", {
                        position: "top-right",
                        queue: true
                    });
                    cart_item.show_update_button = false;
                    this.isBusy = false;
                })
                .catch(() => {
                    // Revert quantities to original values if API call fails
                    cart_item.CartChildItems.forEach((childItem) => {
                        if (originalQuantitiesForApi.has(childItem.id)) {
                            childItem.quantity = originalQuantitiesForApi.get(
                                childItem.id
                            );
                        }
                    });
                    if (cart_item.subItems && cart_item.subItems.length > 0) {
                        cart_item.subItems.forEach((subItem) => {
                            if (subItem.CartChildItems) {
                                subItem.CartChildItems.forEach((childItem) => {
                                    if (
                                        originalQuantitiesForApi.has(
                                            childItem.id
                                        )
                                    ) {
                                        childItem.quantity =
                                            originalQuantitiesForApi.get(
                                                childItem.id
                                            );
                                    }
                                });
                            }
                        });
                    }
                    // Clear tempQuantity so display shows original values
                    this.revertTempQuantities(cart_item);
                    this.$toast.error(
                        "Something went wrong. Please contact admininstrator",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    this.isBusy = false;
                });
        },

        // Clear temporary quantities after successful update
        clearTempQuantities(cart_item) {
            cart_item.CartChildItems.forEach((childItem) => {
                childItem.tempQuantity = undefined;
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            childItem.tempQuantity = undefined;
                        });
                    }
                });
            }
        },

        // Revert temporary quantities to original values
        revertTempQuantities(cart_item) {
            cart_item.CartChildItems.forEach((childItem) => {
                if (
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                ) {
                    childItem.tempQuantity = undefined;
                }
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                            ) {
                                childItem.tempQuantity = undefined;
                            }
                        });
                    }
                });
            }
        },

        emptyAllCartItems() {
            var _this = this;
            localStorage.removeItem("cart");
            localStorage.setItem("cartNotEmpty", false);
            _this.cart_items = [];

            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                ApiService.post("/empty-cart")
                    .then(() => {
                        _this.$toast.error("Your Cart has been empty.", {
                            position: "top-right",
                            queue: true
                        });
                        _this.getCart();
                        _this.$root.$emit("update-cart");
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
            } else {
                _this.$root.$emit("update-cart");
                _this.$toast.error("Your Cart has been empty.", {
                    position: "top-right",
                    queue: true
                });
            }
        },

        deleteCartItem(cart_id) {
            this.isBusy = true;
            this._pendingAssemblyPatchAfterDelete = true;
            ApiService.post("/remove-cart", { cart_id: cart_id })
                .then(() => {
                    this.$toast.success(
                        "Item has been removed from the cart.",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    this.$root.$emit("update-cart");
                    return this.getCart();
                })
                .catch(() => {
                    this._pendingAssemblyPatchAfterDelete = false;
                    this.isBusy = false;
                });
        },

        checkout() {
            let product_names = this.cart_items
                .filter((item) => item.main_new_product.status == "Disabled")
                .map((item) => item.main_new_product.name);

            if (product_names && product_names.length > 0) {
                let str = "Item";
                if (product_names.length > 1) {
                    str = "Items";
                }
                this.$toast.error(
                    `${str} ${product_names.join(
                        ","
                    )} is no longer available, please remove it from cart`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let error = false;
            let no_quantity_error = false;
            let minimum_quantity = 0;
            this.cart_items.forEach((cart_item) => {
                minimum_quantity = this.getMinQuantity(cart_item);
                if (cart_item.build_total_quantity < minimum_quantity) {
                    error = true;
                    return;
                }
                let is_quantity_exist = cart_item.CartChildItems.find(
                    (cartChildItem) => parseInt(cartChildItem.quantity) > 0
                );
                if (!is_quantity_exist) {
                    no_quantity_error = true;
                    return;
                }
                if (cart_item.subItems) {
                    cart_item.subItems.forEach((subItem) => {
                        let is_quantity_exist = subItem.CartChildItems.find(
                            (cartChildItem) =>
                                parseInt(cartChildItem.quantity) > 0
                        );
                        if (!is_quantity_exist) {
                            no_quantity_error = true;
                            return;
                        }
                    });
                }
            });

            if (no_quantity_error == true) {
                this.$toast.error(
                    `Every Item should have atleast single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (error == true) {
                this.$toast.error(
                    `Quantity should be greater than ${minimum_quantity}`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            this.$router.push({ path: "/checkout/v3" });
        },

        openShippingPreferencesModal() {
            if (this.$refs.shippingPreferencesModal) {
                this.$refs.shippingPreferencesModal.openModal();
            }
        },

        handleShippingPreferences(preferences) {
            // Store preferences in Vuex store
            if (preferences.split_shipment) {
                this.$store.commit('splitShipment/setSplitShipment', true);
            } else {
                this.$store.commit('splitShipment/setSplitShipment', false);
            }
            
            // Store other preferences if needed
            if (preferences.kitting || preferences.special_packaging) {
                this.$store.commit('splitShipment/setPackagingOptions', {
                    boxType: preferences.special_packaging ? 'custom' : 'standard',
                    specialHandling: preferences.kitting
                });
            }
            
            // If split shipment is selected, the modal will handle navigation to checkout
        },

        onChangeQuantity(event, cartItem, size) {
            this.$set(cartItem, "show_update_button", true);
            const value = parseInt(event.target.value) || 0;

            // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
            this.$set(size, "tempQuantity", value);
        },

        incrementQuantity(event, cartItem, size) {
            try {
                this.$set(cartItem, "show_update_button", true);
                // Use tempQuantity if available, otherwise use original quantity
                const currentValue =
                    parseInt(
                        size.tempQuantity !== undefined &&
                            size.tempQuantity !== null
                            ? size.tempQuantity
                            : size.quantity
                    ) || 0;
                const newValue = currentValue + 1;

                // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
                this.$set(size, "tempQuantity", newValue);
            } catch (error) {
                console.error("Error in incrementQuantity:", error);
            }
        },

        decrementQuantity(event, cartItem, size) {
            try {
                this.$set(cartItem, "show_update_button", true);
                // Use tempQuantity if available, otherwise use original quantity
                const currentValue =
                    parseInt(
                        size.tempQuantity !== undefined &&
                            size.tempQuantity !== null
                            ? size.tempQuantity
                            : size.quantity
                    ) || 0;
                const newValue = Math.max(0, currentValue - 1);

                // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
                this.$set(size, "tempQuantity", newValue);
            } catch (error) {
                console.error("Error in decrementQuantity:", error);
            }
        },

        // Get display quantity (tempQuantity if available, otherwise original quantity)
        getDisplayQuantity(sizeItem) {
            if (
                sizeItem.tempQuantity !== undefined &&
                sizeItem.tempQuantity !== null
            ) {
                return sizeItem.tempQuantity;
            }
            return sizeItem.quantity || 0;
        },

        // Handle size input change - only update display, no validation
        onSizeInputChange(event, cartItem, sizeItem) {
            const inputValue = event.target.value;
            let value = inputValue === "" ? 0 : parseInt(inputValue);
            if (isNaN(value)) {
                value = 0;
            }
            // Only update display during typing - no validation, no update
            this.$set(sizeItem, "tempQuantity", value);
        },

        // Handle size input blur - validation and update happens here
        onSizeInputBlur(event, cartItem, sizeItem) {
            const inputValue = event.target.value;
            const inputElement = event.target;

            // Store last valid quantity if not already stored
            if (sizeItem.lastValidQuantity === undefined) {
                sizeItem.lastValidQuantity = sizeItem.quantity || 0;
            }

            // If input is empty, check if setting to 0 would keep total above minimum
            if (
                inputValue === "" ||
                inputValue === null ||
                inputValue === undefined
            ) {
                // Calculate what total would be if we set this to 0
                const getItemTotalQuantityWithZero = (
                    item,
                    isEditingThisItem
                ) => {
                    let total = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        item.CartChildItems.forEach((childItem) => {
                            if (
                                isEditingThisItem &&
                                childItem.id === sizeItem.id
                            ) {
                                total += 0; // Setting to 0
                            } else {
                                const qty =
                                    childItem.tempQuantity !== undefined &&
                                    childItem.tempQuantity !== null
                                        ? childItem.tempQuantity
                                        : childItem.quantity || 0;
                                total += qty;
                            }
                        });
                    }
                    return total;
                };

                let newGroupQuantityWithZero = 0;
                this.cart_items.forEach((item) => {
                    if (
                        this.isSameProduct(
                            item,
                            cartItem.item_id,
                            cartItem.decoration_type,
                            cartItem.decoration_price_template,
                            cartItem.build_id
                        )
                    ) {
                        newGroupQuantityWithZero +=
                            getItemTotalQuantityWithZero(
                                item,
                                item.id === cartItem.id
                            );
                    }
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            if (
                                this.isSameProduct(
                                    subItem,
                                    cartItem.item_id,
                                    cartItem.decoration_type,
                                    cartItem.decoration_price_template,
                                    cartItem.build_id
                                )
                            ) {
                                newGroupQuantityWithZero +=
                                    getItemTotalQuantityWithZero(
                                        subItem,
                                        subItem.id === cartItem.id
                                    );
                            }
                        });
                    }
                });

                const minimum_quantity = this.getMinQuantity(cartItem);

                // If setting to 0 would keep total above minimum, set to 0
                if (
                    minimum_quantity === 0 ||
                    newGroupQuantityWithZero >= minimum_quantity
                ) {
                    this.$set(sizeItem, "tempQuantity", 0);
                    sizeItem.lastValidQuantity = 0;
                    this.$nextTick(() => {
                        inputElement.value = 0;
                    });
                    // Proceed with update
                    this.isBusy = true;
                    this.updateCartItem(cartItem);
                    return;
                } else {
                    // If setting to 0 would make total below minimum, revert to last valid
                    this.$toast.error(
                        `Quantity should be greater than or equal to ${minimum_quantity}`,
                        {
                            position: "top-right",
                            queue: true,
                            timeout: 3000
                        }
                    );
                    const lastValid = sizeItem.lastValidQuantity || 0;
                    this.$set(sizeItem, "tempQuantity", lastValid);
                    this.$nextTick(() => {
                        inputElement.value = lastValid;
                    });
                    return;
                }
            }

            let finalValue = parseInt(inputValue);
            if (isNaN(finalValue)) {
                finalValue = 0;
            }

            // Validate negative values
            if (finalValue < 0) {
                const lastValid = sizeItem.lastValidQuantity || 0;
                this.$set(sizeItem, "tempQuantity", lastValid);
                this.$nextTick(() => {
                    inputElement.value = lastValid;
                });
                return;
            }

            // Check minimum quantity validation - calculate final group quantity
            const getItemTotalQuantityWithTemp = (item, isEditingThisItem) => {
                let total = 0;
                if (item.CartChildItems && item.CartChildItems.length > 0) {
                    item.CartChildItems.forEach((childItem) => {
                        if (isEditingThisItem && childItem.id === sizeItem.id) {
                            total += finalValue;
                        } else {
                            const qty =
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                                    ? childItem.tempQuantity
                                    : childItem.quantity || 0;
                            total += qty;
                        }
                    });
                }
                return total;
            };

            let newGroupQuantity = 0;
            this.cart_items.forEach((item) => {
                if (
                    this.isSameProduct(
                        item,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    )
                ) {
                    newGroupQuantity += getItemTotalQuantityWithTemp(
                        item,
                        item.id === cartItem.id
                    );
                }
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                cartItem.item_id,
                                cartItem.decoration_type,
                                cartItem.decoration_price_template,
                                cartItem.build_id
                            )
                        ) {
                            newGroupQuantity += getItemTotalQuantityWithTemp(
                                subItem,
                                subItem.id === cartItem.id
                            );
                        }
                    });
                }
            });

            // Check if other sizes in the group are being edited (have tempQuantity)
            let hasOtherPendingChanges = false;
            this.cart_items.forEach((item) => {
                if (
                    this.isSameProduct(
                        item,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    )
                ) {
                    if (item.CartChildItems) {
                        item.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.id !== sizeItem.id &&
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null &&
                                childItem.tempQuantity !== childItem.quantity
                            ) {
                                hasOtherPendingChanges = true;
                            }
                        });
                    }
                }
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                cartItem.item_id,
                                cartItem.decoration_type,
                                cartItem.decoration_price_template,
                                cartItem.build_id
                            )
                        ) {
                            if (subItem.CartChildItems) {
                                subItem.CartChildItems.forEach((childItem) => {
                                    if (
                                        childItem.id !== sizeItem.id &&
                                        childItem.tempQuantity !== undefined &&
                                        childItem.tempQuantity !== null &&
                                        childItem.tempQuantity !==
                                            childItem.quantity
                                    ) {
                                        hasOtherPendingChanges = true;
                                    }
                                });
                            }
                        }
                    });
                }
            });

            const minimum_quantity = this.getMinQuantity(cartItem);

            // Only validate minimum if no other sizes are being edited
            if (
                minimum_quantity > 0 &&
                newGroupQuantity < minimum_quantity &&
                !hasOtherPendingChanges
            ) {
                this.$toast.error(
                    `Quantity should be greater than or equal to ${minimum_quantity}`,
                    {
                        position: "top-right",
                        queue: true,
                        timeout: 3000
                    }
                );
                const lastValid = sizeItem.lastValidQuantity || 0;
                this.$set(sizeItem, "tempQuantity", lastValid);
                this.$nextTick(() => {
                    inputElement.value = lastValid;
                });
                return;
            }

            // All validations passed - update lastValidQuantity and proceed with update
            sizeItem.lastValidQuantity = finalValue;
            this.isBusy = true;
            this.updateCartItem(cartItem);
        },

        getEffectivePriceDecorationBulk(product) {
            if (!product) return null;

            let decoration = product.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    decoration = null;
                }
            }

            let bulk =
                (decoration && decoration.price_decoration_bulk) ||
                product.price_decoration_bulk ||
                (product.main_new_product &&
                    product.main_new_product.price_decoration_bulk) ||
                null;

            if (typeof bulk === "string") {
                try {
                    bulk = JSON.parse(bulk);
                } catch (e) {
                    bulk = null;
                }
            }

            return bulk;
        },

        getDecorationPrice(
            product,
            total_quantity,
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            // Decoration type 0 means no decoration, return 0
            if (product.decoration_type == 0) {
                return 0;
            }

            // let total_quantity = this.getTotalBuildQuantity();

            if (product.decoration_type == 1 || product.decoration_type == 5) {
                const bulkData = this.getEffectivePriceDecorationBulk(product);
                if (!bulkData) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = bulkData.print_location1;
                } else {
                    decoration_data = bulkData.print_location2;
                }

                if (decoration_data) {
                    for (const [index, element] of Object.entries(
                        decoration_data
                    )) {
                        if (element.quantity <= total_quantity || index == 0) {
                            qty_wise_color_price =
                                element[`colour${colorIndex + 1}`];
                        }
                    }
                }
            } else if (product.decoration_type == 2 || product.decoration_type == 4) {
                let decoration_data = this.getEffectivePriceDecorationBulk(product);
                if (!decoration_data) {
                    return 0;
                }
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(product, total_quantity, additional = false) {
            let discount = 0;

            // Decoration type 0 means no decoration, return 0
            if (product.decoration_type == 0) {
                return 0;
            }

            if (product.decoration_type == 1 || product.decoration_type == 5) {
                const bulkData = this.getEffectivePriceDecorationBulk(product);
                if (!bulkData) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = bulkData.print_location1;
                } else {
                    decoration_data = bulkData.print_location2;
                }

                if (decoration_data) {
                    for (const [index, element] of Object.entries(
                        decoration_data
                    )) {
                        if (element.quantity <= total_quantity || index == 0) {
                            discount = element["discount"];
                        }
                    }
                }
            } else if (product.decoration_type == 2 || product.decoration_type == 4) {
                let decoration_data = this.getEffectivePriceDecorationBulk(product);
                if (!decoration_data) {
                    return 0;
                }
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        getTotalItemQuantity(cartItem) {
            let total_quantity = 0;
            cartItem.CartChildItems.forEach((childItem) => {
                const qty =
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                        ? childItem.tempQuantity
                        : childItem.quantity;
                total_quantity += parseInt(qty || 0, 10);
            });
            return total_quantity;
        },
        getPatchTierForQuantity(qty) {
            const slabs = [50, 100, 250, 500, 1000, 2500, 5000];
            const n = parseInt(qty, 10) || 0;
            const found = slabs.find((s) => s >= n);
            return found != null ? found : slabs[slabs.length - 1];
        },
        getNearestPatchSlabPriceFromCache(patchPriceMap, targetSlab) {
            if (!patchPriceMap || !targetSlab) return null;
            const availableSlabs = Object.keys(patchPriceMap)
                .map((k) => Number(k))
                .filter((n) => !isNaN(n) && n > 0)
                .sort((a, b) => a - b);
            if (!availableSlabs.length) return null;
            const greaterOrEqual = availableSlabs.find((s) => s >= targetSlab);
            const usedSlab =
                greaterOrEqual != null
                    ? greaterOrEqual
                    : availableSlabs[availableSlabs.length - 1];
            return patchPriceMap[usedSlab] || null;
        },
        resolvePatchUnitPriceFromCache(
            materialId,
            patchId,
            billableQty
        ) {
            const mid = parseInt(materialId, 10) || 0;
            const pid = parseInt(patchId, 10) || 0;
            if (!mid || !pid) {
                return 0;
            }

            const byPatch = this.patchPriceCacheByMaterial[mid];
            const targetSlab = this.getPatchTierForQuantity(billableQty);
            let slabPrice = null;
            if (byPatch && byPatch[pid]) {
                slabPrice = this.getNearestPatchSlabPriceFromCache(
                    byPatch[pid],
                    targetSlab
                );
            }
            if (!slabPrice && this.patchPriceCacheByPatchId[pid]) {
                slabPrice = this.getNearestPatchSlabPriceFromCache(
                    this.patchPriceCacheByPatchId[pid],
                    targetSlab
                );
            }
            if (slabPrice && slabPrice.retail_price != null) {
                return parseFloat(slabPrice.retail_price) || 0;
            }
            return 0;
        },
        async loadPatchPricesForMaterial(materialId) {
            const mid = parseInt(materialId, 10) || 0;
            if (!mid) return;
            if (this.patchPriceCacheByMaterial[mid]) return;
            if (this.patchPriceFetchInFlight[mid]) {
                await this.patchPriceFetchInFlight[mid];
                return;
            }

            const request = ApiService.get(
                "/all-patches-with-prices?material_id=" + mid
            )
                .then(({ data }) => {
                    const byPatch = {};
                    (data.patches || []).forEach((p) => {
                        const patchKey =
                            typeof p.id === "number" ? p.id : parseInt(p.id, 10);
                        if (!patchKey) return;
                        byPatch[patchKey] = {};
                        (p.prices || []).forEach((pr) => {
                            const qtyKey = Number(pr.quantity);
                            if (!isNaN(qtyKey) && qtyKey > 0) {
                                byPatch[patchKey][qtyKey] = {
                                    retail_price:
                                        parseFloat(pr.retail_price) || 0,
                                    net_price: parseFloat(pr.net_price) || 0
                                };
                            }
                        });
                    });
                    this.$set(this.patchPriceCacheByMaterial, mid, byPatch);
                })
                .catch(() => {
                    this.$set(this.patchPriceCacheByMaterial, mid, {});
                })
                .finally(() => {
                    this.$delete(this.patchPriceFetchInFlight, mid);
                });

            this.$set(this.patchPriceFetchInFlight, mid, request);
            await request;
        },
        async loadPatchPricesByPatchId(patchId) {
            const pid = parseInt(patchId, 10) || 0;
            if (!pid) return;
            if (this.patchPriceCacheByPatchId[pid]) return;
            if (this.patchPriceByPatchFetchInFlight[pid]) {
                await this.patchPriceByPatchFetchInFlight[pid];
                return;
            }

            const request = ApiService.get("/patch/" + pid + "/prices")
                .then(({ data }) => {
                    const rows = Array.isArray(data && data.prices)
                        ? data.prices
                        : Array.isArray(data && data.patch_prices)
                        ? data.patch_prices
                        : Array.isArray(data && data.patch_price_list)
                        ? data.patch_price_list
                        : Array.isArray(data && data.rows)
                        ? data.rows
                        : [];
                    const byTier = {};
                    rows.forEach((pr) => {
                        const qtyKey = Number(pr && pr.quantity);
                        if (!isNaN(qtyKey) && qtyKey > 0) {
                            byTier[qtyKey] = {
                                retail_price:
                                    parseFloat(pr.retail_price) || 0,
                                net_price: parseFloat(pr.net_price) || 0
                            };
                        }
                    });
                    this.$set(this.patchPriceCacheByPatchId, pid, byTier);
                })
                .catch(() => {
                    this.$set(this.patchPriceCacheByPatchId, pid, {});
                })
                .finally(() => {
                    this.$delete(this.patchPriceByPatchFetchInFlight, pid);
                });

            this.$set(this.patchPriceByPatchFetchInFlight, pid, request);
            await request;
        },
        ensurePatchPriceCacheForRow(row) {
            const mid = parseInt(row && row.material_id, 10) || 0;
            const pid = parseInt(row && row.patch_id, 10) || 0;
            if (mid && !this.patchPriceCacheByMaterial[mid]) {
                this.loadPatchPricesForMaterial(mid);
            }
            if (pid && !this.patchPriceCacheByPatchId[pid]) {
                this.loadPatchPricesByPatchId(pid);
            }
        },
        async primePatchPriceCacheForCartItems(items) {
            const source = Array.isArray(items) ? items : [];
            const materialIds = new Set();
            const patchIds = new Set();
            const gather = (entry) => {
                if (!entry) return;
                let details = entry.patch_cost_details || [];
                if (typeof details === "string") {
                    try {
                        details = JSON.parse(details);
                    } catch (e) {
                        details = [];
                    }
                }
                if (Array.isArray(details)) {
                    details.forEach((row) => {
                        const mid = parseInt(row && row.material_id, 10) || 0;
                        const pid = parseInt(row && row.patch_id, 10) || 0;
                        if (mid) materialIds.add(mid);
                        if (pid) patchIds.add(pid);
                    });
                }
            };

            source.forEach((item) => {
                gather(item);
                (item.subItems || []).forEach((subItem) => gather(subItem));
            });

            await Promise.all(
                [...materialIds].map((mid) =>
                    this.loadPatchPricesForMaterial(mid)
                )
            );
            await Promise.all(
                [...patchIds].map((pid) =>
                    this.loadPatchPricesByPatchId(pid)
                )
            );
        },

        getDynamicPatchCostContext(item) {
            let details = item && item.patch_cost_details ? item.patch_cost_details : [];
            if (typeof details === "string") {
                try {
                    details = JSON.parse(details);
                } catch (e) {
                    details = [];
                }
            }
            if (!Array.isArray(details) || details.length === 0) {
                return {
                    details: [],
                    total: parseFloat((item && item.patch_cost) || 0) || 0
                };
            }

            const qty = this.getTotalItemQuantity(item);
            const billableQty = qty > 0 ? Math.max(qty, 50) : 0;
            let total = 0;

            const normalizedDetails = details.map((row) => {
                const perPatchPrice = this.resolvePatchUnitPriceFromCache(
                    row && row.material_id,
                    row && row.patch_id,
                    billableQty
                );
                const inventoryAvailable =
                    parseInt((row && row.inventory_used) || 0, 10) || 0;
                const inventorySufficientForProduct =
                    qty > 0 && inventoryAvailable >= qty;
                const inventoryUsed = inventorySufficientForProduct
                    ? qty
                    : Math.min(inventoryAvailable, billableQty);
                const chargedQty = inventorySufficientForProduct
                    ? 0
                    : Math.max(0, billableQty - inventoryUsed);
                const lineTotal = perPatchPrice * chargedQty;
                total += lineTotal;

                return {
                    ...row,
                    perPatchPrice,
                    quantity: qty,
                    totalQty: qty,
                    inventory_used: inventoryUsed,
                    charged_quantity: chargedQty,
                    total: lineTotal,
                    slab: row && row.slab != null ? row.slab : this.getPatchTierForQuantity(qty)
                };
            });
            const normalizedTotal = parseFloat(total.toFixed(2));
            return {
                details: normalizedDetails,
                total: normalizedTotal
            };
        },
        getDynamicPatchCostDetails(item) {
            return this.getDynamicPatchCostContext(item).details;
        },
        getDynamicPatchCostTotal(item) {
            return this.getDynamicPatchCostContext(item).total;
        },

        isSameProduct(
            cartItem,
            productId,
            decoration_type,
            decoration_price_template,
            build_id = null
        ) {
            if (build_id) {
                return cartItem.build_id == build_id;
            } else {
                const sameProduct = cartItem.item_id == productId;
                const sameDecorationMethod =
                    cartItem.decoration_type == decoration_type;
                const sameDecorationPriceTemplate =
                    cartItem.decoration_price_template ==
                    decoration_price_template;

                return (
                    sameProduct &&
                    sameDecorationMethod &&
                    sameDecorationPriceTemplate & !cartItem.build_id
                );
            }
        },

        getGroupQuantity(
            cart_items,
            product_id,
            decoration_type,
            decoration_price_template,
            build_id
        ) {
            let total_quantity = 0;
            cart_items.forEach((cartItem) => {
                if (
                    this.isSameProduct(
                        cartItem,
                        product_id,
                        decoration_type,
                        decoration_price_template,
                        build_id
                    )
                ) {
                    total_quantity += this.getTotalItemQuantity(cartItem);
                }
                cartItem.subItems.forEach((subItem) => {
                    if (
                        this.isSameProduct(
                            subItem,
                            product_id,
                            decoration_type,
                            decoration_price_template,
                            build_id
                        )
                    ) {
                        total_quantity += this.getTotalItemQuantity(subItem);
                    }
                });
            });

            return total_quantity;
        },
        getTierQuantityForItem(item, parentItem = null) {
            return resolveTierQuantityForItem(item, parentItem, {
                getTotalItemQuantity: this.getTotalItemQuantity.bind(this),
                isAssemblyGroup: this.isAssemblyGroup.bind(this),
                getAssemblyGroupedItems: this.getAssemblyGroupedItems.bind(this)
            });
        },

        // For sku grouping we have  item level fees if we have different template products
        // So in this case we have to show fees for first item of same template product
        // So we are marking some flag for first item
        markFirstTemplateProduct(cartItems) {
            let temp_arr = [];
            let existedData;
            cartItems.forEach((cartItem) => {
                if (cartItem.build_id) {
                    cartItem.first_item = true;
                } else if (!cartItem.build_id) {
                    if (
                        this.isSameProduct(
                            cartItem,
                            cartItem.item_id,
                            cartItem.decoration_type,
                            cartItem.decoration_price_template
                        )
                    ) {
                        existedData = temp_arr.find(
                            (d) =>
                                d.product_id == cartItem.item_id &&
                                d.decoration_type == cartItem.decoration_type &&
                                d.decoration_price_template ==
                                    cartItem.decoration_price_template
                        );
                        if (!existedData) {
                            temp_arr.push({
                                product_id: cartItem.item_id,
                                decoration_type: cartItem.decoration_type,
                                decoration_price_template:
                                    cartItem.decoration_price_template
                            });
                            cartItem.first_item = true;
                        }
                    }
                    cartItem.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                subItem.item_id,
                                subItem.decoration_type,
                                subItem.decoration_price_template
                            )
                        ) {
                            existedData = temp_arr.find(
                                (d) =>
                                    d.product_id == subItem.item_id &&
                                    d.decoration_type ==
                                        subItem.decoration_type &&
                                    d.decoration_price_template ==
                                        subItem.decoration_price_template
                            );
                            if (!existedData) {
                                temp_arr.push({
                                    product_id: subItem.item_id,
                                    decoration_type: subItem.decoration_type,
                                    decoration_price_template:
                                        subItem.decoration_price_template
                                });
                                subItem.first_item = true;
                            }
                        }
                    });
                }
            });
        },

        calculateCartItemPricing(cartItems, cartItem, decoration_color_price) {
            cartItem.total_price = 0;
            cartItem.subtotal_price = 0;
            cartItem.total_quantity = 0;
            cartItem.sp_imprint_locations = [];
            cartItem.emb_imprint_locations = [];
            cartItem.sp_decoration_colors_count = 0;
            cartItem.emb_decoration_colors_count = 0;
            cartItem.sp_decoration_colors_price = 0;
            cartItem.emb_decoration_colors_price = 0;
            cartItem.sp_setup_fee = 0;
            cartItem.emb_setup_fee = 0;
            cartItem.total_location_decoration_colors = 0;

            const quantity = this.getGroupQuantity(
                cartItems,
                cartItem.item_id,
                cartItem.decoration_type,
                cartItem.decoration_price_template,
                cartItem.build_id
            );
            if (cartItem.first_item) {
                cartItem.total_location_decoration_colors =
                    this.prepareLocationDecorationColors(
                        cartItems,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    );
                this.prepareLocations(
                    cartItem,
                    cartItem.total_location_decoration_colors
                );
                this.calculateDecorationColorsPricing(
                    quantity,
                    cartItem,
                    cartItem.main_new_product
                );
                const decorationTemplateData = this.getDecorationTemplateData(
                    cartItem.decoration_type,
                    cartItem.decoration_price_template
                );
                if (
                    cartItem.decoration_type == 1 ||
                    cartItem.decoration_type == 5
                ) {
                    cartItem.sp_setup_fee =
                        parseFloat(
                            decorationTemplateData &&
                                decorationTemplateData.per_color_setup_cost
                                ? decorationTemplateData.per_color_setup_cost
                                : 0
                        ) * cartItem.sp_decoration_colors_count;
                } else if (cartItem.decoration_type == 2 || cartItem.decoration_type == 4) {
                    cartItem.emb_setup_fee = parseFloat(
                        decorationTemplateData &&
                            decorationTemplateData.machine_fee
                            ? decorationTemplateData.machine_fee
                            : 0
                    );
                } else if (cartItem.decoration_type == 0) {
                    // No decoration, no setup fees
                    cartItem.sp_setup_fee = 0;
                    cartItem.emb_setup_fee = 0;
                }
            }

            // Updating dark/light prices if its global price
            let color_category_price = 0;
            if (
                cartItem.decoration_type ==
                    cartItem.main_new_product.decoration_type &&
                cartItem.decoration_price_template ==
                    cartItem.main_new_product.decoration_price_template
            ) {
                if (
                    cartItem.main_new_product.decoration_price_type ==
                    "global_price"
                ) {
                    const feeSource =
                        cartItem.decoration || cartItem.decoration_template_data;
                    if (feeSource) {
                        if (cartItem.Color.category == "Dark") {
                            color_category_price = parseFloat(
                                feeSource.price_dark || 0
                            );
                        } else if (cartItem.Color.category == "Light") {
                            color_category_price = parseFloat(
                                feeSource.price_light || 0
                            );
                        }
                    }
                } else if (
                    cartItem.main_new_product.decoration_price_type ==
                    "custom_price"
                ) {
                    if (cartItem.Color.category == "Dark") {
                        color_category_price =
                            cartItem.main_new_product
                                .price_color_category_dark || 0;
                    } else if (cartItem.Color.category == "Light") {
                        color_category_price =
                            cartItem.main_new_product
                                .price_color_category_light || 0;
                    }
                }
            }

            cartItem.CartChildItems.forEach((childItem) => {
                childItem.single_location_price = parseFloat(
                    decoration_color_price
                );
                childItem.decoration_discount_percentage =
                    this.getDecorationDiscount(cartItem, quantity);
                if (childItem.decoration_discount_percentage) {
                    // OLD BEHAVIOR (kept for future rollback):
                    // Discount value used only base/case price.
                    // childItem.decoration_discount_value =
                    //     (this.icPriceFormat(childItem.case_price, true) *
                    //         childItem.decoration_discount_percentage) /
                    //     100;
                    // Discount value should reflect combined Product Base Price.
                    const combinedUnitBeforeDiscount =
                        parseFloat(childItem.case_price || 0) +
                        parseFloat(this.getChildMarkupPrice(cartItem, childItem) || 0) +
                        parseFloat(decoration_color_price || 0) +
                        parseFloat(color_category_price || 0);
                    childItem.decoration_discount_value =
                        (this.icPriceFormat(combinedUnitBeforeDiscount, true) *
                            childItem.decoration_discount_percentage) /
                        100;
                }
                childItem.ink_price = color_category_price;
                childItem.unit_price = this.getRetailPrice({
                    base_price: parseFloat(childItem.case_price),
                    markup_price: parseFloat(
                        this.getChildMarkupPrice(cartItem, childItem)
                    ),
                    single_location_price: parseFloat(
                        childItem.single_location_price || 0
                    ),
                    color_category_price: childItem.ink_price,
                    decoration_discount_percentage:
                        childItem.decoration_discount_percentage
                });

                // Apply product discount to computed unit_price (for backend payload)
                childItem.unit_price = this.applyDiscountToSizeCost(
                    childItem.unit_price,
                    cartItem
                );

                childItem.total_price =
                    this.icPriceFormat(childItem.unit_price, true) *
                    parseInt(childItem.quantity);
                cartItem.subtotal_price += parseFloat(childItem.total_price);
                cartItem.total_quantity += parseInt(childItem.quantity);
            });
            const nameNumberFeesTotal = this.getItemPricesNameNumberTotal(
                cartItem.item_prices
            );
            cartItem.total_price =
                parseFloat(cartItem.subtotal_price) + nameNumberFeesTotal;

            if (cartItem.first_item && !cartItem.build_id) {
                cartItem.total_price += this.getAdditionalFees(cartItem);
            }
        },

        prepareLocationDecorationColors(
            cart_items,
            product_id,
            decoration_type,
            decoration_price_template,
            build_id
        ) {
            let total_location_decoration_colors = {
                front: [],
                back: [],
                left: [],
                right: []
            };
            cart_items.forEach((cartItem) => {
                if (
                    this.isSameProduct(
                        cartItem,
                        product_id,
                        decoration_type,
                        decoration_price_template,
                        build_id
                    )
                ) {
                    total_location_decoration_colors =
                        cartItem.location_decoration_colors;
                }
                cartItem.subItems.forEach((subItem) => {
                    if (
                        this.isSameProduct(
                            subItem,
                            product_id,
                            decoration_type,
                            decoration_price_template,
                            build_id
                        )
                    ) {
                        total_location_decoration_colors.front = [
                            ...new Set(
                                total_location_decoration_colors.front.concat(
                                    subItem.location_decoration_colors.front
                                )
                            )
                        ];
                        total_location_decoration_colors.back = [
                            ...new Set(
                                total_location_decoration_colors.back.concat(
                                    subItem.location_decoration_colors.back
                                )
                            )
                        ];
                        total_location_decoration_colors.left = [
                            ...new Set(
                                total_location_decoration_colors.left.concat(
                                    subItem.location_decoration_colors.left
                                )
                            )
                        ];
                        total_location_decoration_colors.right = [
                            ...new Set(
                                total_location_decoration_colors.right.concat(
                                    subItem.location_decoration_colors.right
                                )
                            )
                        ];
                    }
                });
            });
            return total_location_decoration_colors;
        },

        // This function calculate prices for all cart items
        calculatePricing(cart_items) {
            try {
                let quantity = 0;
                cart_items.forEach((cartItem) => {
                    quantity = this.getGroupQuantity(
                        cart_items,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    );
                    this.calculateCartItemPricing(
                        cart_items,
                        cartItem,
                        this.getDecorationPrice(cartItem, quantity)
                    );

                    // Calculate build_total_price using getItemSubTotal for accurate calculation
                    // Note: getItemSubTotal already includes all fees (base fee, run charge, setup fee, custom color fee, name/number fees)
                    // So we don't need to add getAdditionalFees separately as it would cause double-counting
                    cartItem.build_total_price = this.getItemSubTotal(cartItem);

                    // Calculate subtotals for sub-items
                    cartItem.subItems.forEach((subItem) => {
                        quantity = this.getGroupQuantity(
                            cart_items,
                            subItem.item_id,
                            subItem.decoration_type,
                            subItem.decoration_price_template,
                            cartItem.build_id
                        );
                        this.calculateCartItemPricing(
                            cart_items,
                            subItem,
                            this.getDecorationPrice(subItem, quantity)
                        );
                        // Add sub-item subtotal to main item's build_total_price
                        cartItem.build_total_price +=
                            this.getItemSubTotal(subItem, cartItem);
                    });
                });
                // Note: grand_total is now a computed property that automatically calculates from cart_subtotal
            } catch (error) {
                console.log(error);
            }
        },

        getItemPricesNameNumberTotal(itemPrices) {
            if (!itemPrices) return 0;
            const ip = itemPrices;
            const flat =
                parseFloat(ip.front_number_fees || 0) +
                parseFloat(ip.front_name_fees || 0) +
                parseFloat(ip.back_name_fees || 0) +
                parseFloat(ip.back_number_fees || 0) +
                parseFloat(ip.left_name_fees || 0) +
                parseFloat(ip.left_number_fees || 0) +
                parseFloat(ip.right_name_fees || 0) +
                parseFloat(ip.right_number_fees || 0) +
                parseFloat(ip.front_number_decor_up_fees || 0) +
                parseFloat(ip.front_name_decor_up_fees || 0) +
                parseFloat(ip.back_name_decor_up_fees || 0) +
                parseFloat(ip.back_number_decor_up_fees || 0);
            if (flat > 0) return flat;
            const snn = ip.selected_name_number;
            if (!snn) return 0;
            let total = 0;
            ["front", "back", "left", "right"].forEach((loc) => {
                const locObj = snn[loc];
                if (!locObj) return;
                if (locObj.name && typeof locObj.name === "object") {
                    total += parseFloat(locObj.name[loc + "_name_fees"] || 0);
                    total += parseFloat(
                        locObj.name[loc + "_name_decor_up_fees"] || 0
                    );
                }
                if (locObj.number && typeof locObj.number === "object") {
                    total += parseFloat(
                        locObj.number[loc + "_number_fees"] || 0
                    );
                    total += parseFloat(
                        locObj.number[loc + "_number_decor_up_fees"] || 0
                    );
                }
            });
            return total;
        },

        getAdditionalFees(cart_item) {
            // Use setup fee total from setup_fees_details if available, otherwise fallback to sp_setup_fee + emb_setup_fee
            let setupFeeTotal = 0;
            if (cart_item.setup_fees_details) {
                setupFeeTotal = this.getSetupFeeTotal(cart_item);
            } else {
                setupFeeTotal =
                    parseFloat(cart_item.sp_setup_fee || 0) +
                    parseFloat(cart_item.emb_setup_fee || 0);
            }

            // For decoration type 0, use run charge from breakdown
            let runCharge = 0;
            if (cart_item.decoration_type == 0) {
                runCharge = this.getRunChargeTotalFromBreakdown(cart_item);
            } else {
                runCharge =
                    parseFloat(cart_item.sp_decoration_colors_price || 0) +
                    parseFloat(cart_item.emb_decoration_colors_price || 0);
            }

            return runCharge + setupFeeTotal;
        },

        getMinQuantity(cart_item) {
            let price_decoration_bulk = null;

            // Parse price_decoration_bulk if it's a string
            if (cart_item.price_decoration_bulk) {
                if (typeof cart_item.price_decoration_bulk === "string") {
                    try {
                        price_decoration_bulk = JSON.parse(
                            cart_item.price_decoration_bulk
                        );
                    } catch (e) {
                        console.error(
                            "Error parsing price_decoration_bulk:",
                            e
                        );
                        price_decoration_bulk = null;
                    }
                } else {
                    price_decoration_bulk = cart_item.price_decoration_bulk;
                }
            }

            // If price_decoration_bulk is not available, try to get from main_new_product
            if (
                !price_decoration_bulk &&
                cart_item.main_new_product &&
                cart_item.main_new_product.price_decoration_bulk
            ) {
                if (
                    typeof cart_item.main_new_product.price_decoration_bulk ===
                    "string"
                ) {
                    try {
                        price_decoration_bulk = JSON.parse(
                            cart_item.main_new_product.price_decoration_bulk
                        );
                    } catch (e) {
                        console.error(
                            "Error parsing main_new_product.price_decoration_bulk:",
                            e
                        );
                    }
                } else {
                    price_decoration_bulk =
                        cart_item.main_new_product.price_decoration_bulk;
                }
            }

            let minimum_quantity = 0;

            // Simple logic: Get first tier quantity from price_decoration_bulk
            if (price_decoration_bulk) {
                // If it's an array, get first element's quantity
                if (
                    Array.isArray(price_decoration_bulk) &&
                    price_decoration_bulk.length > 0
                ) {
                    minimum_quantity =
                        price_decoration_bulk[0].quantity ||
                        price_decoration_bulk[0].quantity1 ||
                        0;
                }
                // If it's an object with print_location1 (decoration_type 1)
                else if (
                    price_decoration_bulk.print_location1 &&
                    Array.isArray(price_decoration_bulk.print_location1) &&
                    price_decoration_bulk.print_location1.length > 0
                ) {
                    minimum_quantity =
                        price_decoration_bulk.print_location1[0].quantity || 0;
                }
            }

            return minimum_quantity;
        },

        validateMinQuantity(cart_item) {
            let minimum_quantity = this.getMinQuantity(cart_item);

            let total_quantity = this.getGroupQuantity(
                this.cart_items,
                cart_item.item_id,
                cart_item.decoration_type,
                cart_item.decoration_price_template,
                cart_item.build_id
            );
            if (total_quantity < minimum_quantity) {
                this.$toast.error(
                    `Quantity should be greater than ${minimum_quantity}`,
                    { position: "top-right", queue: true }
                );
                return false;
            }
            return true;
        },

        productColors(child_items) {
            if (child_items.length == 0) {
                return;
            }
            let color = child_items;
            let style = color.swatches
                ? "background-image:url(" + color.swatches + ")"
                : " background-color:" + color.hex;
            let html =
                `<a href="javascript:void(0)" class="color_circle mr_16 bg_secondary_black " style="` +
                style +
                `"></a><p>` +
                this.converToCamel(color.name) +
                `</p>`;
            return html;
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        isTShirt24HourItem(item) {
            return isTShirt24HourFromItem(item);
        },
        getCartSizeAbbreviation(sizeItem) {
            const sizeObj =
                sizeItem &&
                sizeItem.main_new_sub_product &&
                sizeItem.main_new_sub_product.Size
                    ? sizeItem.main_new_sub_product.Size
                    : null;
            if (!sizeObj) return "";
            const raw = sizeObj.size_name || sizeObj.size || sizeObj.name || "";
            return String(raw).trim().toUpperCase();
        },
        getSortedCartSizeItems(item) {
            const sizeItems =
                item && Array.isArray(item.CartChildItems)
                    ? item.CartChildItems.filter(
                          (si) =>
                              si &&
                              si.main_new_sub_product &&
                              si.main_new_sub_product.Size
                      )
                    : [];
            if (!this.isTShirt24HourItem(item)) {
                return sizeItems;
            }

            const sizeOrder = [
                "2XS",
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL"
            ];
            const orderMap = sizeOrder.reduce((acc, size, idx) => {
                acc[size] = idx;
                return acc;
            }, {});

            return sizeItems.slice().sort((a, b) => {
                const aSize = this.getCartSizeAbbreviation(a);
                const bSize = this.getCartSizeAbbreviation(b);
                const aRank =
                    orderMap[aSize] !== undefined
                        ? orderMap[aSize]
                        : Number.MAX_SAFE_INTEGER;
                const bRank =
                    orderMap[bSize] !== undefined
                        ? orderMap[bSize]
                        : Number.MAX_SAFE_INTEGER;

                if (aRank !== bRank) return aRank - bRank;
                return aSize.localeCompare(bSize);
            });
        },

        haveRushFee(item) {
            if (item.t_shirt_24_hour) {
                return true;
            }
            let child_item = item.subItems.find(
                (subitem) => subitem.t_shirt_24_hour
            );
            if (child_item) {
                return true;
            }

            return false;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                // OLD BEHAVIOR (kept for future rollback):
                // Discount applied only on single_location_price portion.
                // let decoration_discount_value =
                //     (this.icPriceFormat(
                //         parseFloat(prices.single_location_price),
                //         true
                //     ) *
                //         parseFloat(prices.decoration_discount_percentage)) /
                //     100;
                // item_price -= parseFloat(decoration_discount_value);

                // Apply template discount on combined Product Base Price.
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        shouldShowNameNumbersForChild(childItem, parentItem) {
            const isAssemblyWithMultipleItems =
                parentItem &&
                this.isAssemblyGroup(parentItem) &&
                this.getAssemblyProductCount(parentItem) > 1;

            if (isAssemblyWithMultipleItems) {
                return (
                    this.hasNameNumberData(parentItem.name_and_number_json) ||
                    this.hasNameNumberData(
                        childItem && childItem.name_and_number_json
                    )
                );
            }

            return this.hasNameNumberData(
                childItem && childItem.name_and_number_json
            );
        },

        openNameNumbersModal(cartItem, parentItem = null) {
            this.name_and_number_json = {
                front: [],
                back: [],
                left: [],
                right: []
            };
            const isAssemblyWithMultipleItems =
                parentItem &&
                this.isAssemblyGroup(parentItem) &&
                this.getAssemblyProductCount(parentItem) > 1;
            const sourceItem = isAssemblyWithMultipleItems ? parentItem : cartItem;
            const nnJson = sourceItem && sourceItem.name_and_number_json;
            // selected_name_number lives inside name_and_number_json (no extra column)
            const parsed = nnJson && typeof nnJson === "string" ? (() => { try { return JSON.parse(nnJson); } catch (e) { return nnJson; } })() : nnJson;
            this.selected_name_number = (parsed && parsed.selected_name_number) || {};
            if (!this.selected_name_number.front)
                this.selected_name_number.front = {};
            if (!this.selected_name_number.back)
                this.selected_name_number.back = {};
            if (!this.selected_name_number.left)
                this.selected_name_number.left = {};
            if (!this.selected_name_number.right)
                this.selected_name_number.right = {};
            const snn = this.selected_name_number;
            const hasLoc = (loc) => snn[loc] && (snn[loc].name === true || snn[loc].number === true);
            // Support object format { front, back, left, right [, selected_name_number ] } and legacy array
            if (
                nnJson &&
                typeof nnJson === "object" &&
                !Array.isArray(nnJson)
            ) {
                const arr = (key) => (Array.isArray(parsed[key]) ? parsed[key] : []);
                this.name_and_number_json.front = hasLoc("front") ? arr("front") : [];
                this.name_and_number_json.back = hasLoc("back") ? arr("back") : [];
                this.name_and_number_json.left = hasLoc("left") ? arr("left") : [];
                this.name_and_number_json.right = hasLoc("right") ? arr("right") : [];
            } else if (Array.isArray(nnJson)) {
                const hasData = (nn) =>
                    (nn &&
                        nn.name != null &&
                        String(nn.name).trim() !== "") ||
                    (nn.number != null && nn.number !== "");
                const filtered = nnJson.filter(hasData);
                if (
                    this.selected_name_number.front &&
                    (this.selected_name_number.front.name ||
                        this.selected_name_number.front.number)
                ) {
                    this.name_and_number_json.front = filtered;
                }
                if (
                    this.selected_name_number.back &&
                    (this.selected_name_number.back.name ||
                        this.selected_name_number.back.number)
                ) {
                    this.name_and_number_json.back = filtered;
                }
                if (
                    this.selected_name_number.left &&
                    (this.selected_name_number.left.name ||
                        this.selected_name_number.left.number)
                ) {
                    this.name_and_number_json.left = filtered;
                }
                if (
                    this.selected_name_number.right &&
                    (this.selected_name_number.right.name ||
                        this.selected_name_number.right.number)
                ) {
                    this.name_and_number_json.right = filtered;
                }
            }
            const imprintKeys = this.getImprintLocationKeysForNameNumberModal(
                sourceItem || cartItem
            );
            const useKeys =
                imprintKeys.size > 0 ? imprintKeys : new Set(["front"]);
            this.nameNumberAllowedImprints = {
                front: useKeys.has("front"),
                back: useKeys.has("back"),
                left: useKeys.has("left"),
                right: useKeys.has("right")
            };
            /* eslint-disable */
            $("#nameNumbersModal").modal("show");
            /* eslint-enable */
        },

        hasNameNumberData(nameAndNumberJson) {
            if (!nameAndNumberJson) return false;
            if (Array.isArray(nameAndNumberJson))
                return nameAndNumberJson.length > 0;
            if (typeof nameAndNumberJson === "object") {
                const keys = ["front", "back", "left", "right"];
                return keys.some(
                    (k) =>
                        Array.isArray(nameAndNumberJson[k]) &&
                        nameAndNumberJson[k].length > 0
                );
            }
            return false;
        },

        prepareLocations(cartData, decorationColors) {
            // Decoration type 0 - PCNA: prepare imprint_locations for run charge calculation
            if (cartData.decoration_type == 0) {
                cartData.sp_imprint_locations = [];
                cartData.emb_imprint_locations = [];

                // For decoration type 0, we still need imprint_locations for run charge
                // The imprint_locations should already be set from the cart data
                // Just ensure it's an array
                if (
                    !cartData.imprint_locations ||
                    !Array.isArray(cartData.imprint_locations)
                ) {
                    cartData.imprint_locations = [];
                }
                return;
            }

            const non_standard_color_obj = JSON.parse(
                JSON.stringify(this.nonStandardColorObj)
            );
            /* eslint-disable */
            let no_of_colors = 0;
            /* eslint-enable */
            let colors_type = "";
            if (cartData.decoration_type == 1 || cartData.decoration_type == 5) {
                colors_type = "ink";
                non_standard_color_obj.non_standard_fee =
                    this.non_standard_fees["sp"];
            } else if (cartData.decoration_type == 2 || cartData.decoration_type == 4) {
                colors_type = "thread";
                non_standard_color_obj.non_standard_fee =
                    this.non_standard_fees["emb"];
            }
            let vendor_colors_list = this.getVendorData(
                cartData.main_new_product.default_decorator_id,
                colors_type
            );

            if (
                !cartData.imprint_locations ||
                !Array.isArray(cartData.imprint_locations)
            ) {
                cartData.imprint_locations = [];
            }

            cartData.imprint_locations.forEach((location) => {
                // Preserve existing colors if they already exist and have proper structure
                const hasExistingColors =
                    location.colors &&
                    Array.isArray(location.colors) &&
                    location.colors.length > 0;
                const hasValidColorStructure =
                    hasExistingColors &&
                    location.colors.some(
                        (c) =>
                            c.color &&
                            (c.color.color_id !== undefined ||
                                c.color.color_name)
                    );

                // Only rebuild colors if they don't exist or don't have proper structure
                if (!hasValidColorStructure) {
                    location.colors = [];
                    location.no_of_color = 0;
                    if (decorationColors[location.location.toLowerCase()]) {
                        decorationColors[
                            location.location.toLowerCase()
                        ].forEach((colorHex) => {
                            let vendorColor = vendor_colors_list.find(
                                (vendColor) =>
                                    vendColor.color_value.toLowerCase() ==
                                    colorHex.toLowerCase()
                            );
                            location.colors.push({
                                color: vendorColor || non_standard_color_obj,
                                total_decor_upcharge: 0
                            });
                        });

                        location.no_of_color =
                            decorationColors[
                                location.location.toLowerCase()
                            ].length;
                    }
                } else {
                    // Preserve existing colors, just ensure no_of_color is set correctly
                    if (
                        location.no_of_color === undefined ||
                        location.no_of_color === null
                    ) {
                        location.no_of_color = location.colors.length;
                    }
                }
                location.price = 0;
                location.total_decoration_fee = 0;
                location.total_price = 0;
                if (location.no_of_color) {
                    no_of_colors += parseInt(location.no_of_color || 0);
                }

                if (
                    cartData.decoration_type == 1 ||
                    cartData.decoration_type == 5
                ) {
                    cartData.sp_imprint_locations.push(location);
                    cartData.sp_decoration_colors_count += parseInt(
                        location.no_of_color || 0
                    );
                } else if (cartData.decoration_type == 2 || cartData.decoration_type == 4) {
                    cartData.emb_imprint_locations.push(location);
                    cartData.emb_decoration_colors_count += parseInt(
                        location.no_of_color || 0
                    );
                }
            });
        },

        calculateDecorationColorsPricing(total_quantity, cartData) {
            // Decoration type 0 means no decoration, set prices to 0
            if (cartData.decoration_type == 0) {
                cartData.sp_decoration_colors_price = 0;
                cartData.emb_decoration_colors_price = 0;
                return;
            }

            let imprint_locations_price = 0;
            let initialLocationIndex = 0;
            /* eslint-disable */
            let total_location_fee = 0;
            /* eslint-enable */
            if (cartData.decoration_type == 1 || cartData.decoration_type == 5) {
                if (
                    !cartData.sp_imprint_locations ||
                    !Array.isArray(cartData.sp_imprint_locations)
                ) {
                    cartData.sp_imprint_locations = [];
                }
                cartData.sp_imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initialLocationIndex == 0 && no_of_colors == 1) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = this.getDecorationPrice(
                                cartData,
                                total_quantity,
                                no_of_colors - 1,
                                undefined,
                                initialLocationIndex > 0
                            );
                            let color1_decoration_price =
                                this.getDecorationPrice(
                                    cartData,
                                    total_quantity,
                                    0,
                                    undefined,
                                    initialLocationIndex > 0
                                );
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            if (
                                initialLocationIndex == 0 &&
                                location.decoration_fee > 0
                            ) {
                                location.decoration_fee =
                                    parseFloat(location.decoration_fee) -
                                    parseFloat(color1_decoration_price);
                            }
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_quantity;
                        }

                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((color) => {
                                if (color.color) {
                                    color.total_decor_upcharge =
                                        parseFloat(
                                            color.color.decor_upcharge || 0
                                        ) * total_quantity;
                                    total_location_fee += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                    imprint_locations_price += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                }
                            });
                        }
                        imprint_locations_price +=
                            location.total_decoration_fee;
                        initialLocationIndex++;
                    }
                });
                cartData.sp_decoration_colors_price = imprint_locations_price;
            } else if (cartData.decoration_type == 2 || cartData.decoration_type == 4) {
                if (
                    !cartData.emb_imprint_locations ||
                    !Array.isArray(cartData.emb_imprint_locations)
                ) {
                    cartData.emb_imprint_locations = [];
                }
                cartData.emb_imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initialLocationIndex == 0) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = 0;
                            if (no_of_colors > 0) {
                                decoration_price = this.getDecorationPrice(
                                    cartData,
                                    total_quantity,
                                    0,
                                    initialLocationIndex
                                );
                            }
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_quantity;
                        }

                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((color) => {
                                if (color.color) {
                                    color.total_decor_upcharge =
                                        parseFloat(
                                            color.color.decor_upcharge || 0
                                        ) * total_quantity;
                                    total_location_fee += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                    imprint_locations_price += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                }
                            });
                        }
                        imprint_locations_price +=
                            location.total_decoration_fee;
                        initialLocationIndex++;
                    }
                });
                cartData.emb_decoration_colors_price = imprint_locations_price;
            }

            return imprint_locations_price;
        },

        getVendorsList() {
            return new Promise((resolve, reject) => {
                ApiService.get(`/vendors`)
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.vendors_list = data.vendors;
                        resolve(data.vendors);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getVendorData(vendor_id, colors_type) {
            let vendor_data = this.vendors_list.find(
                (vendor) => vendor.id == vendor_id
            );
            let colors_json = vendor_data.vendor_colors
                ? JSON.parse(vendor_data.vendor_colors)
                : {};
            return colors_json[`color_data_for_${colors_type}`];
        },

        getDecorationMethod(item) {
            if (item.DecorationMethod) {
                return item.DecorationMethod.name;
            }

            return "";
        },

        getDecorationTemplateData(decorationType, decorationTemplateId) {
            // Decoration type 0 means no decoration, return null
            if (decorationType == 0) {
                return null;
            }

            let decorationTemplate;

            if (decorationType == 1) {
                decorationTemplate = this.printTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            } else if (decorationType == 2 || decorationType == 4) {
                const templateList =
                    decorationType == 4
                        ? this.patchTemplates
                        : this.embroideryTemplates;
                decorationTemplate = templateList.find(
                    (temp) => temp.id == decorationTemplateId
                );
            }

            return decorationTemplate;
        },
        getRealtimeTemplateEndpoint(decorationType, templateId) {
            if (!templateId) return null;
            if (decorationType == 1) return `/printtemplate/${templateId}`;
            if (decorationType == 5) return `/dtf-template/${templateId}`;
            if (decorationType == 2) return `/embroidery/${templateId}`;
            if (decorationType == 4) return `/patch-application/${templateId}`;
            return null;
        },
        normalizeRealtimeTemplateFees(responseData, decorationType) {
            if (!responseData || typeof responseData !== "object") return null;
            let detail = null;
            if (decorationType == 1 || decorationType == 5) {
                detail = responseData.templatedetail || null;
            } else if (decorationType == 2) {
                detail = responseData.embroiderydetail || null;
            } else if (decorationType == 4) {
                detail = responseData.patch_application_detail || null;
            }
            if (!detail) return null;
            return {
                price_dark: parseFloat(detail.price_dark || 0),
                price_light: parseFloat(detail.price_light || 0)
            };
        },
        async fetchRealtimeTemplateFees(decorationType, templateId) {
            const key = `${decorationType}:${templateId}`;
            if (this.realtimeTemplateFeeCache[key]) {
                return this.realtimeTemplateFeeCache[key];
            }
            const endpoint = this.getRealtimeTemplateEndpoint(
                decorationType,
                templateId
            );
            if (!endpoint) return null;
            try {
                const { data } = await ApiService.get(endpoint);
                const fees = this.normalizeRealtimeTemplateFees(
                    data,
                    decorationType
                );
                if (fees) {
                    this.$set(this.realtimeTemplateFeeCache, key, fees);
                }
                return fees;
            } catch (e) {
                return null;
            }
        },
        async applyRealtimeTemplateFees(cartItems) {
            if (!Array.isArray(cartItems) || cartItems.length === 0) return;
            const tasks = [];

            cartItems.forEach((item) => {
                const useTemplatePricing =
                    (item.main_new_product &&
                        item.main_new_product.decoration_price_type ===
                            "global_price") ||
                    (item.decoration &&
                        (item.decoration.use_imprintcity_price_template === 1 ||
                            item.decoration.use_imprintcity_price_template ===
                                "1"));
                if (
                    !item ||
                    !useTemplatePricing ||
                    (item.decoration_type != 1 &&
                        item.decoration_type != 5 &&
                        item.decoration_type != 2 &&
                        item.decoration_type != 4) ||
                    !item.decoration_price_template
                ) {
                    return;
                }

                tasks.push(
                    this.fetchRealtimeTemplateFees(
                        item.decoration_type,
                        item.decoration_price_template
                    ).then((fees) => {
                        if (!fees) return;
                        if (
                            item.decoration_template_data &&
                            typeof item.decoration_template_data === "object"
                        ) {
                            item.decoration_template_data.price_dark =
                                fees.price_dark;
                            item.decoration_template_data.price_light =
                                fees.price_light;
                        }
                        if (!item.decoration || typeof item.decoration !== "object") {
                            item.decoration = {};
                        }
                        item.decoration.price_dark = fees.price_dark;
                        item.decoration.price_light = fees.price_light;
                    })
                );
            });

            if (tasks.length > 0) {
                await Promise.all(tasks);
            }
        },

        showDecorationTemplateName(decorationType, decorationTemplateId) {
            let template_name = "";
            let decorationTemplate;
            if (decorationType == 1) {
                decorationTemplate = this.printTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            } else if (decorationType == 2 || decorationType == 4) {
                const templateList =
                    decorationType == 4
                        ? this.patchTemplates
                        : this.embroideryTemplates;
                decorationTemplate = templateList.find(
                    (temp) => temp.id == decorationTemplateId
                );
            }
            if (decorationTemplate) {
                template_name = decorationTemplate.name;
            }

            return template_name;
        },

        // Function not required
        calcPrices(parent_product, parent) {
            // console.log('calcPrices', parent, parent_product)
            let total_quantity = this.getGroupTotalQuantity(
                parent,
                parent_product
            );

            let color_category_price = 0;
            if (parent_product.Color.category == "Dark") {
                color_category_price =
                    parent_product.product.price_color_category_dark;
                parent_product.total_dark_category_fee =
                    parseInt(parent_product.total_quantity) *
                    parseFloat(color_category_price);
            } else if (parent_product.Color.category == "Light") {
                color_category_price =
                    parent_product.product.price_color_category_light;
                parent_product.total_light_category_fee =
                    parseInt(parent_product.total_quantity) *
                    parseFloat(color_category_price);
            }

            let qty_wise_color_price = this.getDecorationColorPrice(
                parent_product,
                total_quantity
            );

            if (parent_product.build_id) {
                if (parent == "parent") {
                    parent_product.total_quantity = 0;
                    parent_product.total_price = 0;
                    parent_product.subtotal_price = 0;
                    // parent_product.total_imprint_locations_price = 0;
                    parent_product.CartChildItems.forEach((item) => {
                        item.ink_price = parseFloat(color_category_price);
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(
                                this.getChildMarkupPrice(parent_product, item)
                            ) +
                            parseFloat(color_category_price) +
                            parseFloat(item.single_location_price);

                        // Apply product discount to unit_price (for backend payload)
                        item.unit_price = this.applyDiscountToSizeCost(
                            item.unit_price,
                            parent_product
                        );

                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent_product.total_quantity += parseInt(
                            item.quantity
                        );
                        parent_product.total_price += parseFloat(
                            item.total_price
                        );
                        parent_product.subtotal_price += parseFloat(
                            item.total_price
                        );
                    });

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;
                    parent_product.subItems.forEach((subItem) => {
                        subItem.total_quantity = 0;
                        subItem.total_price = 0;
                        subItem.subtotal_price = 0;
                        subItem.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(
                                    this.getChildMarkupPrice(subItem, item)
                                ) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            subItem.total_quantity += parseInt(item.quantity);
                            subItem.total_price += parseFloat(item.total_price);
                            subItem.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(
                            parent_product,
                            subItem,
                            total_quantity
                        );

                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    parent.total_quantity = 0;
                    parent.total_price = 0;
                    parent.subtotal_price = 0;
                    // parent.total_imprint_locations_price = 0;
                    parent.CartChildItems.forEach((item) => {
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(
                                this.getChildMarkupPrice(parent, item)
                            ) +
                            parseFloat(color_category_price) +
                            parseFloat(item.single_location_price);
                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent.total_quantity += parseInt(item.quantity);
                        parent.total_price += parseFloat(item.total_price);
                        parent.subtotal_price += parseFloat(item.total_price);
                    });

                    this.calcAdditionalFees(parent, parent, total_quantity);

                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        subItem.total_quantity = 0;
                        subItem.total_price = 0;
                        subItem.subtotal_price = 0;
                        subItem.CartChildItems.forEach((item) => {
                            if (parent_product.id == subItem.id) {
                                item.ink_price =
                                    parseFloat(color_category_price);
                            }
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(
                                    this.getChildMarkupPrice(subItem, item)
                                ) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);

                            // Apply product discount to unit_price (for backend payload)
                            item.unit_price = this.applyDiscountToSizeCost(
                                item.unit_price,
                                subItem
                            );

                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            subItem.total_quantity += parseInt(item.quantity);
                            subItem.total_price += parseFloat(item.total_price);
                            subItem.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(
                            parent,
                            subItem,
                            total_quantity
                        );

                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            } else if (parent_product.artwork) {
                let artwork = parent_product.artwork;
                parent_product.total_quantity = 0;
                parent_product.total_price = 0;
                parent_product.subtotal_price = 0;
                if (parent == "parent") {
                    parent_product.CartChildItems.forEach((item) => {
                        item.ink_price = parseFloat(color_category_price);
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        // console.log(item.case_price, item.markup_price, item.ink_price,item.single_location_price )
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(
                                this.getChildMarkupPrice(parent_product, item)
                            ) +
                            parseFloat(item.ink_price) +
                            parseFloat(item.single_location_price);
                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent_product.total_quantity += parseInt(
                            item.quantity
                        );
                        parent_product.total_price += parseFloat(
                            item.total_price
                        );
                        parent_product.subtotal_price += parseFloat(
                            item.total_price
                        );
                    });

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;

                    parent_product.subItems.forEach((subItem) => {
                        if (subItem.artwork == artwork) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(
                                        this.getChildMarkupPrice(subItem, item)
                                    ) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent_product,
                                subItem,
                                total_quantity
                            );

                            // TOTAL BUILD
                        }
                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    if (parent.artwork == artwork) {
                        parent.total_quantity = 0;
                        parent.total_price = 0;
                        parent.subtotal_price = 0;
                        parent.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(
                                    this.getChildMarkupPrice(parent, item)
                                ) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent.total_quantity += parseInt(item.quantity);
                            parent.total_price += parseFloat(item.total_price);
                            parent.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(parent, parent, total_quantity);

                        // TOTAL BUILD
                    }
                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        if (subItem.artwork == artwork) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                if (parent_product.id == subItem.id) {
                                    item.ink_price =
                                        parseFloat(color_category_price);
                                }
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(
                                        this.getChildMarkupPrice(subItem, item)
                                    ) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent,
                                subItem,
                                total_quantity
                            );
                        }
                        // TOTAL BUILD
                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            } else {
                parent_product.total_quantity = 0;
                parent_product.total_price = 0;
                parent_product.subtotal_price = 0;
                if (parent == "parent") {
                    if (!parent_product.artwork && !parent_product.build_id) {
                        parent_product.CartChildItems.forEach((item) => {
                            item.ink_price = parseFloat(color_category_price);
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(
                                    this.getChildMarkupPrice(parent_product, item)
                                ) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent_product.total_quantity += parseInt(
                                item.quantity
                            );
                            parent_product.total_price += parseFloat(
                                item.total_price
                            );
                            parent_product.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });
                    }

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;

                    parent_product.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(
                                        this.getChildMarkupPrice(subItem, item)
                                    ) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);

                                // Apply product discount to unit_price (for backend payload)
                                item.unit_price = this.applyDiscountToSizeCost(
                                    item.unit_price,
                                    subItem
                                );

                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent_product,
                                subItem,
                                total_quantity
                            );
                        }
                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        parent.total_quantity = 0;
                        parent.total_price = 0;
                        parent.subtotal_price = 0;
                        parent.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(
                                    this.getChildMarkupPrice(parent, item)
                                ) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent.total_quantity += parseInt(item.quantity);
                            parent.total_price += parseFloat(item.total_price);
                            parent.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(parent, parent, total_quantity);

                        // TOTAL BUILD
                    }
                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                if (parent_product.id == subItem.id) {
                                    item.ink_price =
                                        parseFloat(color_category_price);
                                }
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(
                                        this.getChildMarkupPrice(subItem, item)
                                    ) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent,
                                subItem,
                                total_quantity
                            );
                        }
                        // TOTAL BUILD
                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            }

            // Note: grand_total is now a computed property that automatically calculates from cart_subtotal
            // No need to manually set it here

            return qty_wise_color_price;
        },

        // Function not required
        getDecorationColorPrice(
            parent_product,
            total_quantity,
            colorIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            // Decoration type 0 means no decoration, return 0
            if (parent_product.decoration_type == 0) {
                return 0;
            }

            if (colorIndex == 0) {
                return qty_wise_color_price;
            }

            if (colorIndex == undefined) {
                colorIndex = 0;
            }
            if (
                parent_product.decoration_type == 1 ||
                parent_product.decoration_type == 5
            ) {
                if (!parent_product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = JSON.parse(
                        parent_product.price_decoration_bulk
                    ).print_location1;
                } else {
                    decoration_data = JSON.parse(
                        parent_product.price_decoration_bulk
                    ).print_location2;
                }

                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= total_quantity || index == 0) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (parent_product.decoration_type == 2 || parent_product.decoration_type == 4) {
                if (!parent_product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = JSON.parse(
                    parent_product.price_decoration_bulk
                );
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (index == 0) {
                        if (element.quantity1 > total_quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                    if (element.quantity1 <= total_quantity) {
                        if (element.quantity2 >= total_quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                }
            } else if (parent_product.decoration_type == 3) {
                let decoration_data = JSON.parse(
                    parent_product.price_decoration_bulk
                );
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= total_quantity || index == 0) {
                        qty_wise_color_price = parseFloat(element.cost);
                    }
                }
            }
            return qty_wise_color_price;
        },

        // Function not required
        calcAdditionalFees(parent, cart_item) {
            // IMPRINT LOCATIONS
            cart_item.imprint_locations_price = this.calcImprintLocationFees(
                parent,
                cart_item
            );

            // NAME NUMBER FEES
            cart_item.name_number_fees = this.calcNameNumberFees(cart_item);

            // NON STANDARD FEES
            // cart_item.non_standard_fees = this.calcNonStandardFees(cart_item);

            // console.log('cart_item ===> ', cart_item)
            // TOTAL PRICE
            cart_item.total_price +=
                parseFloat(cart_item.design_fee) +
                parseFloat(cart_item.setup_fee) +
                parseFloat(cart_item.imprint_locations_price) +
                parseFloat(cart_item.name_number_fees);
            // parseFloat(cart_item.non_standard_fees);
        },

        // Function not required
        calcImprintLocationFees(parent, cart_item) {
            let total_build_quantity = this.getGroupTotalQuantity(
                parent,
                cart_item
            );
            // console.log('total_build_quantity',total_build_quantity);
            let imprint_locations_price = 0;
            let highest_price_location_index = this.getHighestPriceLocation(
                cart_item.imprint_locations
            );

            cart_item.imprint_locations.forEach((location, locationIndex) => {
                location.colors.forEach((imprint_color, colorIndex) => {
                    let qty_wise_color_price = 0;
                    if (highest_price_location_index == locationIndex) {
                        qty_wise_color_price = this.getDecorationColorPrice(
                            cart_item,
                            total_build_quantity,
                            colorIndex
                        );
                    } else {
                        qty_wise_color_price = this.getDecorationColorPrice(
                            cart_item,
                            total_build_quantity,
                            colorIndex,
                            true
                        );
                    }
                    if (
                        highest_price_location_index == locationIndex &&
                        colorIndex == 0
                    ) {
                        qty_wise_color_price = 0;
                    }
                    // console.log('qty_wise_color_price',qty_wise_color_price);
                    imprint_color.cost_cost =
                        qty_wise_color_price *
                        parseInt(cart_item.total_quantity);
                    if (
                        imprint_color.color &&
                        imprint_color.color.decor_upcharge !== undefined &&
                        imprint_color.color.decor_upcharge !== null
                    ) {
                        imprint_color.decor_upcharge.color_cost =
                            parseFloat(
                                imprint_color.color.decor_upcharge || 0
                            ) * parseInt(cart_item.total_quantity);
                        imprint_locations_price =
                            parseFloat(imprint_color.cost_cost || 0) +
                            parseFloat(
                                imprint_color.decor_upcharge.color_cost || 0
                            );
                    } else if (imprint_color.color && imprint_color.cost_cost) {
                        imprint_locations_price = parseFloat(
                            imprint_color.cost_cost || 0
                        );
                    }
                });
            });
            return imprint_locations_price;
        },

        // Function not required but usefull
        calcNameNumberFees(cart_item) {
            let name_fees_obj = this.getAdminOption("name_fees");
            let name_fees = 0;
            if (name_fees_obj) {
                name_fees = parseFloat(name_fees_obj.option_value || 0);
            }

            let number_fees_obj = this.getAdminOption("number_fees");
            let number_fees = 0;
            if (number_fees_obj) {
                number_fees = parseFloat(number_fees_obj.option_value || 0);
            }

            let name_and_number_json = cart_item.name_and_number_json;
            if (!name_and_number_json) return 0;

            let total_name_number_fees = 0;
            const countFees = (arr) => {
                if (!Array.isArray(arr)) return;
                arr.forEach((nameNumber) => {
                    if (nameNumber.name) {
                        total_name_number_fees += parseFloat(name_fees);
                    }
                    if (nameNumber.number) {
                        total_name_number_fees += parseFloat(number_fees);
                        /* eslint-disable */
                        if (front_number) {
                            total_name_number_fees += parseFloat(number_fees);
                        }
                        /* eslint-enable */
                    }
                });
            };
            if (Array.isArray(name_and_number_json)) {
                countFees(name_and_number_json);
            } else if (typeof name_and_number_json === "object") {
                ["front", "back", "left", "right"].forEach((key) => {
                    countFees(name_and_number_json[key]);
                });
            }

            return total_name_number_fees;
        },

        // Function not required
        calcNonStandardFees(cart_item) {
            let non_standard_fees_obj = this.getAdminOption(
                "non_standard_color_fees"
            );
            let non_standard_fees = 0;
            if (non_standard_fees_obj) {
                non_standard_fees = parseFloat(
                    non_standard_fees_obj.option_value || 0
                );
            }

            // let non_standard_colors = cart_item.non_standard_colors
            //     ? JSON.parse(cart_item.non_standard_colors)
            //     : []

            return (
                cart_item.non_standard_colors.length *
                non_standard_fees *
                cart_item.total_quantity
            );
        },

        // Function not required
        getHighestPriceLocation(imprint_locations) {
            let location_index = -1;
            let highest_location_price = 0;
            imprint_locations.forEach((location, i) => {
                if (location.is_selected) {
                    let location_price = 0;
                    location.colors.forEach((color) => {
                        if (color.color) {
                            location_price += parseFloat(
                                color.color.decor_upcharge || 0
                            );
                        }
                    });

                    if (highest_location_price < location_price) {
                        location_index = i;
                        highest_location_price = location_price;
                    }
                }
            });

            if (highest_location_price == 0) {
                location_index = imprint_locations.findIndex(
                    (loc) => loc.is_selected
                );
            }

            return location_index;
        },

        // Function not required
        getGroupItemIds(parent, cart_item) {
            let cartItemIds = [];
            if (cart_item.build_id) {
                if (parent == "parent") {
                    cartItemIds.push(cart_item.id);
                    cart_item.subItems.forEach((subItem) => {
                        cartItemIds.push(subItem.id);
                    });
                } else {
                    cartItemIds.push(parent.id);
                    parent.subItems.forEach((subItem) => {
                        cartItemIds.push(subItem.id);
                    });
                }
            } else if (cart_item.artwork) {
                if (parent == "parent") {
                    if (cart_item.artwork) {
                        cartItemIds.push(cart_item.id);

                        cart_item.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                cartItemIds.push(subItem.id);
                            }
                        });
                    }
                } else {
                    if (cart_item.artwork) {
                        if (parent.artwork == cart_item.artwork) {
                            cartItemIds.push(parent.id);
                        }

                        parent.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                cartItemIds.push(subItem.id);
                            }
                        });
                    }
                }
            } else {
                if (parent == "parent") {
                    if (!cart_item.artwork && !cart_item.build_id) {
                        cartItemIds.push(cart_item.id);
                    }

                    cart_item.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            cartItemIds.push(subItem.id);
                        }
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        cartItemIds.push(parent.id);
                    }

                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            cartItemIds.push(subItem.id);
                        }
                    });
                }
            }
            return cartItemIds;
        },

        // Function not required
        updateCartOld(cart_item, parent) {
            try {
                let no_quantity_error = false;
                this.cart_items.forEach((cart_item) => {
                    let is_quantity_exist = cart_item.CartChildItems.find(
                        (cartChildItem) => parseInt(cartChildItem.quantity) > 0
                    );
                    if (!is_quantity_exist) {
                        no_quantity_error = true;
                        return;
                    }
                    if (cart_item.subItems) {
                        cart_item.subItems.forEach((subItem) => {
                            let is_quantity_exist = subItem.CartChildItems.find(
                                (cartChildItem) =>
                                    parseInt(cartChildItem.quantity) > 0
                            );
                            if (!is_quantity_exist) {
                                no_quantity_error = true;
                                return;
                            }
                        });
                    }
                });

                if (no_quantity_error == true) {
                    this.$toast.error(
                        `Every Item should have atleast single quantity is required`,
                        { position: "top-right", queue: true }
                    );
                    return;
                }

                if (!this.validateMinQuantity(parent, cart_item)) {
                    return;
                }

                cart_item.total_quantity = 0;
                cart_item.CartChildItems.forEach((childItem) => {
                    if (childItem.quantity > 0) {
                        cart_item.total_quantity += parseInt(
                            childItem.quantity || 0
                        );
                    }
                });

                // UPDATE PRICES
                this.grand_total -= cart_item["total_price"];
                cart_item["total_price"] = 0;

                this.calcPrices(cart_item, parent);

                this.grand_total += this.total_non_standard_fees_sp;

                let item;
                if (parent == "parent") {
                    item = cart_item;
                } else {
                    item = parent;
                }

                const cartItemIds = this.getGroupItemIds(parent, cart_item);

                // PARENT ITEM
                let params = [];
                if (cartItemIds.includes(item.id)) {
                    let child_items = [];
                    item.CartChildItems.forEach((childItem) => {
                        child_items.push({
                            id: childItem.id,
                            sub_product_id: childItem.sub_product_id,
                            case_price: childItem.case_price,
                            markup_price: childItem.markup_price,
                            markup_percentage: childItem.markup_percentage,
                            ink_price: childItem.ink_price,
                            single_location_price:
                                childItem.single_location_price,
                            quantity: childItem.quantity || 0,
                            discount: childItem.discount || 0,
                            unit_price: childItem.unit_price || 0,
                            total_price: childItem.total_price || 0
                        });
                    });
                    params.push({
                        cart_id: item.id,
                        child_items: child_items,
                        total_dark_category_fee: item.total_dark_category_fee,
                        total_light_category_fee: item.total_light_category_fee,
                        name_number_fees: item.name_number_fees,
                        non_standard_fees: item.non_standard_fees,
                        imprint_locations_price: item.imprint_locations_price,
                        imprint_locations: item.imprint_locations,
                        total_quantity: item.total_quantity,
                        subtotal_price: item.subtotal_price,
                        total_price: item.total_price
                    });
                }

                // PARENT SUB ITEMS
                item.subItems.forEach((subItem) => {
                    if (cartItemIds.includes(subItem.id)) {
                        let child_items = [];
                        subItem.CartChildItems.forEach((childItem) => {
                            child_items.push({
                                id: childItem.id,
                                sub_product_id: childItem.sub_product_id,
                                case_price: childItem.case_price,
                                markup_price: childItem.markup_price,
                                markup_percentage: childItem.markup_percentage,
                                ink_price: childItem.ink_price,
                                single_location_price:
                                    childItem.single_location_price,
                                quantity: childItem.quantity || 0,
                                discount: childItem.discount || 0,
                                unit_price: childItem.unit_price || 0,
                                total_price: childItem.total_price || 0
                            });
                        });

                        params.push({
                            cart_id: subItem.id,
                            child_items: child_items,
                            total_dark_category_fee:
                                subItem.total_dark_category_fee,
                            total_light_category_fee:
                                subItem.total_light_category_fee,
                            name_number_fees: subItem.name_number_fees,
                            non_standard_fees: subItem.non_standard_fees,
                            imprint_locations_price:
                                subItem.imprint_locations_price,
                            imprint_locations: subItem.imprint_locations,
                            total_quantity: subItem.total_quantity,
                            subtotal_price: subItem.subtotal_price,
                            total_price: subItem.total_price
                        });
                    }
                });

                if (this.currentUserClient) {
                    this.isBusy = true;
                    ApiService.post("/update-cart", params)
                        .then(() => {
                            this.$root.$emit("update-cart");
                            this.$toast.success(
                                "Quantity updated successfully.",
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            cart_item.show_update_button = false;
                            this.isBusy = false;
                        })
                        .catch((response) => {
                            console.log(response);
                            this.$toast.error("something went wrong.", {
                                position: "top-right",
                                queue: true
                            });
                        });
                }
            } catch (error) {
                console.log(error);
                if (error && error.message) {
                    this.$toast.error(error.message, {
                        position: "top-right",
                        queue: true
                    });
                }
            }
        },

        // Function not required
        getItemTotalQuantity(cartItem) {
            let total_quantity = 0;
            cartItem.CartChildItems.forEach((childItem) => {
                total_quantity += parseInt(childItem.quantity || 0);
            });
            return total_quantity;
        },

        // Function not required
        getGroupTotalQuantity(parent, cart_item) {
            // For assembly groups, tier calculations must use full assembly quantity.
            // This keeps persisted cart pricing aligned with UI tier resolution.
            const parentItem = parent !== "parent" ? parent : null;
            const isAssemblyContext =
                (parentItem && this.isAssemblyGroup(parentItem)) ||
                this.isAssemblyGroup(cart_item);
            if (isAssemblyContext) {
                const assemblyTierQuantity = this.getTierQuantityForItem(
                    cart_item,
                    parentItem
                );
                if (assemblyTierQuantity > 0) {
                    return assemblyTierQuantity;
                }
            }

            let total_quantity = 0;
            if (cart_item.build_id) {
                if (parent == "parent") {
                    total_quantity += this.getItemTotalQuantity(cart_item);
                    cart_item.subItems.forEach((subItem) => {
                        total_quantity += this.getItemTotalQuantity(subItem);
                    });
                } else {
                    total_quantity += this.getItemTotalQuantity(parent);
                    parent.subItems.forEach((subItem) => {
                        total_quantity += this.getItemTotalQuantity(subItem);
                    });
                }
            } else if (cart_item.artwork) {
                if (parent == "parent") {
                    if (cart_item.artwork) {
                        total_quantity += this.getItemTotalQuantity(cart_item);

                        cart_item.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                total_quantity +=
                                    this.getItemTotalQuantity(subItem);
                            }
                        });
                    }
                } else {
                    if (cart_item.artwork) {
                        if (parent.artwork == cart_item.artwork) {
                            total_quantity += this.getItemTotalQuantity(parent);
                        }

                        parent.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                total_quantity +=
                                    this.getItemTotalQuantity(subItem);
                            }
                        });
                    }
                }
            } else {
                if (parent == "parent") {
                    if (!cart_item.artwork && !cart_item.build_id) {
                        total_quantity += this.getItemTotalQuantity(cart_item);
                    }

                    cart_item.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            total_quantity +=
                                this.getItemTotalQuantity(subItem);
                        }
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        total_quantity += this.getItemTotalQuantity(parent);
                    }

                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            total_quantity +=
                                this.getItemTotalQuantity(subItem);
                        }
                    });
                }
            }
            return total_quantity;
        },

        // Get Base Fee services (rollup_fee_id = 1)
        getBaseFeeServices(item) {
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                return (
                    service.rollup_fee_id === 1 || service.rollup_fee_id === "1"
                );
            });
        },
        // Get color-size combinations from cart item
        getColorSizeCombinations(item, parentItem = null) {
            if (
                !item ||
                !item.CartChildItems ||
                !Array.isArray(item.CartChildItems)
            ) {
                return [];
            }

            const combinations = [];

            // Group CartChildItems by color_id
            const colorGroups = {};
            item.CartChildItems.forEach((childItem) => {
                const mainProduct = childItem.main_new_sub_product;
                const colorObj = mainProduct && mainProduct.Color;
                const colorId =
                    childItem.color_id ||
                    (colorObj && colorObj.id) ||
                    (colorObj && colorObj.color_id);
                if (!colorId) return;

                if (!colorGroups[colorId]) {
                    colorGroups[colorId] = {
                        color_id: colorId,
                        color_name:
                            (colorObj && colorObj.name) ||
                            (colorObj && colorObj.color_name) ||
                            "Color",
                        color_value:
                            (colorObj && colorObj.color_value) ||
                            (colorObj && colorObj.hex) ||
                            (colorObj && colorObj.hash) ||
                            "#cccccc",
                        sizes: []
                    };
                }

                // Extract size information
                const sizeObj = mainProduct && mainProduct.Size;
                if (sizeObj) {
                    let sizeAbbr = "N/A";
                    if (sizeObj.size_name) {
                        sizeAbbr = sizeObj.size_name;
                    } else if (sizeObj.size) {
                        const sizeParts = sizeObj.size.trim().split(/\s+/);
                        sizeAbbr = sizeParts[sizeParts.length - 1];
                    } else if (sizeObj.name) {
                        const nameParts = sizeObj.name.trim().split(/\s+/);
                        sizeAbbr = nameParts[nameParts.length - 1];
                    }

                    const quantity = parseInt(childItem.quantity) || 0;
                    if (quantity > 0) {
                        // For decoration type 0 (PCNA), use price from decoration bulk based on total quantity
                        // This matches how PCNAPriceBreakdown works - same unit price for all color-size combinations
                        let calculatedUnitPrice = 0;

                        if (
                            item.decoration_type === 0 ||
                            item.decoration_type === "0"
                        ) {
                            // PCNA: Get unit price from decoration bulk tiers based on total quantity
                            calculatedUnitPrice =
                                this.getBaseUnitPriceFromTiers(
                                    item,
                                    parentItem
                                );
                        } else if (
                            item.decoration_type == 1 ||
                            item.decoration_type == 5 ||
                            item.decoration_type == 2 ||
                            item.decoration_type == 4
                        ) {
                            // Decoration type 1 (Screen Print) and 2/4 (Embroidery-like)
                            // Each color-size combination should have its own unit price
                            // Apply same logic as getBaseUnitPriceFromTiers but per childItem
                            try {
                                // Get base price and markup from current childItem (each can be different)
                                const basePrice = parseFloat(
                                    childItem.case_price || 0
                                );
                                const markupPrice = parseFloat(
                                    childItem.markup_price || 0
                                );

                                // Get single location price from decoration tiers based on total quantity
                                const bulkData =
                                    this.getEffectivePriceDecorationBulk(item);

                                let singleLocationPrice = 0;
                                const totalQuantity =
                                    this.getTierQuantityForItem(
                                        item,
                                        parentItem
                                    );

                                if (
                                    item.decoration_type == 1 ||
                                    item.decoration_type == 5
                                ) {
                                    // Screen Print: get from print_location1
                                    if (bulkData && bulkData.print_location1) {
                                        const location1Data =
                                            bulkData.print_location1;
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(location1Data)) {
                                            if (
                                                element.quantity <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.colour1 || 0
                                                    );
                                            }
                                        }
                                    }
                                } else if (
                                    item.decoration_type == 2 ||
                                    item.decoration_type == 4
                                ) {
                                    // Embroidery/Patch: get from quantity slabs array
                                    if (bulkData && Array.isArray(bulkData)) {
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(bulkData)) {
                                            if (
                                                element.quantity1 <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.cost || 0
                                                    );
                                            }
                                        }
                                    }
                                }

                                // Get color category price (dark/light fee) from decoration for this specific color
                                // Try multiple possible property names for color category
                                let colorCategory = null;
                                if (colorObj) {
                                    colorCategory =
                                        colorObj.category ||
                                        colorObj.color_category ||
                                        (colorObj.Color &&
                                            colorObj.Color.category) ||
                                        (mainProduct &&
                                            mainProduct.Color &&
                                            mainProduct.Color.category);
                                }

                                let colorCategoryPrice = 0;
                                const feeSource =
                                    item.decoration ||
                                    item.decoration_template_data ||
                                    null;
                                if (feeSource && colorCategory) {
                                    if (
                                        colorCategory === "Dark" ||
                                        colorCategory === "dark"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            feeSource.price_dark || 0
                                        );
                                    } else if (
                                        colorCategory === "Light" ||
                                        colorCategory === "light"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            feeSource.price_light || 0
                                        );
                                    }
                                }

                                // Get decoration discount percentage
                                const decorationDiscount =
                                    this.getDecorationDiscount(
                                        item,
                                        totalQuantity,
                                        false
                                    );

                                // Calculate unit price: base + markup + single location + color category
                                calculatedUnitPrice =
                                    basePrice +
                                    markupPrice +
                                    singleLocationPrice +
                                    colorCategoryPrice;

                                // OLD BEHAVIOR (kept for future rollback):
                                // Decoration discount was applied only on singleLocationPrice.
                                // if (decorationDiscount > 0) {
                                //     const discountValue =
                                //         (this.icPriceFormat(
                                //             singleLocationPrice,
                                //             true
                                //         ) *
                                //             decorationDiscount) /
                                //         100;
                                //     calculatedUnitPrice -= discountValue;
                                // }

                                // Apply decoration discount on combined Product Base Price.
                                if (decorationDiscount > 0) {
                                    const discountValue =
                                        (this.icPriceFormat(
                                            calculatedUnitPrice,
                                            true
                                        ) *
                                            decorationDiscount) /
                                        100;
                                    calculatedUnitPrice -= discountValue;
                                }

                                // Apply product discount (same as getBaseUnitPriceFromTiers)
                                calculatedUnitPrice =
                                    this.applyDiscountToSizeCost(
                                        calculatedUnitPrice,
                                        item
                                    );
                            } catch (e) {
                                console.error(
                                    "Error calculating unit price for decoration type " +
                                        item.decoration_type +
                                        ":",
                                    e
                                );
                                // Fallback: use full unit_price
                                calculatedUnitPrice = parseFloat(
                                    childItem.unit_price || 0
                                );
                                if (calculatedUnitPrice === 0) {
                                    calculatedUnitPrice =
                                        parseFloat(childItem.total_price || 0) /
                                        quantity;
                                }
                                // Apply product discount to fallback price as well
                                calculatedUnitPrice =
                                    this.applyDiscountToSizeCost(
                                        calculatedUnitPrice,
                                        item
                                    );
                            }
                        } else {
                            // For other decoration types, use full unit_price
                            calculatedUnitPrice = parseFloat(
                                childItem.unit_price || 0
                            );
                            if (calculatedUnitPrice === 0) {
                                calculatedUnitPrice =
                                    parseFloat(childItem.total_price || 0) /
                                    quantity;
                            }
                            // Apply product discount to fallback price as well
                            calculatedUnitPrice = this.applyDiscountToSizeCost(
                                calculatedUnitPrice,
                                item
                            );
                        }

                        colorGroups[colorId].sizes.push({
                            size: sizeAbbr,
                            quantity: quantity,
                            cost: calculatedUnitPrice, // Unit price calculated same as getBaseUnitPriceFromTiers
                            total_cost: calculatedUnitPrice * quantity
                        });
                    }
                }
            });

            // Convert grouped data to combinations array
            Object.values(colorGroups).forEach((colorGroup) => {
                colorGroup.sizes.forEach((size) => {
                    // Ensure color value has # prefix
                    let colorValue = colorGroup.color_value || "";
                    if (colorValue && !colorValue.startsWith("#")) {
                        colorValue = "#" + colorValue;
                    }
                    if (!colorValue) {
                        colorValue = "#cccccc";
                    }

                    combinations.push({
                        color_id: colorGroup.color_id,
                        color_name: colorGroup.color_name,
                        color_value: colorValue,
                        hex: colorValue,
                        size: size.size,
                        quantity: size.quantity,
                        cost: size.cost,
                        total_cost: size.total_cost
                    });
                });
            });

            return combinations;
        },

        // Get Base Unit Price from price_decoration_bulk tiers based on tier quantity
        getBaseUnitPriceFromTiers(item, parentItem = null) {
            const quantity = this.getTierQuantityForItem(item, parentItem);
            let unitPrice = 0;

            // Decoration type 0 - get from decoration.price_decoration_bulk
            if (item.decoration_type == 0) {
                try {
                    // Check if decoration.price_decoration_bulk exists
                    const decorationBulk =
                        item.decoration && item.decoration.price_decoration_bulk
                            ? typeof item.decoration.price_decoration_bulk ===
                              "string"
                                ? JSON.parse(
                                      item.decoration.price_decoration_bulk
                                  )
                                : item.decoration.price_decoration_bulk
                            : null;

                    if (decorationBulk) {
                        // For decoration type 0, price_decoration_bulk is typically an array
                        if (Array.isArray(decorationBulk)) {
                            for (const [index, element] of Object.entries(
                                decorationBulk
                            )) {
                                if (
                                    element.quantity <= quantity ||
                                    index == 0
                                ) {
                                    unitPrice = parseFloat(
                                        element.retail_cost || element.cost || 0
                                    );
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.error(
                        "Error parsing decoration.price_decoration_bulk for type 0:",
                        e
                    );
                    const fallbackPrice =
                        quantity > 0
                            ? parseFloat(item.subtotal_price || 0) / quantity
                            : 0;
                    // Apply product discount to fallback price
                    return this.applyDiscountToSizeCost(fallbackPrice, item);
                }

                const finalPrice =
                    unitPrice ||
                    (quantity > 0
                        ? parseFloat(item.subtotal_price || 0) / quantity
                        : 0);
                // Apply product discount before returning
                return this.applyDiscountToSizeCost(finalPrice, item);
            }

            // Decoration type 1/5 - Screen Print/DTF (print-like path)
            if (item.decoration_type == 1 || item.decoration_type == 5) {
                try {
                    // Get base price and markup from CartChildItems (use first item or average)
                    let basePrice = 0;
                    let markupPrice = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        const firstChild = item.CartChildItems[0];
                        basePrice = parseFloat(firstChild.case_price || 0);
                        markupPrice = parseFloat(firstChild.markup_price || 0);
                    }

                    // Get single location price from decoration tiers
                    const bulkData = this.getEffectivePriceDecorationBulk(item);

                    let singleLocationPrice = 0;
                    if (bulkData && bulkData.print_location1) {
                        const location1Data = bulkData.print_location1;
                        for (const [index, element] of Object.entries(
                            location1Data
                        )) {
                            if (element.quantity <= quantity || index == 0) {
                                singleLocationPrice = parseFloat(
                                    element.colour1 || 0
                                );
                            }
                        }
                    }

                    // Get color category price (dark/light fee) from decoration
                    let colorCategoryPrice = 0;
                    const feeSource =
                        item.decoration || item.decoration_template_data || null;
                    if (feeSource) {
                        if (item.Color && item.Color.category === "Dark") {
                            colorCategoryPrice = parseFloat(
                                feeSource.price_dark || 0
                            );
                        } else if (
                            item.Color &&
                            item.Color.category === "Light"
                        ) {
                            colorCategoryPrice = parseFloat(
                                feeSource.price_light || 0
                            );
                        }
                    }

                    // Get decoration discount percentage
                    // IMPORTANT: For per-item calculation, use item-specific quantity, NOT grouped quantity
                    // Grouped quantity is only used for tier pricing in calculatePricing, but here we want per-item display
                    const decorationDiscount = this.getDecorationDiscount(
                        item,
                        quantity,
                        false
                    );

                    // Calculate unit price: base + markup + single location + color category
                    unitPrice =
                        basePrice +
                        markupPrice +
                        singleLocationPrice +
                        colorCategoryPrice;
                    // Apply decoration discount
                    if (decorationDiscount > 0) {
                        const discountValue =
                            (this.icPriceFormat(unitPrice, true) *
                                decorationDiscount) /
                            100;
                        unitPrice -= discountValue;
                    }
                } catch (e) {
                    console.error(
                        "Error parsing price_decoration_bulk for type 1:",
                        e
                    );
                    const fallbackPrice =
                        quantity > 0
                            ? parseFloat(item.subtotal_price || 0) / quantity
                            : 0;
                    // Apply product discount to fallback price
                    return this.applyDiscountToSizeCost(fallbackPrice, item);
                }
            }
            // Decoration type 2 - Embroidery
            else if (item.decoration_type == 2 || item.decoration_type == 4) {
                try {
                    // Get base price and markup from CartChildItems (use first item or average)
                    let basePrice = 0;
                    let markupPrice = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        const firstChild = item.CartChildItems[0];
                        basePrice = parseFloat(firstChild.case_price || 0);
                        markupPrice = parseFloat(firstChild.markup_price || 0);
                    }

                    // Get single location price from decoration tiers
                    const bulkData = this.getEffectivePriceDecorationBulk(item);

                    let singleLocationPrice = 0;
                    if (bulkData && Array.isArray(bulkData)) {
                        for (const [index, element] of Object.entries(
                            bulkData
                        )) {
                            if (element.quantity1 <= quantity || index == 0) {
                                singleLocationPrice = parseFloat(
                                    element.cost || 0
                                );
                            }
                        }
                    }

                    // Get color category price (dark/light fee) from decoration
                    let colorCategoryPrice = 0;
                    const feeSource =
                        item.decoration || item.decoration_template_data || null;
                    if (feeSource) {
                        if (item.Color && item.Color.category === "Dark") {
                            colorCategoryPrice = parseFloat(
                                feeSource.price_dark || 0
                            );
                        } else if (
                            item.Color &&
                            item.Color.category === "Light"
                        ) {
                            colorCategoryPrice = parseFloat(
                                feeSource.price_light || 0
                            );
                        }
                    }

                    // Get decoration discount percentage
                    // IMPORTANT: For per-item calculation, use item-specific quantity, NOT grouped quantity
                    // Grouped quantity is only used for tier pricing in calculatePricing, but here we want per-item display
                    const decorationDiscount = this.getDecorationDiscount(
                        item,
                        quantity,
                        false
                    );

                    // Calculate unit price: base + markup + single location + color category
                    unitPrice =
                        basePrice +
                        markupPrice +
                        singleLocationPrice +
                        colorCategoryPrice;

                    // Apply decoration discount
                    if (decorationDiscount > 0) {
                        const discountValue =
                            (this.icPriceFormat(unitPrice, true) *
                                decorationDiscount) /
                            100;
                        unitPrice -= discountValue;
                    }
                } catch (e) {
                    console.error(
                        "Error parsing price_decoration_bulk for type 2:",
                        e
                    );
                    const fallbackPrice =
                        quantity > 0
                            ? parseFloat(item.subtotal_price || 0) / quantity
                            : 0;
                    // Apply product discount to fallback price
                    return this.applyDiscountToSizeCost(fallbackPrice, item);
                }
            }

            // Apply product discount to unit price
            unitPrice = this.applyDiscountToSizeCost(unitPrice, item);

            return (
                unitPrice ||
                (quantity > 0
                    ? parseFloat(item.subtotal_price || 0) / quantity
                    : 0)
            );
        },

        // Get Base Fee Total (base price from tiers + all services)
        // IMPORTANT: This should be per-item, NOT grouped
        getBaseFeeTotal(item, parentItem = null) {
            // Use item-specific quantity, not grouped quantity
            const quantity = this.getTotalItemQuantity(item);

            // If color-size combinations exist, calculate from them (for decoration type 1 and 2)
            const colorSizeCombinations = this.getColorSizeCombinations(
                item,
                parentItem
            );
            if (colorSizeCombinations && colorSizeCombinations.length > 0) {
                let total = 0;

                // Sum up all color-size combination totals
                // Note: combination.cost already has product discount applied in getColorSizeCombinations
                colorSizeCombinations.forEach((combination) => {
                    // Match tooltip rounding: round unit first, then multiply by qty.
                    const cost = parseFloat(
                        (parseFloat(combination.cost || 0) || 0).toFixed(2)
                    );
                    const qty = parseInt(combination.quantity || 0);
                    total += cost * qty;
                });

                // Get included services (show_service = false) unit price
                let includedServicesUnitPrice = 0;
                const baseFeeServices = this.getBaseFeeServices(item);
                if (baseFeeServices && baseFeeServices.length > 0) {
                    baseFeeServices.forEach((service) => {
                        if (!service.show_service) {
                            // Included services: add unit price directly
                            const serviceUnitPrice = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                            includedServicesUnitPrice += serviceUnitPrice;
                        }
                    });
                }

                // Add included services total: unit price × quantity
                total += includedServicesUnitPrice * quantity;

                // Add other services (show_service = true)
                if (baseFeeServices && baseFeeServices.length > 0) {
                    baseFeeServices.forEach((service) => {
                        if (service.show_service) {
                            const servicePrice =
                                service.retail_cost || service.net_cost || 0;
                            if (service.fee_structure === "Per Item") {
                                total += parseFloat(servicePrice) * quantity;
                            } else {
                                total += parseFloat(servicePrice);
                            }
                        }
                    });
                }

                return parseFloat(total.toFixed(2));
            }

            // Fallback: Calculate from tier-based unit price (for decoration type 0 or when no combinations)
            const baseUnitPrice = this.getBaseUnitPriceFromTiers(
                item,
                parentItem
            );

            // Get included services (show_service = false) unit price
            let includedServicesUnitPrice = 0;
            const baseFeeServices = this.getBaseFeeServices(item);
            if (baseFeeServices && baseFeeServices.length > 0) {
                baseFeeServices.forEach((service) => {
                    if (!service.show_service) {
                        // Included services: add unit price directly
                        const serviceUnitPrice = parseFloat(
                            service.retail_cost || service.net_cost || 0
                        );
                        includedServicesUnitPrice += serviceUnitPrice;
                    }
                });
            }

            // Apply discount to base unit price
            const discountedBaseUnitPrice = this.applyDiscountToSizeCost(
                baseUnitPrice,
                item
            );

            // Calculate total: (discountedBaseUnitPrice + includedServicesUnitPrice) × quantity
            const totalUnitPrice =
                discountedBaseUnitPrice + includedServicesUnitPrice;
            let total = totalUnitPrice * quantity;

            // Add other services (show_service = true)
            if (baseFeeServices && baseFeeServices.length > 0) {
                baseFeeServices.forEach((service) => {
                    if (service.show_service) {
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            total += parseFloat(servicePrice) * quantity;
                        } else {
                            total += parseFloat(servicePrice);
                        }
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get Setup Fee services (rollup_fee_id = 2)
        getSetupFeeServices(item) {
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId =
                    rollupService.rollup_fee_id !== undefined &&
                    rollupService.rollup_fee_id !== null
                        ? rollupService.rollup_fee_id
                        : service.rollup_fee_id !== undefined &&
                          service.rollup_fee_id !== null
                        ? service.rollup_fee_id
                        : null;
                return serviceFeeId === 2 || serviceFeeId === "2";
            });
        },

        // Get Run Charge services (if any)
        getRunChargeServices(item) {
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId =
                    rollupService.rollup_fee_id !== undefined &&
                    rollupService.rollup_fee_id !== null
                        ? rollupService.rollup_fee_id
                        : service.rollup_fee_id !== undefined &&
                          service.rollup_fee_id !== null
                        ? service.rollup_fee_id
                        : null;
                return serviceFeeId === 12 || serviceFeeId === "12";
            });
        },
        getColorMixFeeServices(item) {
            const colorType = this.getItemColorType(item);
            const isSupportedColorType =
                colorType === "thread" || colorType === "ink";
            if (!isSupportedColorType) return [];
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId =
                    rollupService.rollup_fee_id !== undefined &&
                    rollupService.rollup_fee_id !== null
                        ? rollupService.rollup_fee_id
                        : service.rollup_fee_id !== undefined &&
                          service.rollup_fee_id !== null
                        ? service.rollup_fee_id
                        : null;
                return serviceFeeId === 13 || serviceFeeId === "13";
            });
        },
        getNormalizedColorTypeFromDecoration(decoration) {
            if (!decoration || typeof decoration !== "object") return "";
            const rawColorType =
                (decoration.master_service &&
                    decoration.master_service.color_type) ||
                decoration.color_type ||
                "";
            return String(rawColorType).toLowerCase().trim();
        },
        getItemColorType(item) {
            if (!item || !item.decoration) return "";
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return "";
                }
            }
            return this.getNormalizedColorTypeFromDecoration(decoration);
        },

        // Rollup 13 services that are the actual thread/ink color-mix fee (stay on assembly parent when split)
        isPrimaryCustomColorRollupService(service) {
            if (!service) return false;
            const t = (service.type || "").toLowerCase();
            if (t === "thread_fee" || t === "custom_ink_mix") return true;
            const name = (
                service.name ||
                service.service_name ||
                service.ecomm_display ||
                (service.rollup_service &&
                    (service.rollup_service.name ||
                        service.rollup_service.service_name ||
                        service.rollup_service.ecomm_display)) ||
                ""
            ).toLowerCase();
            if (name.includes("thread mix") || name.includes("ink mix"))
                return true;
            if (name.includes("color thread") || name.includes("color ink"))
                return true;
            if (
                name.includes("thread fee") &&
                (name.includes("color") || name.includes("custom"))
            )
                return true;
            if (
                name.includes("ink fee") &&
                (name.includes("color") || name.includes("custom"))
            )
                return true;
            return false;
        },
        getOtherColorMixFeeServices(item) {
            const all = this.getColorMixFeeServices(item);
            return all.filter(
                (s) => !this.isPrimaryCustomColorRollupService(s)
            );
        },
        getOtherColorMixFeeRollupTotal(item) {
            let total = 0;
            const services = this.getOtherColorMixFeeServices(item);
            if (!services || services.length === 0) return 0;
            const quantity = this.getTotalItemQuantity(item);
            services.forEach((service) => {
                const servicePrice =
                    service.retail_cost || service.net_cost || 0;
                if (service.fee_structure === "Per Item") {
                    total += parseFloat(servicePrice) * quantity;
                } else {
                    total += parseFloat(servicePrice);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getDisplayedColorMixFeeServices(subItem, parentItem = null) {
            if (parentItem && this.isAssemblyGroup(parentItem)) {
                return this.getOtherColorMixFeeServices(subItem);
            }
            return this.getColorMixFeeServices(subItem);
        },
        getDisplayedColorMixFeeData(subItem, parentItem = null) {
            if (parentItem && this.isAssemblyGroup(parentItem)) {
                return null;
            }
            return this.getColorMixFeeData(subItem);
        },
        getDisplayedColorMixFeeTotal(subItem, parentItem = null) {
            if (parentItem && this.isAssemblyGroup(parentItem)) {
                return this.getOtherColorMixFeeRollupTotal(subItem);
            }
            return this.getColorMixFeeTotal(subItem);
        },

        // Helper method to check if location is full color
        // Returns true when user selected Full color in design studio (so cart shows Full Color row and charges correctly)
        isLocationFullColor(location) {
            // Check if full color flag is set (saved from design studio)
            const hasFullColorFlag =
                location.is_full_color === true ||
                location.no_of_color === "full_color" ||
                location.no_of_color === "Full color";

            if (!hasFullColorFlag) {
                return false;
            }

            // Get actual color count from colors array
            let actualColorCount = 0;
            if (location.colors && Array.isArray(location.colors)) {
                actualColorCount = location.colors.filter((colorObj) => {
                    return (
                        colorObj &&
                        colorObj.color &&
                        (colorObj.color.color_id !== undefined ||
                            colorObj.color.color_value ||
                            colorObj.color.hex)
                    );
                }).length;
            }

            // If colors array count is 0 or not available, check no_of_color for numeric value
            if (actualColorCount === 0) {
                const noOfColors = parseInt(location.no_of_color || 0);
                if (
                    noOfColors > 0 &&
                    noOfColors !== "full_color" &&
                    noOfColors !== "Full color"
                ) {
                    actualColorCount = noOfColors;
                }
            }

            // Full color selected in design studio: show and charge Full Color when
            // - multiple colors, OR
            // - zero colors (e.g. location has only name/number - still charge full color as chosen)
            // Only treat as non-full when exactly 1 color is selected (single-color design)
            return actualColorCount > 1 || actualColorCount === 0;
        },
        getLocationColorCount(location) {
            if (!location || typeof location !== "object") return 0;

            const declaredColorCount = parseInt(location.no_of_color || 0) || 0;
            const colorsArrayCount =
                location.colors && Array.isArray(location.colors)
                    ? location.colors.filter((colorObj) => {
                          return (
                              colorObj &&
                              colorObj.color &&
                              (colorObj.color.color_id !== undefined ||
                                  colorObj.color.color_value ||
                                  colorObj.color.hex)
                          );
                      }).length
                    : 0;

            // Use higher value so stale no_of_color does not drop addl-color rows.
            return Math.max(declaredColorCount, colorsArrayCount);
        },

        // Helper method to get full color value from master_service
        getFullColorValue(item) {
            if (!item.decoration || !item.decoration.master_service) {
                return 0;
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return 0;
                }
            }

            const masterService = decoration.master_service || {};
            // Check for full_color value in master_service
            const fullColorValue = parseFloat(masterService.full_color || 0);
            return fullColorValue;
        },

        // Normalize vendor location label to front | back | left | right (empty if unknown)
        normalizeImprintLocationKey(locationName) {
            const raw = (locationName || "").toLowerCase().trim();
            if (raw.includes("front")) return "front";
            if (raw.includes("back")) return "back";
            if (raw.includes("left")) return "left";
            if (raw.includes("right")) return "right";
            return "";
        },
        getSelectedImprintLocationKeys(item) {
            let im = item && item.imprint_locations;
            if (typeof im === "string") {
                try {
                    im = JSON.parse(im);
                } catch (e) {
                    return new Set();
                }
            }
            if (!im || !Array.isArray(im)) return new Set();
            const keys = new Set();
            im.forEach((loc) => {
                if (!loc || loc.is_selected !== true) return;
                const k = this.normalizeImprintLocationKey(loc.location || "");
                if (k) keys.add(k);
            });
            return keys;
        },
        // Modal: prefer selected imprint sides; if flags missing, fall back to any imprint row on the product
        getImprintLocationKeysForNameNumberModal(item) {
            let keys = this.getSelectedImprintLocationKeys(item);
            if (keys.size > 0) return keys;
            let im = item && item.imprint_locations;
            if (typeof im === "string") {
                try {
                    im = JSON.parse(im);
                } catch (e) {
                    im = [];
                }
            }
            if (Array.isArray(im)) {
                im.forEach((loc) => {
                    if (!loc) return;
                    const k = this.normalizeImprintLocationKey(loc.location || "");
                    if (k) keys.add(k);
                });
            }
            return keys;
        },
        // Add name/number fee rows only for imprints that exist on this product line (avoids saved-design carryover)
        appendOrphanNameNumberFeesForAllowedImprints(
            item,
            breakdown,
            existingFeeNames,
            extra = {}
        ) {
            const allowed = this.getSelectedImprintLocationKeys(item);
            if (allowed.size === 0) return;
            const buckets = {
                back: this.getNameNumberFeesFromItemPrices(item, "back"),
                front: this.getNameNumberFeesFromItemPrices(item, "front"),
                left: this.getNameNumberFeesFromItemPrices(item, "left"),
                right: this.getNameNumberFeesFromItemPrices(item, "right")
            };
            allowed.forEach((key) => {
                (buckets[key] || []).forEach((fee) => {
                    if (fee.total > 0 && !existingFeeNames.includes(fee.name)) {
                        breakdown.push({
                            type: "nameNumberFee",
                            name: fee.name,
                            qty: fee.qty,
                            amt: fee.amt,
                            total: fee.total,
                            ...extra
                        });
                        existingFeeNames.push(fee.name);
                    }
                });
            });
        },
        // Get Run Charge Breakdown Data for Decoration Type 0, 1, and 2
        getRunChargeBreakdown(item, parentItem = null) {
            let breakdown = [];
            // Handle decoration type 0 (PCNA)
            if (item.decoration_type == 0) {
                breakdown = this.getRunChargeBreakdownType0(item, parentItem);
                const out = this.applyRunSuppressionToBreakdown(
                    breakdown,
                    item,
                    parentItem
                );
                const organized = this.organizeBreakdownByLocation(out);
                this.logRunChargeBreakdownDebug(
                    "Cart:dec0",
                    item,
                    organized
                );
                return organized;
            }

            // Handle decoration type 1 (Screen Print) and 2 (Embroidery)
            if (item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) {
                breakdown = this.getRunChargeBreakdownType1And2(item, parentItem);
                const out = this.applyRunSuppressionToBreakdown(
                    breakdown,
                    item,
                    parentItem
                );
                this.logRunChargeBreakdownDebug(
                    "Cart:dec1/2/4/5",
                    item,
                    out
                );
                return out;
            }

            return breakdown;
        },
        getEffectiveImprintLocations(item, parentItem = null) {
            const parseImprintLocations = (locations) => {
                if (Array.isArray(locations)) return locations;
                if (typeof locations === "string") {
                    try {
                        const parsed = JSON.parse(locations);
                        return Array.isArray(parsed) ? parsed : [];
                    } catch (e) {
                        return [];
                    }
                }
                return [];
            };

            const itemLocations = parseImprintLocations(
                item && item.imprint_locations
            );
            if (itemLocations.length > 0) {
                return itemLocations;
            }

            if (parentItem && this.isAssemblyGroup(parentItem)) {
                const parentLocations = parseImprintLocations(
                    parentItem.imprint_locations
                );
                if (parentLocations.length > 0) {
                    return parentLocations;
                }
            }

            return [];
        },

        roundToTwo(value) {
            const parsed = parseFloat(value);
            if (Number.isNaN(parsed)) return "0.00";
            return parsed.toFixed(2);
        },
        getSuppressAdditionalSetupRunChargeConfig(item, parentItem = null) {
            const parseDecoration = (target) => {
                if (!target || !target.decoration) return null;
                if (typeof target.decoration === "string") {
                    try {
                        return JSON.parse(target.decoration);
                    } catch (e) {
                        return null;
                    }
                }
                return target.decoration;
            };
            const decoration = parseDecoration(item) || parseDecoration(parentItem);
            const masterService = decoration && decoration.master_service ? decoration.master_service : {};
            const productMasterService =
                decoration && decoration.product_master_service
                    ? decoration.product_master_service
                    : {};
            const enabled =
                Number(
                    productMasterService.suppress_additional_setup_run_charge ||
                        masterService.suppress_additional_setup_run_charge ||
                        0
                ) === 1;
            return { enabled, masterService };
        },
        getLocationColorSignature(location) {
            if (!location || !Array.isArray(location.colors)) return "";
            const signature = location.colors
                .map((entry) => {
                    const color = entry && entry.color ? entry.color : {};
                    return String(
                        color.color_id ||
                            color.id ||
                            color.hex ||
                            color.color_value ||
                            color.name ||
                            ""
                    ).toLowerCase();
                })
                .filter(Boolean)
                .sort();
            return signature.join("|");
        },
        getLocationDesignComparablePayload(location) {
            if (!location || typeof location !== "object") return {};
            const payload =
                location.design_data ||
                location.design_json ||
                location.artwork_data ||
                location.canvas_json ||
                location.objects ||
                location.print_data ||
                {};
            let normalizedPayload = payload;
            if (typeof normalizedPayload === "string") {
                try {
                    normalizedPayload = JSON.parse(normalizedPayload);
                } catch (e) {
                    normalizedPayload = { raw: normalizedPayload };
                }
            }
            const skipKeys = new Set([
                "left",
                "top",
                "x",
                "y",
                "angle",
                "rotate",
                "rotation",
                "scaleX",
                "scaleY",
                "translateX",
                "translateY",
                "posX",
                "posY"
            ]);
            const normalizeNode = (node) => {
                if (Array.isArray(node)) return node.map(normalizeNode);
                if (!node || typeof node !== "object") return node;
                return Object.keys(node)
                    .sort()
                    .reduce((acc, key) => {
                        if (skipKeys.has(key)) return acc;
                        acc[key] = normalizeNode(node[key]);
                        return acc;
                    }, {});
            };
            return normalizeNode(normalizedPayload);
        },
        getLocationComparisonKey(location) {
            const colorSignature = this.getLocationColorSignature(location);
            const designPayload = this.getLocationDesignComparablePayload(location);
            const fp =
                (location.suppress_design_fingerprint &&
                    String(location.suppress_design_fingerprint)) ||
                computeFingerprintFromArbitraryPayload(
                    location.design_data ||
                        location.design_json ||
                        location.artwork_data ||
                        location.canvas_json ||
                        location.objects ||
                        location.print_data
                );
            const designIdentity =
                location.design_id ||
                location.saved_design_id ||
                location.artwork_id ||
                location.image_url ||
                location.artwork_url ||
                "";
            const payloadSignature = JSON.stringify(designPayload || {});
            return [
                colorSignature,
                String(designIdentity),
                String(fp),
                payloadSignature
            ].join("::");
        },
        getLocationGroupingMetadata(imprintLocations, suppressionEnabled) {
            const selected = (imprintLocations || []).filter((loc) => loc && loc.is_selected);
            const hasPresetGrouping = selected.some(
                (location) =>
                    location.design_group_id !== undefined &&
                    location.design_group_id !== null &&
                    location.design_group_id !== ""
            );
            if (suppressionEnabled && hasPresetGrouping) {
                const seenPreset = new Set();
                return selected.map((location, index) => {
                    const presetKey = String(
                        location.design_group_id || `preset_${index}`
                    );
                    const derivedPrimary =
                        location.is_group_primary !== undefined
                            ? !!location.is_group_primary
                            : !seenPreset.has(presetKey);
                    if (derivedPrimary) {
                        seenPreset.add(presetKey);
                    }
                    return {
                        location,
                        key: presetKey,
                        isGroupPrimary: derivedPrimary
                    };
                });
            }
            if (!suppressionEnabled) {
                return selected.map((location, index) => ({
                    location,
                    key: `legacy_${index}`,
                    isGroupPrimary: index === 0
                }));
            }
            const seenKeys = new Set();
            return selected.map((location) => {
                const key = this.getLocationComparisonKey(location);
                const isGroupPrimary = !seenKeys.has(key);
                if (isGroupPrimary) {
                    seenKeys.add(key);
                }
                return {
                    location,
                    key,
                    isGroupPrimary
                };
            });
        },
        applyRunSuppressionToBreakdown(breakdown, item, parentItem = null) {
            if (!Array.isArray(breakdown) || breakdown.length === 0) {
                return breakdown;
            }
            const suppressConfig = this.getSuppressAdditionalSetupRunChargeConfig(
                item,
                parentItem
            );
            if (!suppressConfig.enabled) {
                return breakdown;
            }
            const groupedLocations = this.getLocationGroupingMetadata(
                this.getEffectiveImprintLocations(item, parentItem),
                true
            );
            const locationSuppressionMap = {};
            groupedLocations.forEach((entry) => {
                const locKey = this.normalizeImprintLocationKey(
                    entry.location.location
                );
                if (locKey) {
                    locationSuppressionMap[locKey] = !entry.isGroupPrimary;
                }
            });
            let currentLocationSuppressed = false;
            const applySuppressionToRow = (row) => {
                if (!row || typeof row !== "object") return row;
                if (row.type === "location") {
                    const locationMatch = String(row.name || "").match(
                        /\(([^)]+)\)/
                    );
                    const locKey = this.normalizeImprintLocationKey(
                        locationMatch ? locationMatch[1] : row.name
                    );
                    currentLocationSuppressed = !!locationSuppressionMap[locKey];
                    if (!currentLocationSuppressed) {
                        return row;
                    }
                    return {
                        ...row,
                        amt: 0,
                        total: 0,
                        is_suppressed_by_group: true
                    };
                }
                if (!currentLocationSuppressed) {
                    return row;
                }
                return {
                    ...row,
                    amt: 0,
                    total: 0,
                    is_suppressed_by_group: true
                };
            };
            if (
                breakdown[0] &&
                breakdown[0].items &&
                Array.isArray(breakdown[0].items)
            ) {
                return breakdown.map((locBucket) => ({
                    ...locBucket,
                    items: (locBucket.items || []).map(applySuppressionToRow)
                }));
            }
            return breakdown.map(applySuppressionToRow);
        },

        // Get Run Charge Breakdown for Decoration Type 0 (PCNA)
        getRunChargeBreakdownType0(item, parentItem = null) {
            if (!item.decoration || !item.decoration.master_service) {
                return [];
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error(
                        "Error parsing decoration in getRunChargeBreakdown:",
                        e
                    );
                    return [];
                }
            }

            const quantity = this.getTotalItemQuantity(item);
            const masterService = decoration.master_service || {};
            const location1stFee = parseFloat(masterService.location_1st || 0);
            const additionalLocationFee = parseFloat(
                masterService.additional_location || 0
            );
            const costPerColor1st = parseFloat(
                masterService.cost_per_color_1st || 0
            );
            const costPerColor2ndOrMore = parseFloat(
                masterService.cost_per_color_2ndormore || 0
            );

            const breakdown = [];
            const suppressConfig = this.getSuppressAdditionalSetupRunChargeConfig(
                item,
                parentItem
            );
            const effectiveImprintLocations = this.getEffectiveImprintLocations(
                item,
                parentItem
            );
            const groupedLocations = this.getLocationGroupingMetadata(
                effectiveImprintLocations,
                suppressConfig.enabled
            );
            if (groupedLocations.length > 0) {
                let locationIndex = 0;
                const fullColorValue = this.getFullColorValue(item);
                // With suppress ON: only the first design-group primary uses
                // 1st-location rows; other primaries (different artwork) use
                // additional-location pricing like suppress OFF.
                let suppressGarmentFirstPrimaryAssigned = false;

                let referenceFirstLocation = null;
                if (suppressConfig.enabled) {
                    const primaryEntry = groupedLocations.find(
                        (ge) =>
                            ge.location &&
                            ge.location.is_selected &&
                            ge.isGroupPrimary
                    );
                    referenceFirstLocation =
                        primaryEntry && primaryEntry.location
                            ? primaryEntry.location
                            : null;
                } else {
                    const firstSel = groupedLocations.find(
                        (ge) => ge.location && ge.location.is_selected
                    );
                    referenceFirstLocation =
                        firstSel && firstSel.location ? firstSel.location : null;
                }
                const refSpecialty = referenceFirstLocation
                    ? this.getLocationColorUpcharge(referenceFirstLocation)
                    : 0;
                const refCustom = referenceFirstLocation
                    ? this.getLocationCustomColorUpcharge(referenceFirstLocation)
                    : 0;

                groupedLocations.forEach((groupEntry) => {
                    const location = groupEntry.location;
                    if (location && location.is_selected) {
                        const isFullColor = this.isLocationFullColor(location);
                        const noOfColors = parseInt(location.no_of_color || 0);
                        const locationName =
                            location.location ||
                            `Location ${locationIndex + 1}`;
                        const treatAsFirstLocation = suppressConfig.enabled
                            ? groupEntry.isGroupPrimary &&
                              !suppressGarmentFirstPrimaryAssigned
                            : locationIndex === 0;
                        if (treatAsFirstLocation && suppressConfig.enabled) {
                            suppressGarmentFirstPrimaryAssigned = true;
                        }
                        const isSuppressedAdditional =
                            suppressConfig.enabled && !groupEntry.isGroupPrimary;

                        if (treatAsFirstLocation) {
                            // First Location
                            const location1stTotal = location1stFee * quantity;
                            breakdown.push({
                                type: "location",
                                name: `1st Location${
                                    locationName !== "1st Location"
                                        ? " (" + locationName + ")"
                                        : ""
                                }`,
                                qty: quantity,
                                amt:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stFee,
                                total:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stTotal
                            });

                            // Full Color or Regular Colors
                            if (isFullColor && fullColorValue > 0) {
                                // Full Color for first location
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else {
                                // 1st Color
                                const color1stTotal =
                                    costPerColor1st * quantity;
                                const isEmbroideryDecoration =
                                    item.decoration_type == 2 ||
                                    item.decoration_type == 4;
                                if (
                                    !isEmbroideryDecoration ||
                                    (costPerColor1st > 0 && color1stTotal > 0)
                                ) {
                                    breakdown.push({
                                        type: "color1",
                                        name: "1st Color",
                                        qty: quantity,
                                        amt:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : costPerColor1st,
                                        total:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : color1stTotal
                                    });
                                }

                                // Additional Colors (if > 1)
                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Specialty Color and Custom Color Upcharge (if any)
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalSpecialtyUpcharge = 0;
                                let totalCustomUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        const upcharge = parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                        const stock =
                                            color.color.stock === true ||
                                            color.color.stock === 1;
                                        const colorType = String(
                                            color.color.type ||
                                                color.color.color_type ||
                                                ""
                                        )
                                            .replace(/['"]/g, "")
                                            .trim()
                                            .toLowerCase();

                                        if (upcharge > 0) {
                                            if (stock && colorType !== "vinyl") {
                                                // Specialty Color: stock = true AND upcharge > 0
                                                totalSpecialtyUpcharge +=
                                                    upcharge;
                                            } else if (colorType !== "vinyl") {
                                                // Custom Color: stock = false AND upcharge > 0
                                                totalCustomUpcharge += upcharge;
                                            }
                                        }
                                    }
                                });
                                if (totalSpecialtyUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Color",
                                        qty: quantity,
                                        amt: totalSpecialtyUpcharge,
                                        total: totalSpecialtyUpcharge * quantity
                                    });
                                }
                                if (totalCustomUpcharge > 0) {
                                    breakdown.push({
                                        type: "customColorUpcharge",
                                        name: "Custom Color",
                                        qty: quantity,
                                        amt: totalCustomUpcharge,
                                        total: totalCustomUpcharge * quantity
                                    });
                                }
                            }

                            // Name/Number Fees for first location (match actual imprint side, not always "front")
                            if (treatAsFirstLocation) {
                                const locationKey =
                                    this.normalizeImprintLocationKey(
                                        locationName
                                    ) || "front";
                                const locationFees =
                                    this.getNameNumberFeesFromItemPrices(
                                        item,
                                        locationKey
                                    );

                                locationFees.forEach((fee) => {
                                    if (fee.total > 0) {
                                        breakdown.push({
                                            type: "nameNumberFee",
                                            name: fee.name,
                                            qty: fee.qty,
                                            amt: fee.amt,
                                            total: fee.total
                                        });
                                    }
                                });
                            }
                        } else {
                            // Additional Location
                            breakdown.push({
                                type: "location",
                                name: `Additional Location (${locationName})`,
                                qty: quantity,
                                amt: isSuppressedAdditional
                                    ? 0
                                    : additionalLocationFee,
                                total: isSuppressedAdditional
                                    ? 0
                                    : additionalLocationFee * quantity,
                                is_suppressed_by_group: isSuppressedAdditional
                            });
                            if (isSuppressedAdditional) {
                                // Match ImprintCityPriceBreakdown / Design Studio: under
                                // suppressed additional sites, show $0 Full Color / Addl Color
                                // and mirror first-location Specialty & Custom when applicable.
                                if (isFullColor || noOfColors > 0) {
                                    if (isFullColor) {
                                        breakdown.push({
                                            type: "fullColor",
                                            name: "Full Color",
                                            qty: quantity,
                                            amt: 0,
                                            total: 0,
                                            is_suppressed_by_group: true
                                        });
                                    } else {
                                        breakdown.push({
                                            type: "addlColor",
                                            name: `Addl Color (${noOfColors})`,
                                            qty: quantity * noOfColors,
                                            amt: 0,
                                            total: 0,
                                            is_suppressed_by_group: true
                                        });
                                    }
                                }
                                if (refSpecialty > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Color",
                                        qty: quantity,
                                        amt: 0,
                                        total: 0,
                                        is_suppressed_by_group: true
                                    });
                                }
                                if (refCustom > 0) {
                                    breakdown.push({
                                        type: "customColorUpcharge",
                                        name: "Custom Color",
                                        qty: quantity,
                                        amt: 0,
                                        total: 0,
                                        is_suppressed_by_group: true
                                    });
                                }
                                locationIndex++;
                                return;
                            }

                            // Full Color or Regular Colors for additional location
                            if (isFullColor && fullColorValue > 0) {
                                // Full Color for additional location - use same value as first location
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else if (noOfColors > 0) {
                                // 1st Color for additional location - always cost_per_color_1st (admin-aligned)
                                const firstColorCost = costPerColor1st;

                                if (firstColorCost > 0) {
                                    breakdown.push({
                                        type: "color1",
                                        name: "1st Color",
                                        qty: quantity,
                                        amt: firstColorCost,
                                        total: firstColorCost * quantity
                                    });
                                }

                                // Additional Colors (if > 1)
                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Specialty Color and Custom Color Upcharge (if any)
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalSpecialtyUpcharge = 0;
                                let totalCustomUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        const upcharge = parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                        const stock =
                                            color.color.stock === true ||
                                            color.color.stock === 1;
                                        const colorType = String(
                                            color.color.type ||
                                                color.color.color_type ||
                                                ""
                                        )
                                            .replace(/['"]/g, "")
                                            .trim()
                                            .toLowerCase();

                                        if (upcharge > 0) {
                                            if (stock && colorType !== "vinyl") {
                                                // Specialty Color: stock = true AND upcharge > 0
                                                totalSpecialtyUpcharge +=
                                                    upcharge;
                                            } else if (colorType !== "vinyl") {
                                                // Custom Color: stock = false AND upcharge > 0
                                                totalCustomUpcharge += upcharge;
                                            }
                                        }
                                    }
                                });
                                if (totalSpecialtyUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Color",
                                        qty: quantity,
                                        amt: totalSpecialtyUpcharge,
                                        total: totalSpecialtyUpcharge * quantity
                                    });
                                }
                                if (totalCustomUpcharge > 0) {
                                    breakdown.push({
                                        type: "customColorUpcharge",
                                        name: "Custom Color",
                                        qty: quantity,
                                        amt: totalCustomUpcharge,
                                        total: totalCustomUpcharge * quantity
                                    });
                                }
                            }

                            // Name/Number Fees for additional locations
                            // Normalize compound names like "left sleeve", "right sleeve" etc. to core locations
                            const locationNameLowerRaw = (
                                locationName || ""
                            )
                                .toLowerCase()
                                .trim();
                            let locationKey = locationNameLowerRaw;
                            if (locationKey.includes("front")) {
                                locationKey = "front";
                            } else if (locationKey.includes("back")) {
                                locationKey = "back";
                            } else if (locationKey.includes("left")) {
                                locationKey = "left";
                            } else if (locationKey.includes("right")) {
                                locationKey = "right";
                            }
                            const nameNumberFees =
                                this.getNameNumberFeesFromItemPrices(
                                    item,
                                    locationKey
                                );
                            nameNumberFees.forEach((fee) => {
                                if (fee.total > 0) {
                                    breakdown.push({
                                        type: "nameNumberFee",
                                        name: fee.name,
                                        qty: fee.qty,
                                        amt: fee.amt,
                                        total: fee.total
                                    });
                                }
                            });
                        }

                        locationIndex++;
                    }
                });
            }

            const existingFeeNamesType0 = breakdown
                .filter((row) => row.type === "nameNumberFee")
                .map((row) => row.name);
            this.appendOrphanNameNumberFeesForAllowedImprints(
                item,
                breakdown,
                existingFeeNamesType0
            );

            return breakdown;
        },

        // Get Run Charge Breakdown for Decoration Type 1 (Screen Print) and 2 (Embroidery)
        getRunChargeBreakdownType1And2(item, parentItem = null) {
            if (!item.decoration) {
                return [];
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error(
                        "Error parsing decoration in getRunChargeBreakdownType1And2:",
                        e
                    );
                    return [];
                }
            }

            const imprintLocations = this.getEffectiveImprintLocations(
                item,
                parentItem
            );
            if (!imprintLocations.length) {
                return [];
            }

            // Get price_decoration_bulk from decoration or item
            let priceBulk =
                decoration.price_decoration_bulk || item.price_decoration_bulk;
            if (typeof priceBulk === "string") {
                try {
                    priceBulk = JSON.parse(priceBulk);
                } catch (e) {
                    console.error("Error parsing price_decoration_bulk:", e);
                    return [];
                }
            }

            if (!priceBulk) {
                return [];
            }

            const lineQuantity = this.getTotalItemQuantity(item);
            const tierQuantity = this.getTierQuantityForItem(item, parentItem);
            const breakdown = [];

            // Get master service data for stitch cost (embroidery)
            const masterService = decoration.master_service || {};
            const stitchCost = parseFloat(masterService.emb_1000_over_10k || 0);
            const stitchCount = parseFloat(item.design_area_inches || 0); // Assuming design_area_inches contains stitch count
            const location1stFee = parseFloat(masterService.location_1st || 0);
            const additionalLocationFee = parseFloat(
                masterService.additional_location || 0
            );
            const costPerColor1st = parseFloat(
                masterService.cost_per_color_1st || 0
            );
            const costPerColor2ndOrMore = parseFloat(
                masterService.cost_per_color_2ndormore || 0
            );

            // Find first selected location
            const firstLocation =
                imprintLocations.find((loc) => loc.is_selected) ||
                imprintLocations[0];
            if (!firstLocation) {
                return [];
            }

            const firstLocationName = firstLocation.location || "1st Location";
            const firstLocationColorCount = this.getLocationColorCount(
                firstLocation
            );
            const isFirstLocationFullColor =
                this.isLocationFullColor(firstLocation);
            const fullColorValue = this.getFullColorValue(item);

            // 1st Location
            breakdown.push({
                type: "location",
                name: `1st Location${
                    firstLocationName !== "1st Location"
                        ? " (" + firstLocationName + ")"
                        : ""
                }`,
                qty: lineQuantity,
                amt: location1stFee > 0 ? location1stFee : "INCL",
                total:
                    location1stFee > 0 ? location1stFee * lineQuantity : "INCL",
                isIncluded: location1stFee <= 0
            });

            // Full Color or Regular Colors for first location
            if (isFirstLocationFullColor && fullColorValue > 0) {
                // Full Color for first location
                breakdown.push({
                    type: "fullColor",
                    name: "Full Color",
                    qty: lineQuantity,
                    amt: fullColorValue,
                    total: fullColorValue * lineQuantity,
                    isIncluded: false
                });
            } else {
                // 1st Color (hide INCL row only for embroidery type 2/4)
                const isEmbroideryDecoration =
                    item.decoration_type == 2 || item.decoration_type == 4;
                if (!isEmbroideryDecoration || costPerColor1st > 0) {
                    breakdown.push({
                        type: "color1",
                        name: "1st Color",
                        qty: lineQuantity,
                        amt: costPerColor1st > 0 ? costPerColor1st : "INCL",
                        total:
                            costPerColor1st > 0
                                ? costPerColor1st * lineQuantity
                                : "INCL",
                        isIncluded: costPerColor1st <= 0
                    });
                }

                // Addl Color for 1st Location
                if (firstLocationColorCount > 1) {
                    const addlColors = firstLocationColorCount - 1;
                    let addlColorPrice = 0;

                    if (
                        item.decoration_type == 1 ||
                        item.decoration_type == 5
                    ) {
                        addlColorPrice = this.getFirstLocationAddlColorPrice(
                            item,
                            priceBulk,
                            tierQuantity,
                            firstLocationColorCount
                        );
                    } else if (
                        item.decoration_type == 2 ||
                        item.decoration_type == 4
                    ) {
                        addlColorPrice = costPerColor2ndOrMore;
                    }

                    if (addlColorPrice > 0) {
                        breakdown.push({
                            type: "addlColor",
                            name: `Addl Color (${addlColors})`,
                            qty: lineQuantity * addlColors,
                            amt: addlColorPrice,
                            total: addlColorPrice * addlColors * lineQuantity,
                            isIncluded: false
                        });
                    }
                }
            }

            // Specialty Color (color upcharge) for 1st Location
            const firstLocationUpcharge = this.getLocationColorUpcharge(
                firstLocation,
                item
            );
            if (firstLocationUpcharge > 0) {
                breakdown.push({
                    type: "colorUpcharge",
                    name: "Specialty Color",
                    qty: lineQuantity,
                    amt: firstLocationUpcharge,
                    total: firstLocationUpcharge * lineQuantity,
                    isIncluded: false
                });
            }

            // Custom Color (color upcharge) for 1st Location
            const firstLocationCustomUpcharge =
                this.getLocationCustomColorUpcharge(firstLocation, item);
            if (firstLocationCustomUpcharge > 0) {
                breakdown.push({
                    type: "customColorUpcharge",
                    name: "Custom Color",
                    qty: lineQuantity,
                    amt: firstLocationCustomUpcharge,
                    total: firstLocationCustomUpcharge * lineQuantity,
                    isIncluded: false
                });
            }

            const firstLocKey =
                this.normalizeImprintLocationKey(firstLocationName) || "front";
            const firstNameNumberFees = this.getNameNumberFeesFromItemPrices(
                item,
                firstLocKey
            );

            firstNameNumberFees.forEach((fee) => {
                if (fee.total > 0) {
                    breakdown.push({
                        type: "nameNumberFee",
                        name: fee.name,
                        qty: fee.qty,
                        amt: fee.amt,
                        total: fee.total,
                        isIncluded: false
                    });
                }
            });

            const suppressAddlConfig =
                this.getSuppressAdditionalSetupRunChargeConfig(
                    item,
                    parentItem
                );
            const selectedForSuppressGroup = imprintLocations.filter(
                (l) => l && l.is_selected
            );
            const groupedForAdditional =
                suppressAddlConfig.enabled && selectedForSuppressGroup.length > 0
                    ? this.getLocationGroupingMetadata(
                          selectedForSuppressGroup,
                          true
                      )
                    : null;
            const additionalLocationGroupByImprint = new Map();
            if (groupedForAdditional) {
                groupedForAdditional.forEach((g) => {
                    additionalLocationGroupByImprint.set(g.location, g);
                });
            }

            // Additional Locations
            const firstSelectedIndex = imprintLocations.findIndex(
                (loc) => loc.is_selected
            );
            const additionalLocations = imprintLocations.filter((loc, idx) => {
                return loc.is_selected && idx !== firstSelectedIndex;
            });

            additionalLocations.forEach((location, idx) => {
                const groupMeta = additionalLocationGroupByImprint.get(
                    location
                );
                const isPrimaryInSuppressGroup = groupMeta
                    ? !!groupMeta.isGroupPrimary
                    : true;
                const isAdditionalLocationSuppressed =
                    suppressAddlConfig.enabled && !isPrimaryInSuppressGroup;

                const locationName = location.location || `Location ${idx + 2}`;
                const colorCount = this.getLocationColorCount(location);
                const isLocationFullColor = this.isLocationFullColor(location);
                const isEmbroideryDecoration =
                    item.decoration_type == 2 || item.decoration_type == 4;
                const embroideryLocationPrice = isEmbroideryDecoration
                    ? this.getEmbroideryLocationPrice(item, priceBulk, tierQuantity)
                    : 0;
                const effectiveAdditionalLocationFee =
                    isEmbroideryDecoration && embroideryLocationPrice > 0
                        ? embroideryLocationPrice
                        : additionalLocationFee;

                // Check if location has name/number fees
                const locationNameLowerRaw = (locationName || "")
                    .toLowerCase()
                    .trim();
                let locationKey = locationNameLowerRaw;
                if (locationKey.includes("front")) {
                    locationKey = "front";
                } else if (locationKey.includes("back")) {
                    locationKey = "back";
                } else if (locationKey.includes("left")) {
                    locationKey = "left";
                } else if (locationKey.includes("right")) {
                    locationKey = "right";
                }
                let nameNumberFeesForLocation =
                    this.getNameNumberFeesFromItemPrices(item, locationKey);
                const hasNameNumberFees =
                    nameNumberFeesForLocation.length > 0 &&
                    nameNumberFeesForLocation.some((fee) => fee.total > 0);

                // Skip only if no colors, not full color, AND no name/number fees
                if (
                    colorCount <= 0 &&
                    !isLocationFullColor &&
                    !hasNameNumberFees
                )
                    return;

                // Additional Location
                breakdown.push({
                    type: "location",
                    name: `Additional Location${
                        locationName ? " (" + locationName + ")" : ""
                    }`,
                    qty: lineQuantity,
                    amt:
                        effectiveAdditionalLocationFee > 0
                            ? effectiveAdditionalLocationFee
                            : "INCL",
                    total:
                        effectiveAdditionalLocationFee > 0
                            ? effectiveAdditionalLocationFee * lineQuantity
                            : "INCL",
                    isIncluded: effectiveAdditionalLocationFee <= 0
                });

                // Full Color or Addl Color for additional location
                if (isLocationFullColor && fullColorValue > 0) {
                    // Full Color for additional location - use same value as first location
                    breakdown.push({
                        type: "fullColor",
                        name: "Full Color",
                        qty: lineQuantity,
                        amt: fullColorValue,
                        total: fullColorValue * lineQuantity,
                        isIncluded: false
                    });
                } else if (colorCount > 0) {
                    if (
                        item.decoration_type == 1 ||
                        item.decoration_type == 5
                    ) {
                        // Screen Print (type 1):
                        // (template colourN + master addl color) * (N * qty)
                        const templateLocation2ColorPrice =
                            this.getAdditionalLocationAddlColorPrice(
                                item,
                                priceBulk,
                                tierQuantity,
                                colorCount
                            );
                        const combinedType1Unit =
                            templateLocation2ColorPrice + costPerColor2ndOrMore;

                        if (combinedType1Unit > 0) {
                            breakdown.push({
                                type: "addlColor",
                                name: `Addl Color (${colorCount})`,
                                qty: lineQuantity * colorCount,
                                amt: combinedType1Unit,
                                total:
                                    combinedType1Unit *
                                    colorCount *
                                    lineQuantity,
                                isIncluded: false
                            });
                        }
                    } else if (
                        item.decoration_type == 2 ||
                        item.decoration_type == 4
                    ) {
                        // Embroidery (type 2/4):
                        // Additional location price is shown in the location row.
                        // Only true additional thread colors stay under Addl Color.
                        if (colorCount > 1 && costPerColor2ndOrMore > 0) {
                            const addlCount = colorCount;
                            breakdown.push({
                                type: "addlColor",
                                name: `Addl Color (${addlCount})`,
                                qty: lineQuantity * addlCount,
                                amt: costPerColor2ndOrMore,
                                total:
                                    costPerColor2ndOrMore *
                                    addlCount *
                                    lineQuantity,
                                isIncluded: false
                            });
                        }
                    }
                }

                // Specialty Color for additional location
                const locationUpcharge = this.getLocationColorUpcharge(
                    location,
                    item
                );
                if (locationUpcharge > 0) {
                    breakdown.push({
                        type: "colorUpcharge",
                        name: "Specialty Color",
                        qty: lineQuantity,
                        amt: locationUpcharge,
                        total: locationUpcharge * lineQuantity,
                        isIncluded: false
                    });
                } else if (
                    isAdditionalLocationSuppressed &&
                    firstLocationUpcharge > 0
                ) {
                    breakdown.push({
                        type: "colorUpcharge",
                        name: "Specialty Color",
                        qty: lineQuantity,
                        amt: 0,
                        total: 0,
                        isIncluded: false
                    });
                }

                // Custom Color for additional location
                const locationCustomUpcharge =
                    this.getLocationCustomColorUpcharge(location, item);
                if (locationCustomUpcharge > 0) {
                    breakdown.push({
                        type: "customColorUpcharge",
                        name: "Custom Color",
                        qty: lineQuantity,
                        amt: locationCustomUpcharge,
                        total: locationCustomUpcharge * lineQuantity,
                        isIncluded: false
                    });
                } else if (
                    isAdditionalLocationSuppressed &&
                    firstLocationCustomUpcharge > 0
                ) {
                    breakdown.push({
                        type: "customColorUpcharge",
                        name: "Custom Color",
                        qty: lineQuantity,
                        amt: 0,
                        total: 0,
                        isIncluded: false
                    });
                }

                // Name/Number Fees for additional location
                // Use the fees we already found above
                nameNumberFeesForLocation.forEach((fee) => {
                    if (fee.total > 0) {
                        breakdown.push({
                            type: "nameNumberFee",
                            name: fee.name,
                            qty: fee.qty,
                            amt: fee.amt,
                            total: fee.total,
                            isIncluded: false
                        });
                    }
                });
            });

            const existingFeeNamesType12 = breakdown
                .filter((row) => row.type === "nameNumberFee")
                .map((row) => row.name);
            this.appendOrphanNameNumberFeesForAllowedImprints(
                item,
                breakdown,
                existingFeeNamesType12,
                { isIncluded: false }
            );

            // Stitch Cost for Embroidery (if stitchCount > 10000)
            if (
                (item.decoration_type == 2 || item.decoration_type == 4) &&
                stitchCount > 10000 &&
                stitchCost > 0
            ) {
                const remainingStitches = stitchCount - 10000;
                const costPer1000Stitches = stitchCost;
                const totalStitchCost =
                    Math.ceil(remainingStitches / 1000) * costPer1000Stitches;

                breakdown.push({
                    type: "stitchCost",
                    name: "Stitch Cost",
                    qty: lineQuantity,
                    amt: totalStitchCost / lineQuantity,
                    total: totalStitchCost * lineQuantity,
                    isIncluded: false
                });
            }

            return this.organizeBreakdownByLocation(breakdown);
        },

        // Match CartSummary: flat breakdown → location buckets for ToolTip nested rendering
        organizeBreakdownByLocation(breakdown) {
            if (
                !breakdown ||
                !Array.isArray(breakdown) ||
                breakdown.length === 0
            ) {
                return breakdown;
            }

            const locations = [];
            let currentLocation = null;

            breakdown.forEach((item) => {
                const formattedItem = { ...item };

                if (formattedItem.amt !== "INCL" && formattedItem.amt !== "-") {
                    const numAmt =
                        typeof formattedItem.amt === "string"
                            ? parseFloat(formattedItem.amt)
                            : formattedItem.amt;
                    if (!isNaN(numAmt) && typeof numAmt === "number") {
                        formattedItem.amt = parseFloat(numAmt).toFixed(2);
                    }
                }

                if (
                    formattedItem.total !== "INCL" &&
                    formattedItem.total !== "-"
                ) {
                    const numTotal =
                        typeof formattedItem.total === "string"
                            ? parseFloat(formattedItem.total)
                            : formattedItem.total;
                    if (!isNaN(numTotal) && typeof numTotal === "number") {
                        formattedItem.total = parseFloat(numTotal).toFixed(2);
                    }
                }

                if (formattedItem.type === "location") {
                    if (currentLocation) {
                        locations.push(currentLocation);
                    }

                    let locationName = "Location";
                    const match = formattedItem.name.match(/\(([^)]+)\)/);
                    if (match) {
                        locationName = match[1];
                    } else if (formattedItem.name.includes("1st Location")) {
                        locationName = "Front";
                    } else if (
                        formattedItem.name.includes("Additional Location")
                    ) {
                        locationName =
                            formattedItem.name
                                .replace("Additional Location", "")
                                .trim()
                                .replace(/[()]/g, "") || "Back";
                    }

                    currentLocation = {
                        location: locationName,
                        locationName: formattedItem.name,
                        items: [formattedItem]
                    };
                } else if (currentLocation) {
                    currentLocation.items.push(formattedItem);
                } else {
                    currentLocation = {
                        location: "Default",
                        locationName: "Default Location",
                        items: [formattedItem]
                    };
                }
            });

            if (currentLocation) {
                locations.push(currentLocation);
            }

            return locations.length > 0 ? locations : breakdown;
        },

        logRunChargeBreakdownDebug(label, item, breakdown) {
            try {
                if (
                    typeof localStorage === "undefined" ||
                    localStorage.getItem("DEBUG_RUN_CHARGE") !== "1"
                ) {
                    return;
                }
                const flat =
                    breakdown &&
                    breakdown.length &&
                    breakdown[0] &&
                    Array.isArray(breakdown[0].items)
                        ? breakdown.flatMap((loc) =>
                              (loc.items || []).map((r) => ({
                                  ...r,
                                  _bucket: loc.location
                              }))
                          )
                        : Array.isArray(breakdown)
                        ? breakdown.slice()
                        : [];
            } catch (e) {
            }
        },

        // Get First Location Additional Color Price (for type 1)
        getFirstLocationAddlColorPrice(item, priceBulk, quantity, colorCount) {
            if (
                !priceBulk ||
                !priceBulk.print_location1 ||
                (item.decoration_type != 1 && item.decoration_type != 5)
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location1;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let lastColorPrice = 0;
            let firstColorPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    lastColorPrice = parseFloat(
                        tier[`colour${colorCount}`] || 0
                    );
                    firstColorPrice = parseFloat(tier.colour1 || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (lastColorPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                lastColorPrice = parseFloat(
                    firstTier[`colour${colorCount}`] || 0
                );
                firstColorPrice = parseFloat(firstTier.colour1 || 0);
            }

            // Additional color price is template delta + master additional-color cost
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    decoration = null;
                }
            }
            const masterAddlColor = parseFloat(
                (((decoration || {}).master_service || {})
                    .cost_per_color_2ndormore || 0)
            );
            return Math.max(0, lastColorPrice - firstColorPrice) + masterAddlColor;
        },

        // Get Additional Location Additional Color Price (for type 1)
        getAdditionalLocationAddlColorPrice(
            item,
            priceBulk,
            quantity,
            colorCount
        ) {
            if (
                !priceBulk ||
                !priceBulk.print_location2 ||
                (item.decoration_type != 1 && item.decoration_type != 5)
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location2;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let directPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    directPrice = parseFloat(tier[`colour${colorCount}`] || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (directPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                directPrice = parseFloat(firstTier[`colour${colorCount}`] || 0);
            }

            return directPrice;
        },

        // Get Embroidery Location Price (for type 2)
        getEmbroideryLocationPrice(item, priceBulk, quantity) {
            if (!priceBulk || (item.decoration_type != 2 && item.decoration_type != 4)) {
                return 0;
            }

            // For embroidery, priceBulk is an array
            if (!Array.isArray(priceBulk)) {
                return 0;
            }

            // Find the price tier for current quantity
            let selectedRow = null;

            for (const row of priceBulk) {
                if (row.quantity1 && row.quantity2) {
                    if (
                        quantity >= parseInt(row.quantity1) &&
                        quantity <= parseInt(row.quantity2)
                    ) {
                        selectedRow = row;
                        break;
                    }
                } else if (
                    row.quantity1 &&
                    quantity >= parseInt(row.quantity1)
                ) {
                    selectedRow = row;
                    break;
                }
            }

            // If no tier found, use first tier
            if (!selectedRow && priceBulk.length > 0) {
                selectedRow = priceBulk[0];
            }

            if (selectedRow && selectedRow.location2 !== undefined) {
                return parseFloat(selectedRow.location2 || 0);
            }

            return 0;
        },

        // Get Location Color Upcharge
        getLocationColorUpcharge(location) {
            if (
                !location ||
                !location.colors ||
                !Array.isArray(location.colors)
            ) {
                return 0;
            }

            let totalUpcharge = 0;
            location.colors.forEach((colorObj) => {
                if (
                    colorObj &&
                    colorObj.color &&
                    colorObj.color.decor_upcharge
                ) {
                    const upcharge = parseFloat(
                        colorObj.color.decor_upcharge || 0
                    );
                    const stock =
                        colorObj.color.stock === true ||
                        colorObj.color.stock === 1;
                    const colorType = String(
                        colorObj.color.type || colorObj.color.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    // Only include specialty colors: stock = true AND upcharge > 0
                    if (upcharge > 0 && stock && colorType !== "vinyl") {
                        totalUpcharge += upcharge;
                    }
                }
            });

            return parseFloat(totalUpcharge.toFixed(2));
        },
        getLocationCustomColorUpcharge(location) {
            if (
                !location ||
                !location.colors ||
                !Array.isArray(location.colors)
            ) {
                return 0;
            }

            let totalUpcharge = 0;
            location.colors.forEach((colorObj) => {
                if (
                    colorObj &&
                    colorObj.color &&
                    colorObj.color.decor_upcharge
                ) {
                    const upcharge = parseFloat(
                        colorObj.color.decor_upcharge || 0
                    );
                    const stock =
                        colorObj.color.stock === true ||
                        colorObj.color.stock === 1;
                    const colorType = String(
                        colorObj.color.type || colorObj.color.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    // Only include custom colors: stock = false AND upcharge > 0
                    if (upcharge > 0 && !stock && colorType !== "vinyl") {
                        totalUpcharge += upcharge;
                    }
                }
            });

            return parseFloat(totalUpcharge.toFixed(2));
        },

        // Get Name/Number Fees from item_prices for a specific location
        getNameNumberFeesFromItemPrices(item, locationName) {
            const fees = [];

            if (!item.item_prices) {
                return fees;
            }

            // Parse item_prices if it's a string
            let itemPrices = item.item_prices;
            if (typeof itemPrices === "string") {
                try {
                    itemPrices = JSON.parse(itemPrices);
                } catch (e) {
                    console.error("Error parsing item_prices:", e);
                    return fees;
                }
            }

            if (!itemPrices.selected_name_number) {
                return fees;
            }

            const selectedNameNumber = itemPrices.selected_name_number;
            const location = locationName.toLowerCase();

            // Get real-time fees from VendorFees (if available)
            let nameFeePerItem = null;
            let numberFeePerItem = null;

            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;

                // Get Name Fee (only if rollup_fee_id exists)
                const nameService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "name" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("name")))
                );
                if (nameService && nameService.retail_cost) {
                    nameFeePerItem = parseFloat(nameService.retail_cost) || 0;
                }

                // Get Number Fee (only if rollup_fee_id exists)
                const numberService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "number" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("number")))
                );
                if (numberService && numberService.retail_cost) {
                    numberFeePerItem =
                        parseFloat(numberService.retail_cost) || 0;
                }
            }

            // Front location
            if (location === "front" && selectedNameNumber.front) {
                const front = selectedNameNumber.front;

                // Front Name Fee
                if (
                    front.name &&
                    typeof front.name === "object" &&
                    front.name.front_name_count &&
                    parseInt(front.name.front_name_count || 0) > 0 &&
                    nameFeePerItem !== null &&
                    nameFeePerItem > 0
                ) {
                    const count = parseInt(front.name.front_name_count || 0);
                    const perPrice = nameFeePerItem;
                    const totalFee = count * perPrice;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Front Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    }
                }

                // Front Name Decor Up Fee (from item_prices)
                if (
                    front.name &&
                    typeof front.name === "object" &&
                    front.name.front_name_decor_up_fees !== undefined &&
                    parseFloat(front.name.front_name_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(front.name.front_name_count || 0);
                    const totalFee = parseFloat(
                        front.name.front_name_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.name.front_name_decor_up_per_price || 0
                    );
                    fees.push({
                        name: "Front Name Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Front Number Fee - Only if VendorFees has rollup_fee_id
                if (
                    front.number &&
                    front.number.front_number_count &&
                    parseInt(front.number.front_number_count || 0) > 0 &&
                    numberFeePerItem !== null &&
                    numberFeePerItem > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );

                    // Use real-time fee from VendorFees (only if rollup_fee_id exists)
                    const perPrice = numberFeePerItem;
                    const totalFee = count * perPrice;

                    if (totalFee > 0) {
                        fees.push({
                            name: "Front Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    }
                }

                // Front Number Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    front.number &&
                    front.number.front_number_decor_up_fees &&
                    front.number.front_number_decor_up_fees > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );
                    const totalFee = parseFloat(
                        front.number.front_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.number.front_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Front Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            // Back location
            if (location === "back" && selectedNameNumber.back) {
                const back = selectedNameNumber.back;

                // Back Name Fee - Only if VendorFees has rollup_fee_id
                if (
                    back.name &&
                    typeof back.name === "object" &&
                    back.name.back_name_count &&
                    parseInt(back.name.back_name_count || 0) > 0 &&
                    nameFeePerItem !== null &&
                    nameFeePerItem > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);

                    // Use real-time fee from VendorFees (only if rollup_fee_id exists)
                    const perPrice = nameFeePerItem;
                    const totalFee = count * perPrice;

                    if (totalFee > 0) {
                        fees.push({
                            name: "Back Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    }
                }

                // Back Name Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    back.name &&
                    typeof back.name === "object" &&
                    back.name.back_name_decor_up_fees !== undefined &&
                    parseFloat(back.name.back_name_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);
                    const totalFee = parseFloat(
                        back.name.back_name_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.name.back_name_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Name Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Back Number Fee - Only if VendorFees has rollup_fee_id
                if (
                    back.number &&
                    typeof back.number === "object" &&
                    back.number.back_number_count &&
                    parseInt(back.number.back_number_count || 0) > 0 &&
                    numberFeePerItem !== null &&
                    numberFeePerItem > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);

                    // Use real-time fee from VendorFees (only if rollup_fee_id exists)
                    const perPrice = numberFeePerItem;
                    const totalFee = count * perPrice;

                    if (totalFee > 0) {
                        fees.push({
                            name: "Back Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    }
                }

                // Back Number Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    back.number &&
                    typeof back.number === "object" &&
                    back.number.back_number_decor_up_fees !== undefined &&
                    parseFloat(back.number.back_number_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);
                    const totalFee = parseFloat(
                        back.number.back_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.number.back_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            // Left location (use item_prices when VendorFees not available)
            if (location === "left" && selectedNameNumber.left) {
                const left = selectedNameNumber.left;
                if (
                    left.name &&
                    typeof left.name === "object" &&
                    left.name.left_name_count &&
                    parseInt(left.name.left_name_count || 0) > 0
                ) {
                    const count = parseInt(left.name.left_name_count || 0);
                    const totalFee = parseFloat(left.name.left_name_fees || 0);
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Left Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Left Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }
                if (
                    left.number &&
                    typeof left.number === "object" &&
                    left.number.left_number_count &&
                    parseInt(left.number.left_number_count || 0) > 0
                ) {
                    const count = parseInt(left.number.left_number_count || 0);
                    const totalFee = parseFloat(
                        left.number.left_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Left Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Left Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }
            }

            // Right location (use item_prices when VendorFees not available)
            if (location === "right" && selectedNameNumber.right) {
                const right = selectedNameNumber.right;
                if (
                    right.name &&
                    typeof right.name === "object" &&
                    right.name.right_name_count &&
                    parseInt(right.name.right_name_count || 0) > 0
                ) {
                    const count = parseInt(right.name.right_name_count || 0);
                    const totalFee = parseFloat(
                        right.name.right_name_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Right Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Right Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }
                if (
                    right.number &&
                    typeof right.number === "object" &&
                    right.number.right_number_count &&
                    parseInt(right.number.right_number_count || 0) > 0
                ) {
                    const count = parseInt(
                        right.number.right_number_count || 0
                    );
                    const totalFee = parseFloat(
                        right.number.right_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Right Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Right Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }
            }

            return fees;
        },

        // Get Custom Color Fee Data for Decoration Type 0, 1, and 2
        getColorMixFeeData(item) {
            if (
                (item.decoration_type != 0 &&
                    item.decoration_type != 1 &&
                    item.decoration_type != 5 &&
                    item.decoration_type != 2 &&
                    item.decoration_type != 4) ||
                !item.decoration
            ) {
                return null;
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error("Error parsing decoration:", e);
                    return null;
                }
            }

            const colorType = this.getNormalizedColorTypeFromDecoration(
                decoration
            );
            const isThread = colorType === "thread";
            const isInk = colorType === "ink";
            if (!isThread && !isInk) return null;

            // Get fee per color - prioritize VendorFees (real-time) over decoration.color_mix_fee
            let feePerColor = 0;

            // First, try to get from VendorFees (real-time update from API)
            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;
                let targetService = null;

                if (isThread) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee")))
                    );
                } else if (isInk) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee")))
                    );
                } 

                if (targetService && targetService.retail_cost) {
                    feePerColor = parseFloat(targetService.retail_cost) || 0;
                }
            }

            // NO FALLBACK - Only use VendorFees with rollup_fee_id
            // If VendorFees not available or fee is 0, feePerColor remains 0

            // Get unique non-standard color count (color_id == 0)
            // This should be per-item, so each item with different colors will have different count
            const mixColorCount = this.getUniqueNonStandardColors(item);

            // Return null only if fee is missing/zero (colors can be 0, but fee must exist)
            if (!feePerColor || feePerColor <= 0) {
                return null;
            }

            // Calculate total (unique count × fee per color, NO quantity multiplication)
            const total = mixColorCount * feePerColor;

            // Determine fee label based on decoration type and service name
            let feeLabel = "Color Ink Mix Fee"; // Default

            if (isThread) {
                feeLabel = "Color Thread Mix Fee";
            }

            return {
                label: feeLabel,
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };
        },

        // Get unique non-standard colors from imprint_locations (for type 0) or non_standard_colors (for type 1 and 2)
        getUniqueNonStandardColors(item) {
            const uniqueColors = new Set();

            // For decoration type 1 and 2, use non_standard_colors array
            if (item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) {
                let nonStandardColors = item.non_standard_colors;
                if (typeof nonStandardColors === "string") {
                    try {
                        nonStandardColors = JSON.parse(nonStandardColors);
                    } catch (e) {
                        console.error("Error parsing non_standard_colors:", e);
                        return 0;
                    }
                }

                if (nonStandardColors && Array.isArray(nonStandardColors)) {
                    nonStandardColors.forEach((colorHex) => {
                        if (colorHex && typeof colorHex === "string") {
                            const colorKey = colorHex.toLowerCase();
                            if (
                                colorKey &&
                                colorKey !== "#gggggg" &&
                                colorKey !== ""
                            ) {
                                uniqueColors.add(colorKey);
                            }
                        }
                    });
                }

                return uniqueColors.size;
            }

            // For decoration type 0, use imprint_locations
            // Parse imprint_locations if it's a string
            let imprintLocations = item.imprint_locations;
            if (typeof imprintLocations === "string") {
                try {
                    imprintLocations = JSON.parse(imprintLocations);
                } catch (e) {
                    console.error("Error parsing imprint_locations:", e);
                    return 0;
                }
            }

            if (!imprintLocations || !Array.isArray(imprintLocations)) {
                return 0;
            }

            imprintLocations.forEach((location) => {
                if (
                    location &&
                    location.is_selected &&
                    location.colors &&
                    Array.isArray(location.colors)
                ) {
                    location.colors.forEach((colorObj) => {
                        if (colorObj && colorObj.color) {
                            const color = colorObj.color;
                            const colorId = parseInt(color.color_id || 0);

                            // Check if it's a non-standard color (color_id == 0)
                            if (colorId === 0) {
                                // Use color_value or hex as unique identifier
                                const colorKey = (
                                    color.color_value ||
                                    color.hex ||
                                    ""
                                ).toLowerCase();
                                if (
                                    colorKey &&
                                    colorKey !== "#gggggg" &&
                                    colorKey !== ""
                                ) {
                                    uniqueColors.add(colorKey);
                                }
                            }
                        }
                    });
                }
            });

            return uniqueColors.size;
        },

        // Get Color Mix Fee Total
        getColorMixFeeTotal(item) {
            let total = 0;
            const mixFeeData = this.getColorMixFeeData(item);
            if (mixFeeData && mixFeeData.total > 0) {
                total += parseFloat(mixFeeData.total);
            }

            // Add services with rollup_fee_id = 13 (Color Mix Fee services) - include all services regardless of show_service
            const colorMixFeeServices = this.getColorMixFeeServices(item);
            if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                colorMixFeeServices.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        getAssemblyDecorationServiceId(item) {
            if (!item) return null;
            // Extract service ID from decoration JSON
            let decoration = item.decoration;
            if (decoration) {
                if (typeof decoration === "string") {
                    try { decoration = JSON.parse(decoration); } catch (e) { decoration = null; }
                }
                if (decoration) {
                    // Priority 1: decoration.id is the direct service ID
                    if (decoration.id) return String(decoration.id);
                    // Priority 2: legacy fallback via master_service.id
                    const masterService = decoration.master_service || null;
                    if (masterService && masterService.id) return String(masterService.id);
                }
            }
            // decoration_type 1/2/3 have no decoration JSON → use "type_N" as last resort
            if (item.decoration_type != null && item.decoration_type !== "") {
                return `type_${item.decoration_type}`;
            }
            return null;
        },
        getAssemblyDecoratorId(item) {
            if (!item || !item.main_new_product) return null;
            const decoratorId = item.main_new_product.default_decorator_id;
            return decoratorId !== undefined && decoratorId !== null && decoratorId !== ""
                ? String(decoratorId)
                : null;
        },
        getAssemblyVendorId(item) {
            if (!item || !item.main_new_product) return null;
            const product = item.main_new_product;
            const vendorId =
                product.vendor_id ||
                product.default_vendor_id ||
                (product.Vendor && product.Vendor.id) ||
                (product.vendor && product.vendor.id) ||
                // Fallback for data models where default decorator maps vendor.
                product.default_decorator_id ||
                null;
            return vendorId !== undefined && vendorId !== null && vendorId !== ""
                ? String(vendorId)
                : null;
        },
        getAssemblyProductCount(item) {
            if (!item) return 0;
            return 1 + (item.subItems && item.subItems.length ? item.subItems.length : 0);
        },
        getAssemblyKey(item) {
            if (!item) return null;
            // ── Priority 1: use the stored group_assembly_id (new items after migration) ──
            if (
                item.group_assembly_id &&
                item.group_assembly_id !== "null" &&
                item.group_assembly_id !== "undefined"
            ) {
                return item.group_assembly_id;
            }
            // ── Priority 2: compute from saved_design_id + serviceId (legacy items) ──
            const savedDesignId = item.saved_design_id;
            if (
                savedDesignId === undefined ||
                savedDesignId === null ||
                savedDesignId === "" ||
                savedDesignId === "null" ||
                savedDesignId === "undefined"
            ) {
                return null;
            }
            const serviceId = this.getAssemblyDecorationServiceId(item);
            if (!serviceId) {
                return null;
            }
            // decoratorId / vendorId may be absent on legacy data – use 'x' as placeholder
            const decoratorId = this.getAssemblyDecoratorId(item) || "x";
            const vendorId    = this.getAssemblyVendorId(item)    || "x";
            return [
                String(savedDesignId),
                serviceId,
                decoratorId,
                vendorId
            ].join("|");
        },
        isAssemblyGroup(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return false;
            }
            // Fast-path: if item has group_assembly_id, check subItems for same id
            if (
                item.group_assembly_id &&
                item.group_assembly_id !== "null" &&
                item.group_assembly_id !== "undefined"
            ) {
                return item.subItems.some(
                    (s) => s.group_assembly_id === item.group_assembly_id
                );
            }
            // Fallback: computed key match
            const assemblyKey = this.getAssemblyKey(item);
            if (!assemblyKey) {
                return false;
            }
            return item.subItems.some(
                (subItem) => this.getAssemblyKey(subItem) === assemblyKey
            );
        },
        getAssemblyGroupedItems(item) {
            if (!item) return [];
            if (!item.subItems || item.subItems.length === 0) return [item];
            return [item, ...item.subItems];
        },
        // Check if item is part of a grouped decoration type 0, 1, or 2
        // For type 0: same item_id + same service
        // For type 1 and 2: same item_id + same decoration_type + same decoration_price_template
        isGroupedDecorationType0(item) {
            // Only for decoration type 0, 1, and 2
            if (
                item.decoration_type !== 0 &&
                item.decoration_type !== 1 &&
                item.decoration_type !== 2 &&
                item.decoration_type !== 4
            ) {
                return false;
            }

            // Check if this item has subItems
            if (!item.subItems || item.subItems.length === 0) {
                return false;
            }

            // Assembly group: same saved_design_id across parent and sub-items
            if (this.isAssemblyGroup(item)) {
                return true;
            }

            // For decoration type 0, check service
            if (item.decoration_type === 0) {
                // Parse decoration to get service ID
                let decoration = item.decoration;
                if (typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        return false;
                    }
                }

                const itemServiceId =
                    decoration.master_service && decoration.master_service.id
                        ? decoration.master_service.id
                        : null;

                // Check if all subItems have same item_id, decoration_type, and service
                return item.subItems.some((subItem) => {
                    if (
                        subItem.item_id !== item.item_id ||
                        subItem.decoration_type !== 0
                    ) {
                        return false;
                    }

                    let subDecoration = subItem.decoration;
                    if (typeof subDecoration === "string") {
                        try {
                            subDecoration = JSON.parse(subDecoration);
                        } catch (e) {
                            return false;
                        }
                    }

                    const subServiceId =
                        subDecoration.master_service &&
                        subDecoration.master_service.id
                            ? subDecoration.master_service.id
                            : null;

                    return itemServiceId === subServiceId;
                });
            }

            // For decoration type 1 and 2, check item_id, decoration_type, and decoration_price_template
            if (item.decoration_type === 1 || item.decoration_type === 5 || item.decoration_type === 2 || item.decoration_type === 4) {
                return item.subItems.some((subItem) => {
                    return (
                        subItem.item_id === item.item_id &&
                        subItem.decoration_type === item.decoration_type &&
                        subItem.decoration_price_template ===
                            item.decoration_price_template
                    );
                });
            }

            return false;
        },

        // Get all items in a group (parent + subItems) for decoration type 0, 1, and 2
        getGroupedItems(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return [item];
            }

            return [item, ...item.subItems];
        },

        // Get combined unique non-standard colors across all items in a group
        getCombinedUniqueNonStandardColors(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return this.getUniqueNonStandardColors(item);
            }

            const groupedItems = this.getGroupedItems(item);
            const uniqueColors = new Set();

            groupedItems.forEach((groupItem) => {
                // For decoration type 1 and 2, use non_standard_colors array
                if (
                    groupItem.decoration_type === 1 ||
                            groupItem.decoration_type === 2 ||
                            groupItem.decoration_type === 4
                ) {
                    let nonStandardColors = groupItem.non_standard_colors;
                    if (typeof nonStandardColors === "string") {
                        try {
                            nonStandardColors = JSON.parse(nonStandardColors);
                        } catch (e) {
                            return;
                        }
                    }

                    if (nonStandardColors && Array.isArray(nonStandardColors)) {
                        nonStandardColors.forEach((colorHex) => {
                            if (colorHex && typeof colorHex === "string") {
                                const colorKey = colorHex.toLowerCase();
                                if (
                                    colorKey &&
                                    colorKey !== "#gggggg" &&
                                    colorKey !== ""
                                ) {
                                    uniqueColors.add(colorKey);
                                }
                            }
                        });
                    }
                } else if (groupItem.decoration_type === 0) {
                    // For decoration type 0, use imprint_locations
                    let imprintLocations = groupItem.imprint_locations;
                    if (typeof imprintLocations === "string") {
                        try {
                            imprintLocations = JSON.parse(imprintLocations);
                        } catch (e) {
                            return;
                        }
                    }

                    if (!imprintLocations || !Array.isArray(imprintLocations)) {
                        return;
                    }

                    imprintLocations.forEach((location) => {
                        if (
                            location &&
                            location.is_selected &&
                            location.colors &&
                            Array.isArray(location.colors)
                        ) {
                            location.colors.forEach((colorObj) => {
                                if (colorObj && colorObj.color) {
                                    const color = colorObj.color;
                                    const colorId = parseInt(
                                        color.color_id || 0
                                    );

                                    // Check if it's a non-standard color (color_id == 0)
                                    if (colorId === 0) {
                                        // Use color_value or hex as unique identifier
                                        const colorKey = (
                                            color.color_value ||
                                            color.hex ||
                                            ""
                                        ).toLowerCase();
                                        if (
                                            colorKey &&
                                            colorKey !== "#gggggg" &&
                                            colorKey !== ""
                                        ) {
                                            uniqueColors.add(colorKey);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });

            return uniqueColors.size;
        },

        // Get combined color mix fee data for grouped items (type 0, 1, and 2)
        getCombinedColorMixFeeData(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return null;
            }

            // Get fee per color from first item (should be same for all items in group)
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return null;
                }
            }

            // Check if decoration is null or undefined
            if (!decoration || typeof decoration !== "object") {
                return null;
            }

            const colorType = this.getNormalizedColorTypeFromDecoration(
                decoration
            );
            const isThread = colorType === "thread";
            const isInk = colorType === "ink";
            if (!isThread && !isInk) return null;

            // Get fee per color - prioritize VendorFees (real-time) over decoration.color_mix_fee
            let feePerColor = 0;

            // First, try to get from VendorFees (real-time update from API)
            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;
                let targetService = null;

                if (isThread) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee")))
                    );
                } else if (isInk) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee")))
                    );
                } 

                if (targetService && targetService.retail_cost) {
                    feePerColor = parseFloat(targetService.retail_cost) || 0;
                }
            }

            // NO FALLBACK - Only use VendorFees with rollup_fee_id
            // If VendorFees not available or fee is 0, feePerColor remains 0

            if (!feePerColor || feePerColor <= 0) {
                return null;
            }

            // Get combined unique color count
            const mixColorCount = this.getCombinedUniqueNonStandardColors(item);

            // Calculate total
            const total = mixColorCount * feePerColor;

            // Simple label for outside display
            let feeLabel = "Color Mix Fee";

            // Detailed label for breakdown table (Color Ink Mix Fee or Color Thread Mix Fee)
            let breakdownLabel = "Color Ink Mix Fee";

            if (colorType === "thread") {
                breakdownLabel = "Color Thread Mix Fee";
            }

            return {
                label: feeLabel, // Simple label for outside
                breakdownLabel: breakdownLabel, // Detailed label for breakdown table
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };
        },

        // Get combined color mix fee total for grouped items
        getCombinedColorMixFeeTotal(item) {
            let total = 0;
            const mixFeeData = this.getCombinedColorMixFeeData(item);
            if (mixFeeData && mixFeeData.total > 0) {
                total += parseFloat(mixFeeData.total);
            }

            // Assembly groups: thread/ink mix rollup 13 from any line; other rollup 13 only on owning line.
            if (this.isAssemblyGroup(item)) {
                const groupedItems = this.getAssemblyGroupedItems(item);
                groupedItems.forEach((groupItem, idx) => {
                    const services = this.getColorMixFeeServices(groupItem);
                    if (!services || services.length === 0) return;
                    const quantity = this.getTotalItemQuantity(groupItem);
                    const isParentLine = idx === 0;
                    services.forEach((service) => {
                        if (
                            !isParentLine &&
                            !this.isPrimaryCustomColorRollupService(service)
                        ) {
                            return;
                        }
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            total += parseFloat(servicePrice) * quantity;
                        } else {
                            total += parseFloat(servicePrice);
                        }
                    });
                });
            } else if (item.subItems && item.subItems.length > 0) {
                // Legacy grouped flow: add services from sub-items.
                item.subItems.forEach((subItem) => {
                    const colorMixFeeServices =
                        this.getColorMixFeeServices(subItem);
                    if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                        const quantity = this.getTotalItemQuantity(subItem);
                        colorMixFeeServices.forEach((service) => {
                            const servicePrice =
                                service.retail_cost || service.net_cost || 0;
                            if (service.fee_structure === "Per Item") {
                                total += parseFloat(servicePrice) * quantity;
                            } else {
                                total += parseFloat(servicePrice);
                            }
                        });
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },
        // Check if grouped items have rollup_fee_id = 13 services
        hasCombinedColorMixFeeServices(item) {
            if (this.isAssemblyGroup(item)) {
                const groupedItems = this.getAssemblyGroupedItems(item);
                return groupedItems.some((groupItem, idx) => {
                    const services = this.getColorMixFeeServices(groupItem);
                    if (!services || services.length === 0) return false;
                    if (idx === 0) return true;
                    return services.some((s) =>
                        this.isPrimaryCustomColorRollupService(s)
                    );
                });
            }
            if (!item.subItems || item.subItems.length === 0) {
                return false;
            }
            return item.subItems.some((subItem) => {
                const services = this.getColorMixFeeServices(subItem);
                return services && services.length > 0;
            });
        },
        // Get combined rollup_fee_id = 13 services from all subItems
        getCombinedColorMixFeeServices(item) {
            if (this.isAssemblyGroup(item)) {
                const allServices = [];
                const groupedItems = this.getAssemblyGroupedItems(item);
                groupedItems.forEach((groupItem, idx) => {
                    const services = this.getColorMixFeeServices(groupItem);
                    if (!services || services.length === 0) return;
                    const itemQuantity = this.getTotalItemQuantity(groupItem);
                    const isParentLine = idx === 0;
                    services.forEach((service) => {
                        if (
                            !isParentLine &&
                            !this.isPrimaryCustomColorRollupService(service)
                        ) {
                            return;
                        }
                        const serviceCopy = { ...service };
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            serviceCopy._calculatedTotal =
                                parseFloat(servicePrice) * itemQuantity;
                            serviceCopy._quantity = itemQuantity;
                        } else {
                            serviceCopy._calculatedTotal =
                                parseFloat(servicePrice);
                            serviceCopy._quantity = 1;
                        }
                        allServices.push(serviceCopy);
                    });
                });
                return allServices;
            }
            if (!item.subItems || item.subItems.length === 0) {
                return [];
            }
            const allServices = [];
            item.subItems.forEach((subItem) => {
                const services = this.getColorMixFeeServices(subItem);
                if (services && services.length > 0) {
                    const subItemQuantity = this.getTotalItemQuantity(subItem);
                    services.forEach((service) => {
                        // Create a copy of the service with calculated total based on subItem quantity
                        const serviceCopy = { ...service };
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            serviceCopy._calculatedTotal =
                                parseFloat(servicePrice) * subItemQuantity;
                            serviceCopy._quantity = subItemQuantity;
                        } else {
                            serviceCopy._calculatedTotal =
                                parseFloat(servicePrice);
                            serviceCopy._quantity = 1;
                        }
                        allServices.push(serviceCopy);
                    });
                }
            });
            return allServices;
        },

        // Get item subtotal excluding color mix fee (for grouped items)
        getItemSubTotalExcludingColorMixFee(item, parentItem = null) {
            let total = 0;
            const isAssemblyChild =
                parentItem && this.isAssemblyGroup(parentItem);

            // Base Fee Total
            total += this.getBaseFeeTotal(item, parentItem);

            // Run Charge (includes name/number fees for all decoration types)
            total += this.getRunChargeTotalFromBreakdown(item, parentItem);

            // Setup Fee
            if (!isAssemblyChild) {
                if (item.setup_fees_details) {
                    total += this.getSetupFeeTotal(item);
                } else {
                    total +=
                        parseFloat(item.sp_setup_fee || 0) +
                        parseFloat(item.emb_setup_fee || 0);
                }
            } else {
                total += this.getSetupFeeServicesTotal(item);
            }

            // Rush Fee (recalculated based on current quantity)
            if (item.rush_fee_breakdown) {
                total += this.getRushFeeTotal(item);
            }

            // Patch Cost
            total += this.getDynamicPatchCostTotal(item);

            // Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
            if (item.decoration_type != 0) {
                const itemPrices = item.item_prices || {};
                total +=
                    parseFloat(itemPrices.front_number_fees || 0) +
                    parseFloat(itemPrices.back_name_fees || 0) +
                    parseFloat(itemPrices.back_number_fees || 0) +
                    parseFloat(itemPrices.front_name_fees || 0);
            }

            return total;
        },

        // Get group subtotal (all items + combined color mix fee)
        // If discount exists: Group Sub Total = Sum of (Item Sub Total - Discount) for all items
        // If discount doesn't exist: Group Sub Total = Sum of Item Sub Totals (no discount applied)
        getGroupSubTotal(item) {
            if (!this.isGroupedDecorationType0(item)) {
                // For single items
                const itemSubTotal = this.getItemSubTotal(item);
                const itemDiscount = this.getItemDiscount(item);
                // If discount exists, subtract it; otherwise return Item Sub Total
                return itemDiscount > 0
                    ? itemSubTotal - itemDiscount
                    : itemSubTotal;
            }

            let total = 0;

            // Add parent item
            const parentSubTotal = this.getItemSubTotalForGroupedParent(item);
            // Discount now applied at size cost level, not here
            total += parentSubTotal;

            // Add all subItems
            if (item.subItems && item.subItems.length > 0) {
                item.subItems.forEach((subItem) => {
                    const subItemSubTotal = this.getItemSubTotal(subItem, item);
                    // Discount now applied at size cost level, not here
                    total += subItemSubTotal;
                });
            }

            return total;
        },

        // Get Item Sub Total for grouped parent item (includes combined color mix fee)
        getItemSubTotalForGroupedParent(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return this.getItemSubTotal(item);
            }

            // Get parent's item subtotal excluding color mix fee
            let total = this.getItemSubTotalExcludingColorMixFee(item);

            // Add combined color mix fee
            total += this.getCombinedColorMixFeeTotal(item);

            return total;
        },

        // Get Run Charge Total from Breakdown (for decoration type 0, 1, and 2)
        getRunChargeTotalFromBreakdown(item, parentItem = null) {
            let total = 0;

            // Get breakdown for all types (flat or location-bucket nested)
            const breakdown = this.getRunChargeBreakdown(item, parentItem);
            if (breakdown && breakdown.length > 0) {
                const isLocationBuckets =
                    breakdown[0] &&
                    breakdown[0].location &&
                    Array.isArray(breakdown[0].items);
                if (isLocationBuckets) {
                    breakdown.forEach((location) => {
                        (location.items || []).forEach((row) => {
                            if (
                                row.isIncluded ||
                                row.total === "INCL" ||
                                row.total === "-" ||
                                row.amt === "INCL" ||
                                row.amt === "-"
                            ) {
                                return;
                            }
                            total += parseFloat(row.total || 0);
                        });
                    });
                } else {
                    total = breakdown.reduce((sum, row) => {
                        if (
                            row.isIncluded ||
                            row.total === "INCL" ||
                            row.total === "-" ||
                            row.amt === "INCL" ||
                            row.amt === "-"
                        ) {
                            return sum;
                        }
                        return sum + parseFloat(row.total || 0);
                    }, 0);
                }
            }

            // Add services with rollup_fee_id = 12 (Run Charge services) - include all services regardless of show_service
            const runChargeServices = this.getRunChargeServices(item);
            if (runChargeServices && runChargeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                runChargeServices.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            // If breakdown was empty, continue with fallback logic
            if (!breakdown || breakdown.length === 0) {
                // Fallback for type 0 only
                if (item.decoration_type == 0) {
                    if (!item.decoration || !item.decoration.master_service) {
                        return 0;
                    }

                    // Fallback: calculate directly if breakdown is empty (type 0 only)
                    const quantity = this.getTotalItemQuantity(item);
                    const masterService = item.decoration.master_service;
                    const location1stFee = parseFloat(
                        masterService.location_1st || 0
                    );
                    const additionalLocationFee = parseFloat(
                        masterService.additional_location || 0
                    );
                    const costPerColor1st = parseFloat(
                        masterService.cost_per_color_1st || 0
                    );
                    const costPerColor2ndOrMore = parseFloat(
                        masterService.cost_per_color_2ndormore || 0
                    );

                    let runCharge = 0;

                    const effectiveImprintLocations =
                        this.getEffectiveImprintLocations(item, parentItem);
                    if (effectiveImprintLocations.length > 0) {
                        let locationIndex = 0;
                        effectiveImprintLocations.forEach((location) => {
                            if (location.is_selected) {
                                const noOfColors = parseInt(
                                    location.no_of_color || 0
                                );

                                if (locationIndex === 0) {
                                    // First location: location1stFee + all colors × costPerColor1st
                                    runCharge +=
                                        (location1stFee +
                                            noOfColors * costPerColor1st) *
                                        quantity;
                                } else {
                                    // Additional locations: additionalLocationFee + 1st color × costPerColor1st + additional colors × costPerColor2ndOrMore
                                    const firstColorCost = costPerColor1st;
                                    const additionalColorsCost =
                                        noOfColors > 1
                                            ? (noOfColors - 1) *
                                              costPerColor2ndOrMore
                                            : 0;
                                    runCharge +=
                                        (additionalLocationFee +
                                            firstColorCost +
                                            additionalColorsCost) *
                                        quantity;
                                }

                                // Add decor upcharge from colors
                                if (
                                    location.colors &&
                                    Array.isArray(location.colors)
                                ) {
                                    location.colors.forEach((color) => {
                                        if (
                                            color.color &&
                                            color.color.decor_upcharge
                                        ) {
                                            runCharge +=
                                                parseFloat(
                                                    color.color
                                                        .decor_upcharge || 0
                                                ) * quantity;
                                        }
                                    });
                                }

                                locationIndex++;
                            }
                        });
                    }

                    const allowedNk = this.getSelectedImprintLocationKeys(item);
                    ["front", "back", "left", "right"].forEach((side) => {
                        if (!allowedNk.has(side)) return;
                        this.getNameNumberFeesFromItemPrices(
                            item,
                            side
                        ).forEach((fee) => {
                            runCharge += parseFloat(fee.total || 0);
                        });
                    });

                    total += runCharge;
                }
            }

            // Return total (includes breakdown + rollup_fee_id = 12 services + fallback if needed)
            return parseFloat(total.toFixed(2));
        },

        // Get Item Sub Total (Base Fee + Run Charge + Color Mix Fee + Setup Fee + Name/Number fees)
        getItemSubTotal(item, parentItem = null) {
            // For grouped decoration type 0, 1, and 2 items, exclude individual color mix fee (will be shown separately)
            if (
                item.decoration_type === 0 ||
                item.decoration_type === 1 ||
                item.decoration_type === 2 ||
                item.decoration_type === 4
            ) {
                // Check if parent is grouped (for subItems)
                if (parentItem && this.isGroupedDecorationType0(parentItem)) {
                    let sub = this.getItemSubTotalExcludingColorMixFee(
                        item,
                        parentItem
                    );
                    if (this.isAssemblyGroup(parentItem)) {
                        sub += this.getOtherColorMixFeeRollupTotal(item);
                    }
                    return sub;
                }
                // Check if item itself is grouped (for parent items)
                if (this.isGroupedDecorationType0(item)) {
                    return this.getItemSubTotalExcludingColorMixFee(item);
                }
            }

            let total = 0;

            // Base Fee Total
            total += this.getBaseFeeTotal(item, parentItem);

            // Run Charge (includes name/number fees for all decoration types)
            total += this.getRunChargeTotalFromBreakdown(item);

            // Color Mix Fee (for decoration type 0, 1, and 2)
            if (
                item.decoration_type == 0 ||
                item.decoration_type == 1 ||
                item.decoration_type == 5 ||
                item.decoration_type == 2 || item.decoration_type == 4
            ) {
                total += this.getColorMixFeeTotal(item);
            }

            // Setup Fee
            const isAssemblyChild =
                parentItem && this.isAssemblyGroup(parentItem);
            if (!isAssemblyChild) {
                if (item.setup_fees_details) {
                    total += this.getSetupFeeTotal(item);
                } else {
                    total +=
                        parseFloat(item.sp_setup_fee || 0) +
                        parseFloat(item.emb_setup_fee || 0);
                }
            } else {
                total += this.getSetupFeeServicesTotal(item);
            }

            // Rush Fee (recalculated based on current quantity)
            if (item.rush_fee_breakdown) {
                total += this.getRushFeeTotal(item);
            }

            // Patch Cost
            total += this.getDynamicPatchCostTotal(item);

            // Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
            if (item.decoration_type != 0) {
                const itemPrices = item.item_prices || {};
                total +=
                    parseFloat(itemPrices.front_number_fees || 0) +
                    parseFloat(itemPrices.back_name_fees || 0) +
                    parseFloat(itemPrices.back_number_fees || 0) +
                    parseFloat(itemPrices.front_number_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_name_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_number_decor_up_fees || 0);
            }

            return total;
        },

        // Get Run Charge base price (sum of decoration colors prices)
        getRunChargeBasePrice(item) {
            const quantity = this.getTotalItemQuantity(item);
            let runCharge = 0;

            // Decoration type 0 - PCNA
            if (item.decoration_type == 0) {
                if (!item.decoration || !item.decoration.master_service) {
                    return 0;
                }

                const masterService = item.decoration.master_service;
                const location1stFee = parseFloat(
                    masterService.location_1st || 0
                );
                const additionalLocationFee = parseFloat(
                    masterService.additional_location || 0
                );
                const costPerColor1st = parseFloat(
                    masterService.cost_per_color_1st || 0
                );
                const costPerColor2ndOrMore = parseFloat(
                    masterService.cost_per_color_2ndormore || 0
                );
                const fullColorValue = this.getFullColorValue(item);

                if (
                    item.imprint_locations &&
                    Array.isArray(item.imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: location1stFee + fullColorValue
                                    runCharge +=
                                        (location1stFee + fullColorValue) *
                                        quantity;
                                } else {
                                    // Regular: location1stFee + all colors × costPerColor1st
                                    runCharge +=
                                        (location1stFee +
                                            noOfColors * costPerColor1st) *
                                        quantity;
                                }
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: additionalLocationFee + fullColorValue
                                    runCharge +=
                                        (additionalLocationFee +
                                            fullColorValue) *
                                        quantity;
                                } else {
                                    // Regular: additionalLocationFee + 1st color × costPerColor1st + additional colors × costPerColor2ndOrMore
                                    const firstColorCost = costPerColor1st;
                                    const additionalColorsCost =
                                        noOfColors > 1
                                            ? (noOfColors - 1) *
                                              costPerColor2ndOrMore
                                            : 0;
                                    runCharge +=
                                        (additionalLocationFee +
                                            firstColorCost +
                                            additionalColorsCost) *
                                        quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }

                return runCharge;
            }

            // Decoration type 1/5 - Screen Print/DTF (print-like path)
            if (item.decoration_type == 1 || item.decoration_type == 5) {
                const fullColorValue = this.getFullColorValue(item);

                if (
                    item.sp_imprint_locations &&
                    Array.isArray(item.sp_imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.sp_imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use fullColorValue
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 1) {
                                    // Additional colors (if > 1)
                                    const secondColorPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            1,
                                            undefined,
                                            false
                                        );
                                    const firstColorPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            undefined,
                                            false
                                        );
                                    const additionalColorPrice =
                                        secondColorPrice - firstColorPrice;
                                    runCharge +=
                                        additionalColorPrice *
                                        (noOfColors - 1) *
                                        quantity;
                                }
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use same value as first location
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 0) {
                                    // Regular: all colors
                                    const locationPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            undefined,
                                            true
                                        );
                                    runCharge +=
                                        locationPrice * noOfColors * quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }
            }
            // Decoration type 2 - Embroidery
            else if (item.decoration_type == 2 || item.decoration_type == 4) {
                const fullColorValue = this.getFullColorValue(item);

                if (
                    item.emb_imprint_locations &&
                    Array.isArray(item.emb_imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.emb_imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use fullColorValue
                                    runCharge += fullColorValue * quantity;
                                }
                                // Otherwise first location is free
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use same value as first location
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 0) {
                                    // Regular: all colors
                                    const locationPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            locationIndex
                                        );
                                    runCharge +=
                                        locationPrice * noOfColors * quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }
            }

            return runCharge;
        },

        // Get Setup Fee base price
        getSetupFeeBasePrice(item) {
            return (
                parseFloat(item.sp_setup_fee || 0) +
                parseFloat(item.emb_setup_fee || 0)
            );
        },
        getSetupFeeDetailsTotal(item) {
            let total = 0;
            const normalizedSetupFeeDetails =
                this.getNormalizedSetupFeeDetails(item);
            if (normalizedSetupFeeDetails) {
                if (
                    normalizedSetupFeeDetails.total &&
                    parseFloat(normalizedSetupFeeDetails.total) > 0
                ) {
                    total = parseFloat(normalizedSetupFeeDetails.total);
                } else if (
                    normalizedSetupFeeDetails.locations &&
                    normalizedSetupFeeDetails.locations.length > 0
                ) {
                    total = normalizedSetupFeeDetails.locations.reduce(
                        (sum, location) => {
                            return sum + parseFloat(location.total || 0);
                        },
                        0
                    );
                }
            }
            const columnSetup = parseFloat(item.setup_fee || 0);
            if (!Number.isNaN(columnSetup) && columnSetup > total) {
                total = columnSetup;
            }
            return total;
        },
        getCombinedSetupFeeServices(item) {
            if (!this.isAssemblyGroup(item)) {
                return this.getSetupFeeServices(item);
            }
            const allServices = [];
            const groupedItems = this.getAssemblyGroupedItems(item);
            groupedItems.forEach((groupItem) => {
                const services = this.getSetupFeeServices(groupItem);
                if (!services || services.length === 0) return;
                const itemQuantity = this.getTotalItemQuantity(groupItem);
                services.forEach((service) => {
                    const serviceCopy = { ...service };
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        serviceCopy._calculatedTotal =
                            parseFloat(servicePrice) * itemQuantity;
                        serviceCopy._quantity = itemQuantity;
                    } else {
                        serviceCopy._calculatedTotal = parseFloat(servicePrice);
                        serviceCopy._quantity = 1;
                    }
                    allServices.push(serviceCopy);
                });
            });
            return allServices;
        },
        getCombinedSetupFeeTotal(item) {
            if (!this.isAssemblyGroup(item)) {
                return this.getSetupFeeTotal(item);
            }
            let total = 0;
            const groupedItems = this.getAssemblyGroupedItems(item);
            groupedItems.forEach((groupItem) => {
                total = Math.max(
                    total,
                    this.getSetupFeeDetailsTotal(groupItem)
                );
            });
            groupedItems.forEach((groupItem) => {
                const services = this.getSetupFeeServices(groupItem);
                if (!services || services.length === 0) return;
                const quantity = this.getTotalItemQuantity(groupItem);
                services.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            });
            return parseFloat(total.toFixed(2));
        },
        getDisplayedSetupFeeServices(item) {
            if (this.isAssemblyGroup(item)) {
                return this.getCombinedSetupFeeServices(item);
            }
            return this.getSetupFeeServices(item);
        },

        togglePatchTooltip(itemId) {
            this.activePatchTooltipId = this.activePatchTooltipId === itemId ? null : itemId;
        },

        // Get Setup Fee Total from setup_fees_details
        getSetupFeeTotal(item) {
            let total = 0;
            const normalizedSetupFeeDetails =
                this.getNormalizedSetupFeeDetails(item);

            if (normalizedSetupFeeDetails) {
                // Use total from setup_fees_details if available and > 0
                if (
                    normalizedSetupFeeDetails.total &&
                    parseFloat(normalizedSetupFeeDetails.total) > 0
                ) {
                    total = parseFloat(normalizedSetupFeeDetails.total);
                } else if (
                    normalizedSetupFeeDetails.locations &&
                    normalizedSetupFeeDetails.locations.length > 0
                ) {
                    total = normalizedSetupFeeDetails.locations.reduce(
                        (sum, location) => {
                            return sum + parseFloat(location.total || 0);
                        },
                        0
                    );
                }
            }

            const columnSetup = parseFloat(item.setup_fee || 0);
            const detailsHasSuppressedRow =
                normalizedSetupFeeDetails &&
                Array.isArray(normalizedSetupFeeDetails.locations) &&
                normalizedSetupFeeDetails.locations.some(
                    (loc) => loc && loc.is_suppressed_by_group === true
                );
            if (
                !detailsHasSuppressedRow &&
                !isAssemblySuppressOrphanLine(item) &&
                !Number.isNaN(columnSetup) &&
                columnSetup > total
            ) {
                total = columnSetup;
            }

            const setupServicesEmbeddedInDetails =
                normalizedSetupFeeDetails &&
                Array.isArray(normalizedSetupFeeDetails.services) &&
                normalizedSetupFeeDetails.services.length > 0;

            // Add services with rollup_fee_id = 2 (Setup Fee services) - include all services regardless of show_service
            const setupFeeServices = this.getSetupFeeServices(item);
            if (
                !setupServicesEmbeddedInDetails &&
                setupFeeServices &&
                setupFeeServices.length > 0
            ) {
                const quantity = this.getTotalItemQuantity(item);
                setupFeeServices.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },
        getSetupFeeServicesTotal(item) {
            let total = 0;
            const setupFeeServices = this.getSetupFeeServices(item);
            if (setupFeeServices && setupFeeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                setupFeeServices.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }
            return parseFloat(total.toFixed(2));
        },
        getDisplayedSetupFeeDetails(item, parentItem = null) {
            if (parentItem && this.isAssemblyGroup(parentItem)) {
                // Assembly child: hide setup location rows, show only other services.
                return null;
            }
            return this.getNormalizedSetupFeeDetails(item);
        },
        getSetupFeeMasterService(item) {
            if (!item || !item.decoration) return {};
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return {};
                }
            }
            return decoration.product_master_service || {};
        },
        applySuppressionToSetupFeeDetails(setupFeeDetails, item, parentItem = null) {
            return applySetupFeeSuppressionShared(
                setupFeeDetails,
                item,
                parentItem,
                (it, par) => this.getEffectiveImprintLocations(it, par)
            );
        },
        hasSuppressedRowsInRunBreakdown(item, parentItem = null) {
            const breakdown = this.getRunChargeBreakdown(item, parentItem);
            if (!Array.isArray(breakdown) || breakdown.length === 0)
                return false;
            const isLocationBuckets =
                breakdown[0] &&
                breakdown[0].location &&
                Array.isArray(breakdown[0].items);
            if (isLocationBuckets) {
                return breakdown.some((bucket) =>
                    (bucket.items || []).some(
                        (row) =>
                            row &&
                            row.is_suppressed_by_group === true &&
                            parseFloat(row.total || 0) === 0
                    )
                );
            }
            return breakdown.some(
                (row) =>
                    row &&
                    row.is_suppressed_by_group === true &&
                    parseFloat(row.total || 0) === 0
            );
        },
        shouldShowRunChargeRow(item, parentItem = null) {
            return (
                this.getRunChargeTotalFromBreakdown(item, parentItem) > 0 ||
                this.hasSuppressedRowsInRunBreakdown(item, parentItem)
            );
        },
        hasSuppressedRowsInSetupDetails(item, parentItem = null) {
            const details = this.getDisplayedSetupFeeDetails(item, parentItem);
            return !!(
                details &&
                Array.isArray(details.locations) &&
                details.locations.some(
                    (location) =>
                        location && location.is_suppressed_by_group === true
                )
            );
        },
        shouldShowZeroSetupFeeForSuppress(item, parentItem = null) {
            const { enabled } = getSuppressAdditionalSetupRunChargeConfig(
                item,
                parentItem
            );
            if (!enabled) return false;

            const details = this.getDisplayedSetupFeeDetails(item, parentItem);
            if (
                !details ||
                !Array.isArray(details.locations) ||
                details.locations.length === 0
            ) {
                return false;
            }

            if (this.hasSuppressedRowsInSetupDetails(item, parentItem)) {
                return true;
            }

            const imprintLocs = this.getEffectiveImprintLocations(
                item,
                parentItem
            );
            const selected = (imprintLocs || []).filter(
                (loc) => loc && loc.is_selected !== false
            );
            if (selected.length < 2) return false;

            const grouping = this.getLocationGroupingMetadata(
                imprintLocs,
                true
            );
            return grouping.some((entry) => entry && !entry.isGroupPrimary);
        },
        shouldShowSetupFeeRow(item, parentItem = null) {
            if (this.getDisplayedSetupFeeTotal(item, parentItem) > 0) {
                return true;
            }
            return this.shouldShowZeroSetupFeeForSuppress(item, parentItem);
        },
        getNormalizedSetupFeeDetails(item) {
            if (!item || !item.setup_fees_details) return null;
            const decorationType = parseInt(item.decoration_type) || 0;
            // For non-PCNA decoration types, use payload values as-is.
            if (decorationType !== 0) {
                let parsedSetup = item.setup_fees_details;
                if (typeof item.setup_fees_details === "string") {
                    try {
                        parsedSetup = JSON.parse(item.setup_fees_details);
                    } catch (e) {
                        parsedSetup = item.setup_fees_details;
                    }
                }
                const assemblyGrouped = this.getAssemblyGroupedItems(item);
                if (
                    parsedSetup &&
                    typeof parsedSetup === "object" &&
                    this.isAssemblyGroup(item) &&
                    assemblyGrouped.length > 0 &&
                    assemblyGrouped[0] === item
                ) {
                    const mixedDisplay = getAssemblyMixedCaseDisplaySetupDetails(
                        item,
                        assemblyGrouped
                    );
                    if (mixedDisplay) {
                        return mixedDisplay;
                    }
                    const colExpand = parseFloat(item.setup_fee || 0);
                    const rawExpand = getRawSetupFeesDetailsTotal(parsedSetup);
                    if (
                        !Number.isNaN(colExpand) &&
                        colExpand > rawExpand + 0.021 &&
                        Array.isArray(parsedSetup.locations)
                    ) {
                        const expanded = expandSetupFeeDetailsToMatchTargetTotal(
                            parsedSetup,
                            colExpand
                        );
                        if (expanded) {
                            return expanded;
                        }
                    }
                    const rawT = getRawSetupFeesDetailsTotal(parsedSetup);
                    const col = parseFloat(item.setup_fee || 0);
                    if (
                        rawT > 0 &&
                        !Number.isNaN(col) &&
                        Math.abs(rawT - col) < 0.021
                    ) {
                        return JSON.parse(JSON.stringify(parsedSetup));
                    }
                }
                if (
                    parsedSetup &&
                    typeof parsedSetup === "object" &&
                    this.isAssemblyGroup(item) &&
                    shouldSkipSetupFeeSuppressionForAssemblyParentFromGrouped(
                        item,
                        parsedSetup,
                        this.getAssemblyGroupedItems(item)
                    )
                ) {
                    return JSON.parse(JSON.stringify(parsedSetup));
                }
                return this.applySuppressionToSetupFeeDetails(parsedSetup, item);
            }

            // PCNA (decoration_type 0): preserve legacy normalization behavior.
            const masterService = this.getSetupFeeMasterService(item);
            const setupFeeColor1 = parseFloat(masterService.setup_fee_color1 || 0);
            const setupFeeMulticolor = parseFloat(
                masterService.setup_fee_multicolor || 0
            );

            let normalizedDetails = item.setup_fees_details;
            if (typeof normalizedDetails === "string") {
                try {
                    normalizedDetails = JSON.parse(normalizedDetails);
                } catch (e) {
                    return item.setup_fees_details;
                }
            }
            if (
                !normalizedDetails ||
                !normalizedDetails.locations ||
                !Array.isArray(normalizedDetails.locations)
            ) {
                return normalizedDetails;
            }
            if (setupFeeColor1 <= 0 && setupFeeMulticolor <= 0) {
                return normalizedDetails;
            }

            if (
                normalizedDetails.locations.some(
                    (loc) => loc && loc.is_suppressed_by_group === true
                )
            ) {
                const headerT = parseFloat(normalizedDetails.total);
                const sumLocs = normalizedDetails.locations.reduce(
                    (s, loc) => s + parseFloat((loc && loc.total) || 0),
                    0
                );
                if (
                    !Number.isNaN(headerT) &&
                    Math.abs(headerT - sumLocs) < 0.021
                ) {
                    if (
                        this.isAssemblyGroup(item) &&
                        shouldSkipSetupFeeSuppressionForAssemblyParentFromGrouped(
                            item,
                            normalizedDetails,
                            this.getAssemblyGroupedItems(item)
                        )
                    ) {
                        return JSON.parse(JSON.stringify(normalizedDetails));
                    }
                    return this.applySuppressionToSetupFeeDetails(
                        JSON.parse(JSON.stringify(normalizedDetails)),
                        item
                    );
                }
            }

            const feeStructure = parseInt(masterService.fee_structure) || 1;
            const cloned = JSON.parse(JSON.stringify(normalizedDetails));
            let grandTotal = 0;
            cloned.locations = cloned.locations.map((location) => {
                if (location && location.is_suppressed_by_group === true) {
                    grandTotal += parseFloat(location.total || 0);
                    const catalogQty = getSetupFeeLocationCatalogQuantity(
                        location,
                        this.getEffectiveImprintLocations(item),
                        cloned.locations
                    );
                    return {
                        ...location,
                        catalog_quantity: catalogQty,
                        quantity: catalogQty,
                        per_price: 0,
                        total: 0
                    };
                }
                const qtyParsed = parseInt(location.quantity, 10);
                const qty = Number.isNaN(qtyParsed)
                    ? 1
                    : Math.max(0, qtyParsed);
                const isFullColor =
                    location.is_full_color === true ||
                    /full\s*color/i.test(String(location.name || ""));
                let perPrice = 0;
                let total = 0;

                if (feeStructure === 1) {
                    perPrice = setupFeeColor1;
                    total = perPrice * (qty > 0 ? qty : 1);
                } else {
                    perPrice =
                        isFullColor || qty > 1
                            ? setupFeeMulticolor
                            : setupFeeColor1;
                    total = perPrice;
                    location.quantity = 1;
                }

                grandTotal += total;
                return {
                    ...location,
                    per_price: perPrice,
                    total: total
                };
            });
            cloned.total = grandTotal;
            if (
                this.isAssemblyGroup(item) &&
                shouldSkipSetupFeeSuppressionForAssemblyParentFromGrouped(
                    item,
                    cloned,
                    this.getAssemblyGroupedItems(item)
                )
            ) {
                return cloned;
            }
            return this.applySuppressionToSetupFeeDetails(cloned, item);
        },
        getDisplayedSetupFeeTotal(item, parentItem = null) {
            if (parentItem && this.isAssemblyGroup(parentItem)) {
                return this.getSetupFeeServicesTotal(item);
            }
            if (this.isAssemblyGroup(item)) {
                return this.getCombinedSetupFeeTotal(item);
            }
            return this.getSetupFeeTotal(item);
        },

        // Get Rush Fee Total from rush_fee_breakdown (recalculate based on current quantity)
        getRushFeeTotal(item) {
            let total = 0;

            if (item.rush_fee_breakdown && item.rush_fee_breakdown.services) {
                const currentQuantity = this.getTotalItemQuantity(item);

                // Recalculate based on current quantity
                item.rush_fee_breakdown.services.forEach((service) => {
                    const servicePrice = parseFloat(service.retail_cost || 0);

                    if (servicePrice > 0) {
                        // Rush options: rush_package is Per Order (multiply by 1), others (rush1, rush3, rush5, rush7) are Per Item (multiply by quantity)
                        if (service.is_rush_option === true) {
                            // Check if it's rush_package or other rush options
                            if (service.service_id === "rush_package") {
                                // Rush Package: multiply by 1 (fixed price)
                                total += servicePrice * 1;
                            } else {
                                // Other rush options (rush1, rush3, rush5, rush7): multiply by quantity
                                total += servicePrice * currentQuantity;
                            }
                        } else {
                            // For other rush fee services, check fee_structure
                            const isPerItem =
                                service.fee_structure === "Per Item" ||
                                service.fee_structure === 6 ||
                                service.fee_structure === "6";

                            if (isPerItem) {
                                // Per Item: multiply by current quantity
                                total += servicePrice * currentQuantity;
                            } else {
                                // Per Order: use price as-is
                                total += servicePrice;
                            }
                        }
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get Rush Fee Services from rush_fee_breakdown
        getRushFeeServices(item) {
            if (item.rush_fee_breakdown && item.rush_fee_breakdown.services) {
                return item.rush_fee_breakdown.services;
            }
            return [];
        },

        // Enrich rush fee breakdowns with real-time vendor service prices
        async enrichRushFeeBreakdowns(cartItems) {
            if (!cartItems || cartItems.length === 0) {
                return;
            }

            // Collect unique default_decorator_ids from cart items
            const decoratorIds = new Set();

            cartItems.forEach((item) => {
                // Get decorator_id from product
                const decoratorId =
                    item.main_new_product &&
                    item.main_new_product.default_decorator_id
                        ? item.main_new_product.default_decorator_id
                        : null;

                if (decoratorId) {
                    decoratorIds.add(decoratorId);
                }

                // Also check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        const subDecoratorId =
                            subItem.main_new_product &&
                            subItem.main_new_product.default_decorator_id
                                ? subItem.main_new_product.default_decorator_id
                                : null;
                        if (subDecoratorId) {
                            decoratorIds.add(subDecoratorId);
                        }
                    });
                }
            });

            if (decoratorIds.size === 0) {
                return; // No decorator IDs found
            }

            // Fetch vendor services for all unique decorator IDs
            const vendorServicesMap = new Map();
            const fetchPromises = Array.from(decoratorIds).map(
                async (decoratorId) => {
                    try {
                        const response = await ApiService.get(
                            `/vendors/${decoratorId}/services`
                        );
                        if (response.data && response.data.vendorServices) {
                            vendorServicesMap.set(
                                decoratorId,
                                response.data.vendorServices
                            );
                        } else if (
                            response.data &&
                            Array.isArray(response.data)
                        ) {
                            // Handle case where response is directly an array
                            vendorServicesMap.set(decoratorId, response.data);
                        }
                    } catch (error) {
                        console.error(
                            `Error fetching vendor services for decorator ${decoratorId}:`,
                            error
                        );
                    }
                }
            );

            await Promise.all(fetchPromises);

            // Enrich rush fee breakdowns for each item
            cartItems.forEach((item) => {
                this.enrichItemRushFeeBreakdown(item, vendorServicesMap);

                // Also enrich subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        this.enrichItemRushFeeBreakdown(
                            subItem,
                            vendorServicesMap
                        );
                    });
                }
            });
        },

        // Enrich rush fee breakdown for a single item
        enrichItemRushFeeBreakdown(item, vendorServicesMap) {
            if (!item.rush_fee_breakdown || !item.rush_fee_breakdown.services) {
                return;
            }

            // Get decorator_id from product
            const decoratorId =
                item.main_new_product &&
                item.main_new_product.default_decorator_id
                    ? item.main_new_product.default_decorator_id
                    : null;

            if (!decoratorId) {
                return; // No decorator ID found
            }

            // Get vendor services for this decorator
            const vendorServices = vendorServicesMap.get(decoratorId);
            if (!vendorServices || vendorServices.length === 0) {
                return; // No vendor services found
            }

            // Get master_service.id from decoration
            let masterServiceId = null;
            if (item.decoration && item.decoration.master_service) {
                masterServiceId = item.decoration.master_service.id;
            }

            if (!masterServiceId) {
                return; // No master service ID found
            }

            // Find vendor service that matches master_service.id
            const vendorService = vendorServices.find(
                (vs) => vs.id === masterServiceId
            );
            if (!vendorService) {
                return; // Vendor service not found
            }

            // Get current quantity for calculation
            const currentQuantity = this.getTotalItemQuantity(item);

            // Update rush fee breakdown services with latest prices
            item.rush_fee_breakdown.services.forEach((service, index) => {
                if (service.is_rush_option === true) {
                    // Update rush options (rush1, rush3, rush5, rush7, rush_package)
                    let updatedPrice = null;
                    switch (service.service_id) {
                        case "rush1":
                            if (
                                vendorService.rush1 !== undefined &&
                                vendorService.rush1 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush1 || 0
                                );
                            }
                            break;
                        case "rush3":
                            if (
                                vendorService.rush3 !== undefined &&
                                vendorService.rush3 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush3 || 0
                                );
                            }
                            break;
                        case "rush5":
                            if (
                                vendorService.rush5 !== undefined &&
                                vendorService.rush5 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush5 || 0
                                );
                            }
                            break;
                        case "rush7":
                            if (
                                vendorService.rush7 !== undefined &&
                                vendorService.rush7 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush7 || 0
                                );
                            }
                            break;
                        case "rush_package":
                            if (
                                vendorService.rush_package !== undefined &&
                                vendorService.rush_package !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush_package || 0
                                );
                            }
                            break;
                    }

                    if (updatedPrice !== null) {
                        // Use Vue.set to ensure reactivity
                        this.$set(
                            item.rush_fee_breakdown.services[index],
                            "retail_cost",
                            updatedPrice
                        );
                        // Rush options are per order, so total = retail_cost
                        this.$set(
                            item.rush_fee_breakdown.services[index],
                            "total",
                            updatedPrice
                        );
                    }
                } else {
                    // Update other rush fee services by matching service_id
                    if (service.service_id) {
                        const matchingVendorService = vendorServices.find(
                            (vs) => vs.id === service.service_id
                        );
                        if (
                            matchingVendorService &&
                            matchingVendorService.retail_cost !== undefined
                        ) {
                            const updatedRetailCost = parseFloat(
                                matchingVendorService.retail_cost || 0
                            );

                            // Use Vue.set to ensure reactivity
                            this.$set(
                                item.rush_fee_breakdown.services[index],
                                "retail_cost",
                                updatedRetailCost
                            );

                            // Recalculate total based on fee_structure
                            const isPerItem =
                                service.fee_structure === "Per Item" ||
                                service.fee_structure === 6 ||
                                service.fee_structure === "6";

                            let serviceTotal;
                            if (isPerItem) {
                                // Per Item: multiply by current quantity
                                serviceTotal = parseFloat(
                                    (
                                        updatedRetailCost * currentQuantity
                                    ).toFixed(2)
                                );
                            } else {
                                // Per Order: use price as-is
                                serviceTotal = parseFloat(
                                    updatedRetailCost.toFixed(2)
                                );
                            }
                            this.$set(
                                item.rush_fee_breakdown.services[index],
                                "total",
                                serviceTotal
                            );
                        }
                    }
                }
            });

            // Recalculate total for rush_fee_breakdown (this will be recalculated in getRushFeeTotal, but update stored value too)
            // Note: getRushFeeTotal will recalculate based on current quantity, so this is just for reference
            let total = 0;
            item.rush_fee_breakdown.services.forEach((service) => {
                const servicePrice = parseFloat(service.retail_cost || 0);
                if (servicePrice > 0) {
                    if (service.is_rush_option === true) {
                        // Rush options: rush_package is Per Order (multiply by 1), others (rush1, rush3, rush5, rush7) are Per Item (multiply by quantity)
                        if (service.service_id === "rush_package") {
                            // Rush Package: multiply by 1 (fixed price)
                            total += servicePrice * 1;
                        } else {
                            // Other rush options (rush1, rush3, rush5, rush7): multiply by quantity
                            total += servicePrice * currentQuantity;
                        }
                    } else {
                        // Other services depend on fee_structure
                        const isPerItem =
                            service.fee_structure === "Per Item" ||
                            service.fee_structure === 6 ||
                            service.fee_structure === "6";
                        total += isPerItem
                            ? servicePrice * currentQuantity
                            : servicePrice;
                    }
                }
            });
            this.$set(
                item.rush_fee_breakdown,
                "total",
                parseFloat(total.toFixed(2))
            );
        },

        // Get active product discount for an item
        getActiveProductDiscount(item) {
            if (
                !item.main_new_product ||
                !item.main_new_product.MainNewProductDiscount
            ) {
                return null;
            }

            const discount = item.main_new_product.MainNewProductDiscount;

            // Return null if discount doesn't exist
            if (!discount) {
                return null;
            }

            const today = new Date();
            // Set time to the beginning of the day for a consistent date-only comparison
            today.setHours(0, 0, 0, 0);

            // Check if the discount has a start date and if it has already started
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                startDate.setHours(0, 0, 0, 0); // Normalize to start of day for accurate comparison
                if (today < startDate) {
                    return null; // Discount hasn't started yet
                }
            }

            // Check if the discount has an end date and if it has expired
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                endDate.setHours(23, 59, 59, 999); // Normalize to end of day for accurate comparison
                if (today > endDate) {
                    return null; // Discount has expired
                }
            }

            // Validate discount_type and discount_value
            if (!discount.discount_type || !discount.discount_value) {
                return null;
            }

            // If all checks pass, the discount is active
            return discount;
        },

        // Apply discount to size cost if activeProductDiscount exists
        applyDiscountToSizeCost(originalCost, item) {
            if (!originalCost || originalCost <= 0) {
                return originalCost;
            }

            const activeDiscount = this.getActiveProductDiscount(item);
            // Just check if discount exists and has required fields
            if (
                !activeDiscount ||
                !activeDiscount.discount_type ||
                !activeDiscount.discount_value
            ) {
                return originalCost;
            }

            const discountType = activeDiscount.discount_type;
            const discountValue = parseFloat(
                activeDiscount.discount_value || 0
            );

            if (discountType === "Percent") {
                return parseFloat(
                    (originalCost * (1 - discountValue / 100)).toFixed(2)
                );
            } else {
                // Fixed amount discount
                return parseFloat(
                    Math.max(0, originalCost - discountValue).toFixed(2)
                );
            }
        },

        // Calculate discount amount for an item
        // Discount calculation removed - no longer applying overall discount
        // Discount is now applied at size cost level
        getItemDiscount(item, parentItem = null) {
            return 0;
        },

        // Fetch holidays from admin options (same as ProductDetailsV3New.vue)
        async fetchHolidays() {
            try {
                const { data } = await ApiService.get("/get-socialLinks");
                const holidaysLink =
                    data.links &&
                    data.links.find((link) => link.option_key === "holidays");

                if (holidaysLink && holidaysLink.option_value) {
                    try {
                        this.holidays = JSON.parse(holidaysLink.option_value);
                        // Also expose to window for ToolTip access
                        if (
                            typeof window !== "undefined" &&
                            window.CartV3Component
                        ) {
                            window.CartV3Component.holidays = this.holidays;
                        }
                    } catch (e) {
                        console.error("Error parsing holidays:", e);
                        this.holidays = [];
                    }
                } else {
                    this.holidays = [];
                }
            } catch (error) {
                console.error("Error fetching holidays:", error);
                this.holidays = [];
            }
        },

        // Calculate estimated date with holidays excluded (EXACT same as ToolTip)
        // calculateEstimatedDateWithHolidays(baseDate, daysToAdd, holidays = []) {
        //     let currentDate = new Date(baseDate);
        //     currentDate.setHours(0, 0, 0, 0);
        //     let daysAdded = 0;

        //     // Convert holidays to Date objects for comparison
        //     const holidayDates = holidays.map((h) => {
        //         const d = new Date(h);
        //         d.setHours(0, 0, 0, 0);
        //         return d;
        //     });

        //     // Add days one by one, skipping holidays
        //     while (daysAdded < daysToAdd) {
        //         currentDate.setDate(currentDate.getDate() + 1);

        //         // Check if current date is a holiday
        //         const currentDateOnly = new Date(currentDate);
        //         currentDateOnly.setHours(0, 0, 0, 0);

        //         const isHoliday = holidayDates.some((h) => {
        //             return h.getTime() === currentDateOnly.getTime();
        //         });

        //         // Only count non-holiday days
        //         if (!isHoliday) {
        //             daysAdded++;
        //         }
        //     }

        //     // Ensure final date is not a holiday (add extra days if needed)
        //     let finalDateOnly = new Date(currentDate);
        //     finalDateOnly.setHours(0, 0, 0, 0);
        //     while (
        //         holidayDates.some(
        //             (h) => h.getTime() === finalDateOnly.getTime()
        //         )
        //     ) {
        //         currentDate.setDate(currentDate.getDate() + 1);
        //         finalDateOnly = new Date(currentDate);
        //         finalDateOnly.setHours(0, 0, 0, 0);
        //     }

        //     return currentDate;
        // },
         // Calculate estimated date with holidays excluded (EXACT same as ToolTip)
        calculateEstimatedDateWithHolidays(baseDate, daysToAdd, holidays = []) {
            // Helper: get YYYY-MM-DD date string in New York timezone
            // This makes holiday comparison universal across all timezones
            var toNYDateString = function(date) {
                return new Intl.DateTimeFormat("en-CA", {
                    timeZone: "America/New_York",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }).format(date);
            };

            // Build a Set of NY holiday date strings
            // API returns "YYYY-MM-DD" strings — treat them as NY calendar dates directly
            // (no Date parsing needed, avoids UTC-shift problem entirely)
            var holidaySet = new Set(
                holidays.map(function(h) {
                    if (typeof h === "string" && /^\d{4}-\d{2}-\d{2}$/.test(h)) {
                        return h; // Already a NY calendar date string, use as-is
                    }
                    return toNYDateString(new Date(h)); // Fallback for other formats
                })
            );

            // Start from base date
            var currentDate = new Date(baseDate);
            var daysAdded = 0;

            // Add days one by one, skipping holidays (compared in NY timezone)
            while (daysAdded < daysToAdd) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (!holidaySet.has(toNYDateString(currentDate))) {
                    daysAdded++;
                }
            }

            // Ensure final date is not a holiday (push forward if needed)
            while (holidaySet.has(toNYDateString(currentDate))) {
                currentDate.setDate(currentDate.getDate() + 1);
            }

            return currentDate;
        },


   

        // Get estimated shipping date at runtime (ProductDetailsV3New.vue style)
        // Rush option: calculate from rush breakdown (same as ToolTip)
        // Standard: calculate from vendor standard_shipping_days
        // _fromSibling: internal flag to avoid recursion when resolving date from same-product sibling
        getEstimatedShippingDate(item, _fromSibling = false) {
            if (!item) return null;

            // Check if rush option is selected
            let rushFeeBreakdown = item.rush_fee_breakdown;
            if (rushFeeBreakdown && typeof rushFeeBreakdown === "string") {
                try {
                    rushFeeBreakdown = JSON.parse(rushFeeBreakdown);
                } catch (e) {
                    console.error("Error parsing rush_fee_breakdown:", e);
                    rushFeeBreakdown = null;
                }
            }

            if (
                rushFeeBreakdown &&
                rushFeeBreakdown.services &&
                Array.isArray(rushFeeBreakdown.services)
            ) {
                const rushService = rushFeeBreakdown.services.find(
                    (service) => service.is_rush_option === true
                );

                if (rushService && rushService.service_id) {
                    // Calculate date based on rush option type (EXACT same as ToolTip.getRushServiceNameWithDate)
                    let daysToAdd = 0;
                    switch (rushService.service_id) {
                        case "rush1":
                        case "rush_package":
                            daysToAdd = 1;
                            break;
                        case "rush3":
                            daysToAdd = 3;
                            break;
                        case "rush5":
                            daysToAdd = 5;
                            break;
                        case "rush7":
                            daysToAdd = 7;
                            break;
                        default:
                            daysToAdd = 0;
                    }

                    if (daysToAdd > 0) {
                        // Get holidays EXACTLY like ToolTip does (from window.CartV3Component first)
                        let holidays = [];
                        if (
                            typeof window !== "undefined" &&
                            window.CartV3Component
                        ) {
                            holidays = window.CartV3Component.holidays || [];
                        }
                        // Fallback to this.holidays if window not available
                        if (holidays.length === 0) {
                            holidays = this.holidays || [];
                        }

                        // If holidays not loaded yet, return null (will recalculate once loaded)
                        if (holidays.length === 0) {
                            return null;
                        }

                        // EXACT same calculation as ToolTip
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const estimatedDate =
                            this.calculateEstimatedDateWithHolidays(
                                today,
                                daysToAdd,
                                holidays
                            );
                        // Format date same as ToolTip - use local timezone methods to avoid UTC conversion
                        const localDate = new Date(
                            estimatedDate.getFullYear(),
                            estimatedDate.getMonth(),
                            estimatedDate.getDate()
                        );
                        const mm = String(localDate.getMonth() + 1).padStart(
                            2,
                            "0"
                        );
                        const dd = String(localDate.getDate()).padStart(2, "0");
                        const yyyy = localDate.getFullYear();
                        // Return in MM/DD/YYYY format (same as ToolTip displays)
                        return `${mm}/${dd}/${yyyy}`;
                    }
                }
            }

            // If no rush option, calculate using standard_shipping_days from decorator vendor
            const decoratorId =
                item.main_new_product &&
                item.main_new_product.default_decorator_id
                    ? item.main_new_product.default_decorator_id
                    : null;

            if (
                decoratorId &&
                this.vendors_list &&
                this.vendors_list.length > 0
            ) {
                const vendor = this.vendors_list.find(
                    (v) => v.id === decoratorId
                );
                if (
                    vendor &&
                    vendor.standard_shipping_days !== null &&
                    vendor.standard_shipping_days !== undefined
                ) {
                    // Get holidays - use same source as ToolTip
                    let holidays = [];
                    if (
                        typeof window !== "undefined" &&
                        window.CartV3Component
                    ) {
                        holidays = window.CartV3Component.holidays || [];
                    }
                    // Fallback to this.holidays if window not available
                    if (holidays.length === 0) {
                        holidays = this.holidays || [];
                    }

                    // If holidays not loaded yet, return null (will recalculate once loaded)
                    if (holidays.length === 0) {
                        return null;
                    }

                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const estimatedDate =
                        this.calculateEstimatedDateWithHolidays(
                            today,
                            vendor.standard_shipping_days,
                            holidays
                        );
                    // Format date same as ToolTip - use local timezone methods to avoid UTC conversion
                    const localDate = new Date(
                        estimatedDate.getFullYear(),
                        estimatedDate.getMonth(),
                        estimatedDate.getDate()
                    );
                    const mm = String(localDate.getMonth() + 1).padStart(
                        2,
                        "0"
                    );
                    const dd = String(localDate.getDate()).padStart(2, "0");
                    const yyyy = localDate.getFullYear();
                    // Return in MM/DD/YYYY format (same as ToolTip displays)
                    return `${mm}/${dd}/${yyyy}`;
                }
            }

            // Same product different color (sub): use parent's date so both show Est. Ship Date on cart
            if (!_fromSibling && this.cart_items && this.cart_items.length > 0 && item && item.main_new_product && item.main_new_product.id) {
                const productId = item.main_new_product.id;
                const sibling = this.cart_items.find(
                    (i) => i !== item && i.main_new_product && i.main_new_product.id === productId
                );
                if (sibling) {
                    const parentDate = this.getEstimatedShippingDate(sibling, true);
                    if (parentDate) return parentDate;
                }
            }
            return null;
        },

        // Format estimated shipping date for display (avoid timezone issues)
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                // If dateString is already in YYYY-MM-DD format, parse it directly
                if (
                    typeof dateString === "string" &&
                    dateString.match(/^\d{4}-\d{2}-\d{2}$/)
                ) {
                    const [year, month, day] = dateString.split("-");
                    return `${month}/${day}/${year}`;
                }
                // Otherwise, parse as Date and use local timezone methods
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                // Use local timezone methods to avoid UTC conversion issues
                const localDate = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                );
                const mm = String(localDate.getMonth() + 1).padStart(2, "0");
                const dd = String(localDate.getDate()).padStart(2, "0");
                const yyyy = localDate.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        }
    }
};
</script>

<style>
.accordion_action {
    vertical-align: top !important;
    text-align: right !important;
    min-width: 90px !important;
}

.cart_icon_image {
    display: flex !important;
    align-items: center;
}

.cart_icon_image img {
    width: 16px;
    height: 16px;
}

.cart_table .table tbody tr td .cart_image .hover_search {
    right: 85px !important;
}

.delete_block {
    display: flex;
    justify-content: space-between;
}

.cart_page_vthree .item-image .standard_colors {
    margin-top: 2px !important;
    justify-content: left !important;
}

.cart_table .table tbody tr td .cart_image {
    margin-bottom: 20px !important;
}

.cart_page_vthree .cart_table {
    overflow: inherit;
}

/* .cart_page_vthree .cost-label {
        min-width: 80px;
    } */

.cart_page_vthree .cost-breakdown {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.cart_page_vthree .cost-item {
    gap: 130px;
}

.cart_page_vthree .cost-separator {
    width: 100%;
}

.cart_page_vthree.cart_page_vtwo .main_data .outer_head tr td.assembly_group_header_cell {
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: #121212;
    height: auto;
    padding: 0px !important;
}
.cart_table .table tbody tr td.assembly_group_header_cell .assembly_header_inner{
 background: #f7f7f7;
    padding: 17px 24px !important;
    border: 1px solid #F4F4F4 !important;

    background-color: #F4F4F4 !important;
}
.cart_table .table tbody tr .inner_tbody{
    border-top: 1px dashed #B6B6B666 !important;
}
.cart_table .table tbody tr .header_row .item-image,

.cart_table .table tbody tr .header_row .title_mobile,

.cart_table .table tbody tr .header_row .price_data_block{
    padding: 24px 16px !important;
}
.cart_page_vthree .cart_table .table tbody tr td.main_data{
    padding: 0px;
    
    border: none !important;
}
.cart_page_vthree .standard_colors {
        bottom: 10px !important;
}
.cart_page_vthree .cart_table .table tbody tr td.main_data .main_data_inner{
border: 1px solid hsla(0, 0%, 71%, 0.4) !important;
margin-top: 16px;
}
.cart_page_vthree .cart_table .table tbody tr td.price_data_block {
    padding: 16px 12px !important;
    max-width: 25% !important;
}

.cart_page_vthree .discount-value {
    color: #dc3545 !important;
}
.cart_page_vthree .cost-item.cost-total {
    margin: 0px !important;
}
.cart_page_vthree .cost-disocunt-row {
    padding-bottom: 10px !important;
    padding-top: 10px !important;
}

.cart_page_vthree .cart_table_custom_overflow {
    overflow-x: auto;
    overflow-y: hidden;
}
@media (max-width: 1200px) {
    .cart_page_vthree .cart_table .cart_table_custom_overflow .table {
        min-width: 1600px;
    }
    .cart_page_vthree .cart_table .table tbody tr td.price_data_block {
        min-width: 370px;
    }
}
.patch-tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}
.patch-tooltip-wrapper .info-icon-svg {
    margin-left: 4px;
    vertical-align: middle;
}
.patch-tooltip-content {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1050;
    min-width: 340px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    margin-top: 6px;
}
.patch-tooltip-content.is-visible {
    display: block;
}
.patch-tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #eee;
}
.patch-tooltip-header h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
}
.patch-tooltip-header .close-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    color: #999;
}
.patch-tooltip-body {
    padding: 8px 14px 12px;
}
.patch-breakdown-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}
.patch-breakdown-table th {
    text-align: left;
    padding: 4px 6px;
    border-bottom: 1px solid #eee;
    color: #666;
    font-weight: 600;
}
.patch-breakdown-table td {
    padding: 4px 6px;
    color: #333;
}
.patch-breakdown-table .patch-total-row td {
    border-top: 1px solid #ccc;
    padding-top: 6px;
}
.breadcrumb-section{
    margin-top: 22px;
}
.cart-preview-artworks-btn {
    display: block;
    height: 30px;
    padding: 0 9px;
    border: 1px solid #E87722;
    border-radius: 5px;
    background: #fff;
    color: #E87722;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    line-height: 1;
    transition: background 0.15s, color 0.15s;
    margin-bottom: 30px;
}
.cart-preview-artworks-btn:hover {
    background: #E87722;
    color: #fff;
}
.cart_page_vthree .inner_tbody tr td {
    padding-bottom: 24px !important;
}
.cart_page_vthree .inner_tbody tr:last-child td {
    padding-bottom: 32px !important;
}
.hours_info_block{
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-between;
}
.hours_info_block img {
    width: 100%;
    height: auto;
    object-fit: contain;
}
.hours_info_block_image{
    max-width:250px;
}
</style>

<!-- All cart_page_vthree styles have been moved to /public/maincss/scss/components/_cart.scss --> 
